// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%239aa5b5%27 d=%27M2.5 4.5 6 8l3.5-3.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio_dashboard .pos {
  color: #16a34a;
}

.portfolio_dashboard .neg {
  color: #dc2626;
}

.portfolio_dashboard strong.pos,
.portfolio_dashboard span.pos,
.portfolio_dashboard .portfolio_holding_card__stat_value.pos {
  color: #16a34a;
}

.portfolio_dashboard strong.neg,
.portfolio_dashboard span.neg,
.portfolio_dashboard .portfolio_holding_card__stat_value.neg {
  color: #dc2626;
}

.portfolio_dashboard__detail_kpis strong.pos,
.portfolio_stock_detail__metric strong.pos,
.portfolio_action_section .portfolio_dashboard__detail_kpis > span strong.pos,
.portfolio_action_plan__metrics strong.pos {
  color: #16a34a;
}

.portfolio_dashboard__detail_kpis strong.neg,
.portfolio_stock_detail__metric strong.neg,
.portfolio_action_section .portfolio_dashboard__detail_kpis > span strong.neg,
.portfolio_action_plan__metrics strong.neg {
  color: #dc2626;
}

.portfolio_analysis_row__val.pos {
  color: #16a34a;
}

.portfolio_analysis_row__val.neg {
  color: #dc2626;
}

.portfolio_dashboard {
  --dash-sidebar-w: 268px;
  --dash-main-bg: #fff8f4;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  background: var(--dash-main-bg);
  color: var(--text);
  overflow: hidden;
}

/* ── Premium sidebar (#002141) ─────────────────────────────────── */
.portfolio_dashboard__sidebar.sidebar_premium {
  --sidebar-bg: #002141;
  --sidebar-bg-soft: #001a33;
  --sidebar-text: #ffffff;
  --sidebar-muted: rgba(255, 255, 255, 0.72);
  --sidebar-border: rgba(255, 255, 255, 0.12);
  --sidebar-hover: rgba(255, 255, 255, 0.1);
  --sidebar-active-bg: rgba(255, 255, 255, 0.14);
  --sidebar-active-border: rgba(255, 255, 255, 0.22);
  --sidebar-accent: #e35834;

  width: var(--dash-sidebar-w);
  height: 100vh;
  max-height: 100vh;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: var(--sidebar-bg);
  border-right: 1px solid #001530;
  box-shadow: 4px 0 20px rgba(0, 33, 65, 0.35);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  overflow: hidden;
}

.sidebar_premium__brand {
  flex-shrink: 0;
  padding: 0;
  margin: 0;
  width: 100%;
  border-bottom: 1px solid var(--sidebar-border);
}

.sidebar_premium__logo {
  display: block;
  width: auto;
  max-width: 92%;
  max-height: 68px;
  height: auto;
  margin: 0 auto;
  padding: 14px 14px 12px;
  border-radius: 0;
  background: var(--sidebar-bg);
  box-shadow: none;
  object-fit: contain;
  box-sizing: border-box;
}

.sidebar_premium__nav {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 4px 10px 2px;
}

.sidebar_premium__nav_group + .sidebar_premium__nav_group {
  margin-top: 0;
}

.sidebar_premium__section {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--sidebar-muted);
  padding: 8px 10px 4px;
}

.sidebar_premium__section:first-child {
  padding-top: 2px;
}

.sidebar_premium__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 7px 10px;
  margin-bottom: 2px;
  border-radius: 10px;
  font-size: 14.5px;
  font-weight: 500;
  color: var(--sidebar-text);
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
  position: relative;
}

.sidebar_premium__item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) scaleY(0);
  width: 4px;
  height: 68%;
  border-radius: 0 4px 4px 0;
  background: var(--sidebar-accent);
  box-shadow: none;
  transition: transform 0.2s ease;
}

.sidebar_premium__item:hover {
  background: var(--sidebar-hover);
  color: #ffffff;
}

.sidebar_premium__item.is_active {
  background: var(--sidebar-active-bg);
  color: #ffffff;
  font-weight: 600;
  box-shadow: inset 0 0 0 1px var(--sidebar-active-border);
}

.sidebar_premium__item.is_active::before {
  transform: translateY(-50%) scaleY(1);
}

.sidebar_premium__item_left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.sidebar_nav__icon_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.1);
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.sidebar_nav__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sidebar-muted);
  transition: color 0.2s ease;
}

.sidebar_nav__icon svg {
  width: 20px;
  height: 20px;
}

.sidebar_premium__item:hover .sidebar_nav__icon_wrap {
  background: rgba(255, 255, 255, 0.18);
}

.sidebar_premium__item:hover .sidebar_nav__icon {
  color: #ffffff;
}

.sidebar_premium__item.is_active .sidebar_nav__icon_wrap {
  background: rgba(227, 88, 52, 0.45);
  box-shadow: 0 0 0 1px rgba(227, 88, 52, 0.55);
}

.sidebar_premium__item.is_active .sidebar_nav__icon {
  color: #ffffff;
}

.sidebar_premium__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar_premium__badge {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  min-width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  transition: background 0.2s ease, color 0.2s ease;
}

.sidebar_premium__badge.is_active {
  background: var(--sidebar-accent);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(227, 88, 52, 0.4);
}

.sidebar_premium__badge.is_count {
  background: transparent;
  color: rgba(255, 255, 255, 0.88);
  min-width: auto;
  padding: 0 4px;
}

.sidebar_premium__item.is_active .sidebar_premium__badge.is_count {
  color: #ffffff;
  font-weight: 800;
}

.sidebar_premium__badge.is_danger {
  background: rgba(127, 29, 29, 0.55);
  color: #ffffff;
}

.sidebar_premium__badge.is_success {
  background: rgba(20, 83, 45, 0.55);
  color: #ffffff;
}

.sidebar_premium__badge.is_muted {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

.sidebar_premium__footer {
  flex-shrink: 0;
  padding: 10px 10px 14px;
  border-top: 1px solid var(--sidebar-border);
  background: var(--sidebar-bg);
}

.sidebar_premium__logout {
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 10px 10px;
  border-radius: 10px;
  font-size: 14.5px;
  font-weight: 500;
  color: var(--sidebar-muted);
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease;
}

.sidebar_premium__logout:hover {
  background: var(--sidebar-hover);
  color: #ffffff;
}

.sidebar_premium__logout:hover .sidebar_nav__icon {
  color: #ffffff;
}

.sidebar_premium__foot {
  flex-shrink: 0;
  padding: 10px 10px 12px;
  border-top: 1px solid var(--sidebar-border);
  background: var(--sidebar-bg);
}

.sidebar_premium__foot_card {
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sidebar-bg-soft);
  border: 1px solid var(--sidebar-border);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.sidebar_premium__foot_lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sidebar-muted);
  margin-bottom: 6px;
}

.sidebar_premium__foot_val {
  font-size: 19px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.03em;
  line-height: 1.15;
}

.sidebar_premium__foot_sub {
  font-size: 11px;
  margin-top: 5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.sidebar_premium__foot_trend {
  font-size: 12px;
  line-height: 1;
}

.sidebar_premium__foot_sub.pos {
  color: #86efac;
}

.sidebar_premium__foot_sub.neg {
  color: #fca5a5;
}

.portfolio_dashboard__main {
  flex: 1 1;
  min-width: 0;
  margin-left: var(--dash-sidebar-w);
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  background: var(--dash-main-bg);
}

.portfolio_dashboard__header_fixed {
  flex-shrink: 0;
  z-index: 15;
  padding: 16px 20px 14px;
  background: var(--dash-main-bg);
  border-bottom: 1px solid rgba(227, 88, 52, 0.12);
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
}

.portfolio_dashboard__scroll {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 24px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(227, 88, 52, 0.35) transparent;
}

.portfolio_dashboard__topbar {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.portfolio_dashboard__title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin: 0;
  flex-shrink: 0;
  white-space: nowrap;
}

.portfolio_dashboard__title--theme {
  color: var(--theme, #f15623);
}

.portfolio_dashboard__search_wrap {
  flex: 1 1;
  min-width: 220px;
  max-width: 560px;
  position: relative;
  display: flex;
  align-items: center;
}

.portfolio_dashboard__search_icon {
  position: absolute;
  left: 14px;
  color: var(--faint);
  pointer-events: none;
}

.portfolio_dashboard__search {
  width: 100%;
  height: 42px;
  padding: 0 16px 0 42px;
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  color: var(--text);
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.portfolio_dashboard__search::placeholder {
  color: var(--faint);
}

.portfolio_dashboard__search:hover {
  border-color: var(--theme-border);
}

.portfolio_dashboard__search:focus {
  outline: none;
  border-color: var(--theme);
  box-shadow: 0 0 0 3px var(--theme-glow);
}

.portfolio_dashboard__search_dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 50;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.12);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 33, 65, 0.12);
  max-height: 320px;
  overflow-y: auto;
  padding: 6px;
}

.portfolio_dashboard__search_empty {
  padding: 14px 12px;
  font-size: 13px;
  color: #64748b;
  text-align: center;
}

.portfolio_dashboard__search_result {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.15s ease;
}

.portfolio_dashboard__search_result:hover,
.portfolio_dashboard__search_result:focus {
  outline: none;
  background: #fff8f4;
}

.portfolio_dashboard__search_result_main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  min-width: 0;
}

.portfolio_dashboard__search_result_name {
  font-size: 14px;
  font-weight: 700;
  color: #002141;
  line-height: 1.3;
}

.portfolio_dashboard__search_result_meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
}

.portfolio_dashboard__search_result_action {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: capitalize;
}

.portfolio_dashboard__search_result_section {
  font-size: 11px;
  font-weight: 700;
  color: #e35834;
}

.portfolio_dashboard__search_result_codes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #e35834;
}

.portfolio_dashboard__search_result_codes span {
  padding: 2px 8px;
  background: rgba(227, 88, 52, 0.08);
  border-radius: 4px;
}

.portfolio_dashboard__actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  margin-left: auto;
  align-items: center;
}

.portfolio_dashboard__btn {
  height: 42px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

.portfolio_dashboard__btn_secondary {
  border: 1px solid var(--border);
  background: #ffffff;
  color: var(--text);
}

.portfolio_dashboard__btn_secondary:hover {
  border-color: var(--theme-border);
  background: var(--theme-light);
  color: var(--theme);
}

.portfolio_dashboard__btn_primary {
  border: 1px solid var(--theme);
  background: var(--theme);
  color: #ffffff;
  box-shadow: 0 4px 14px var(--theme-glow);
}

.portfolio_dashboard__btn_primary:hover {
  background: var(--theme-hover);
  border-color: var(--theme-hover);
}

.portfolio_dashboard__kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  flex-shrink: 0;
}

.portfolio_dashboard__kpis--top {
  grid-template-columns: repeat(4, 1fr);
}

.portfolio_overview__kpis {
  grid-template-columns: repeat(3, 1fr);
}

.portfolio_dashboard__kpi {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 14px 16px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}

.portfolio_dashboard__kpi.theme {
  background: #ffedd5;
  border-color: rgba(234, 88, 12, 0.28);
}

.portfolio_dashboard__kpi.theme .portfolio_dashboard__kpi_lbl {
  color: #c2410c;
}

.portfolio_dashboard__kpi.theme .portfolio_dashboard__kpi_val {
  color: #9a3412;
}

.portfolio_dashboard__kpi.theme .portfolio_dashboard__kpi_sub {
  color: #b45309;
}

.portfolio_dashboard__kpi.green {
  background: #bbf7d0;
  border-color: rgba(22, 163, 74, 0.3);
}

.portfolio_dashboard__kpi.green .portfolio_dashboard__kpi_lbl {
  color: #166534;
}

.portfolio_dashboard__kpi.green .portfolio_dashboard__kpi_val {
  color: #14532d;
}

.portfolio_dashboard__kpi.green .portfolio_dashboard__kpi_sub {
  color: #15803d;
}

.portfolio_dashboard__kpi.emerald {
  background: #a7f3d0;
  border-color: rgba(5, 150, 105, 0.32);
}

.portfolio_dashboard__kpi.emerald .portfolio_dashboard__kpi_lbl {
  color: #047857;
}

.portfolio_dashboard__kpi.red {
  background: #fecaca;
  border-color: rgba(220, 38, 38, 0.28);
}

.portfolio_dashboard__kpi.orange {
  background: #fde68a;
  border-color: rgba(217, 119, 6, 0.3);
}

.portfolio_dashboard__kpi.orange .portfolio_dashboard__kpi_lbl {
  color: #b45309;
}

.portfolio_dashboard__kpi.orange .portfolio_dashboard__kpi_val {
  color: #92400e;
}

.portfolio_dashboard__kpi.blue {
  background: #bfdbfe;
  border-color: rgba(37, 99, 235, 0.3);
}

.portfolio_dashboard__kpi.blue .portfolio_dashboard__kpi_lbl {
  color: #1d4ed8;
}

.portfolio_dashboard__kpi.blue .portfolio_dashboard__kpi_val {
  color: #1e3a8a;
}

.portfolio_dashboard__kpi.purple {
  background: #ddd6fe;
  border-color: rgba(124, 58, 237, 0.28);
}

.portfolio_dashboard__kpi.purple .portfolio_dashboard__kpi_lbl {
  color: #6d28d9;
}

.portfolio_dashboard__kpi.purple .portfolio_dashboard__kpi_sub {
  color: #7c3aed;
}

.portfolio_dashboard__kpi.slate {
  background: #e2e8f0;
  border-color: rgba(71, 85, 105, 0.28);
}

.portfolio_dashboard__kpi.slate .portfolio_dashboard__kpi_lbl {
  color: #475569;
}

.portfolio_dashboard__kpi.slate .portfolio_dashboard__kpi_val {
  color: #1e293b;
}

.portfolio_dashboard__kpi_lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--faint);
}

.portfolio_dashboard__kpi_val {
  font-size: 24px;
  font-weight: 800;
  margin: 6px 0 2px;
  letter-spacing: -0.02em;
}

.portfolio_dashboard__kpi_sub {
  font-size: 12px;
  color: var(--muted);
}

.portfolio_dashboard__kpi_sub.pos {
  color: var(--acc);
  font-weight: 600;
}

.portfolio_dashboard__kpi_sub.neg {
  color: var(--red);
  font-weight: 600;
}

.portfolio_dashboard__split {
  display: flex;
  flex-direction: column;
  flex: none;
  min-height: auto;
}

.portfolio_dashboard__stocks {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
}

.portfolio_dashboard__stocks_head {
  padding: 12px 14px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--faint);
  border-bottom: 1px solid var(--border);
}

.portfolio_dashboard__stocks_list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}

.portfolio_dashboard__stock_row {
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 6px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}

.portfolio_dashboard__stock_row:hover {
  background: var(--theme-light);
  border-color: var(--theme-border);
}

.portfolio_dashboard__stock_row.active {
  background: #fff;
  border-color: var(--theme);
  box-shadow: inset -3px 0 0 var(--theme), 0 4px 12px var(--theme-glow);
}

.portfolio_dashboard__stock_top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
}

.portfolio_dashboard__stock_code {
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
}

.portfolio_dashboard__stock_name {
  font-size: 11px;
  color: var(--muted);
  margin-top: 2px;
  line-height: 1.3;
}

.portfolio_dashboard__badge {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
}

.badge_acc {
  background: var(--acc-bg);
  color: var(--acc);
}

.badge_hold {
  background: #eff6ff;
  color: #2563eb;
}

.badge_exit,
.badge_trim {
  background: #fff7ed;
  color: #ea580c;
}

.badge_cut {
  background: #fef2f2;
  color: var(--red);
}

.badge_muted {
  background: #f1f5f9;
  color: var(--muted);
}

.portfolio_dashboard__stock_stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 10px;
  font-size: 11px;
  color: var(--muted);
}

.portfolio_dashboard__stock_stats strong {
  color: var(--text);
  font-weight: 700;
}

.portfolio_dashboard__detail {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  min-height: min-content;
  flex: 1 0 auto;
  overflow: visible;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
}

.portfolio_dashboard__detail--overview {
  overflow: visible;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.portfolio_dashboard.is_dashboard_page {
  --dash-main-bg: #f3f4f6;
}

.portfolio_dashboard.is_dashboard_page .portfolio_dashboard__header_fixed.is_dashboard_header {
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
}

.portfolio_dashboard.is_dashboard_page .portfolio_dashboard__topbar.is_dashboard_topbar {
  justify-content: flex-end;
}

.portfolio_overview {
  padding: 20px 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Dashboard mock layout (portfolio overview page) ─────────────── */
.portfolio_overview--mock {
  gap: 18px;
  padding: 8px 24px 28px;
  background: transparent;
  max-width: 1280px;
}

.portfolio_overview__page_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.portfolio_overview__page_title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #111827;
}

.portfolio_overview__updated {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.portfolio_overview__updated svg {
  width: 16px;
  height: 16px;
  color: #94a3b8;
}

.portfolio_overview__summary_kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  gap: 16px;
}

.portfolio_dash_summary_card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 18px 18px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 132px;
  min-width: 0;
  overflow: visible;
}

.portfolio_dash_summary_card.is_value {
  background: linear-gradient(160deg, #ffffff 0%, #f0f7ff 100%);
  border-color: #dbeafe;
}

.portfolio_dash_summary_card.is_score {
  background: linear-gradient(160deg, #ffffff 0%, #fff7ed 100%);
  border-color: #ffedd5;
}

.portfolio_dash_summary_card.is_returns {
  background: linear-gradient(160deg, #ffffff 0%, #f0fdf4 100%);
  border-color: #dcfce7;
}

.portfolio_dash_summary_card.is_invested {
  background: linear-gradient(160deg, #ffffff 0%, #ecfdf5 100%);
  border-color: #d1fae5;
}

.portfolio_dash_summary_card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.portfolio_dash_summary_card__metrics {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  width: 100%;
}

.portfolio_dash_summary_card__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
}

.portfolio_dash_summary_card__icon svg {
  width: 18px;
  height: 18px;
  display: block;
}

.portfolio_dash_summary_card__icon.is_value {
  background: linear-gradient(145deg, #3b82f6, #2563eb);
  box-shadow: 0 0 0 6px rgba(59, 130, 246, 0.12);
}

.portfolio_dash_summary_card__icon.is_score {
  background: linear-gradient(145deg, #f97316, #ea580c);
  box-shadow: 0 0 0 6px rgba(249, 115, 22, 0.12);
}

.portfolio_dash_summary_card__icon.is_returns {
  background: linear-gradient(145deg, #22c55e, #16a34a);
  box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.12);
}

.portfolio_dash_summary_card__icon.is_invested {
  background: linear-gradient(145deg, #10b981, #059669);
  box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.12);
}

.portfolio_dash_summary_card__lbl {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-transform: none;
  color: #374151;
  line-height: 1.3;
  flex: 1 1;
  min-width: 0;
}

.portfolio_dash_summary_card__val {
  font-size: clamp(24px, 2.4vw, 32px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
  word-break: keep-all;
  overflow: visible;
  width: 100%;
}

.portfolio_dash_summary_card__val--score {
  display: flex;
  align-items: baseline;
  gap: 3px;
  flex-wrap: nowrap;
}

.portfolio_dash_summary_card__val_main {
  font-size: clamp(26px, 2.5vw, 34px);
  font-weight: 800;
  line-height: 1;
  color: #0f172a;
}

.portfolio_dash_summary_card__val_suffix {
  font-size: 17px;
  font-weight: 600;
  color: #9ca3af;
  line-height: 1;
}

.portfolio_dash_summary_card__val.is_return {
  font-size: clamp(26px, 2.5vw, 34px);
}

.portfolio_dash_summary_card__val.is_return.pos {
  color: #16a34a;
}

.portfolio_dash_summary_card__val.is_return.neg {
  color: #dc2626;
}

.portfolio_dash_summary_card__extra {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.portfolio_dash_summary_card__extra.pos {
  color: #16a34a;
}

.portfolio_dash_summary_card__extra.neg {
  color: #dc2626;
}

.portfolio_dash_summary_card__tag {
  font-size: 14px;
  font-weight: 700;
}

.portfolio_dash_summary_card__tag.is_good {
  color: #22c55e;
}

.portfolio_dash_summary_card__tag.is_fair {
  color: #f59e0b;
}

.portfolio_dash_summary_card__tag.is_attention {
  color: #ef4444;
}

.portfolio_dash_summary_card__bar {
  height: 5px;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
  margin-top: 6px;
}

.portfolio_dash_summary_card__bar_fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #f97316 0%, #fdba74 55%, #e5e7eb 100%);
}

.portfolio_dash_summary_card__bar_fill.is_good {
  background: linear-gradient(90deg, #22c55e 0%, #86efac 55%, #e5e7eb 100%);
}

.portfolio_overview__analytics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  align-items: stretch;
}

.portfolio_overview__analytics--split {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.portfolio_overview__analytics_top {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(0, 2fr);
  gap: 14px;
  align-items: stretch;
}

.portfolio_overview__analytics_bottom {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: stretch;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel {
  min-height: 0;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--score,
.portfolio_overview__analytics--compact .portfolio_dash_panel--sector,
.portfolio_overview__analytics--compact .portfolio_dash_panel--meter {
  min-height: 0;
}

.portfolio_dash_panel {
  padding: 20px 22px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  min-height: 280px;
  display: flex;
  flex-direction: column;
}

.portfolio_dash_panel__head_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.65);
}

.portfolio_dash_panel__head_row .portfolio_dash_panel__title {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 12px;
  letter-spacing: 0.07em;
  white-space: nowrap;
}

.portfolio_dash_panel__head_stack {
  min-width: 0;
  flex: 1 1;
}

.portfolio_dash_panel__hint_inline {
  margin: 4px 0 0;
  font-size: 11px;
  line-height: 1.35;
  color: #64748b;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.portfolio_dash_panel__title {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #111827;
}

.portfolio_dash_panel__hint {
  margin: -8px 0 10px;
  font-size: 12px;
  line-height: 1.45;
  color: #6b7280;
}

.portfolio_dash_panel--score {
  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 48%, #fff9f5 100%);
  border: 1px solid #e8ecf1;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.06);
  min-height: 300px;
  padding: 0;
  overflow: visible;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--score {
  min-height: 0;
}

.portfolio_dash_panel--score .portfolio_dash_panel__title {
  margin: 0;
  padding: 18px 22px 14px;
  text-align: center;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.08em;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--score .portfolio_dash_panel__title {
  padding: 12px 14px 10px;
  font-size: 12px;
}

.portfolio_dash_panel--score_body {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
  padding: 20px 18px 24px;
  container-type: inline-size;
  container-name: portfolio-score-panel;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--score_body {
  padding: 10px 12px 14px;
}

.portfolio_dash_panel--score_inner {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  justify-content: center;
  gap: 16px 20px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  min-width: 0;
}

.portfolio_dash_donut_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  min-width: 0;
  max-width: 100%;
}

.portfolio_overview__analytics_top .portfolio_dash_donut_wrap {
  max-width: 168px;
}

.portfolio_overview__analytics_top .portfolio_dash_donut {
  width: 160px;
  height: 160px;
}

.portfolio_overview__analytics_top .portfolio_dash_donut__svg {
  width: 100%;
  height: 100%;
}

.portfolio_overview__analytics_top .portfolio_dash_donut__val {
  font-size: 26px;
}

.portfolio_overview__analytics_top .portfolio_dash_donut__of {
  font-size: 13px;
}

.portfolio_overview__analytics_top .portfolio_dash_donut__caption {
  font-size: 12px;
  max-width: 160px;
}

.portfolio_dash_donut {
  position: relative;
  width: 188px;
  height: 188px;
  flex-shrink: 0;
  filter: drop-shadow(0 4px 14px rgba(249, 115, 22, 0.14));
}

.portfolio_overview__analytics--compact .portfolio_dash_donut {
  width: 132px;
  height: 132px;
  filter: drop-shadow(0 2px 8px rgba(249, 115, 22, 0.12));
}

.portfolio_dash_donut__svg {
  width: 188px;
  height: 188px;
  display: block;
}

.portfolio_overview__analytics--compact .portfolio_dash_donut__svg {
  width: 132px;
  height: 132px;
}

.portfolio_overview__analytics--compact .portfolio_dash_donut__val {
  font-size: 22px;
}

.portfolio_overview__analytics--compact .portfolio_dash_donut__of {
  font-size: 12px;
}


.portfolio_dash_donut__track {
  stroke: #e5e7eb;
}

.portfolio_dash_donut__fill {
  stroke: #f97316;
  stroke-linecap: round;
}

.portfolio_dash_donut__fill.is_good {
  stroke: #22c55e;
}

.portfolio_dash_donut__fill.is_fair {
  stroke: #f97316;
}

.portfolio_dash_donut__fill.is_attention {
  stroke: #ef4444;
}

.portfolio_dash_donut__center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;
  padding: 0 8px;
  box-sizing: border-box;
}

.portfolio_dash_donut__val {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.05;
  color: #0f172a;
  letter-spacing: -0.03em;
}

.portfolio_dash_donut__of {
  font-size: 15px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_dash_donut__caption {
  margin: 8px 0 0;
  padding: 0 4px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.02em;
  text-align: center;
  text-wrap: balance;
  max-width: 188px;
}

.portfolio_dash_donut__caption.is_good {
  color: #22c55e;
}

.portfolio_dash_donut__caption.is_fair {
  color: #f59e0b;
}

.portfolio_dash_donut__caption.is_attention {
  color: #ef4444;
}

.portfolio_overview__analytics--compact .portfolio_dash_donut__caption {
  margin-top: 6px;
  font-size: 11px;
  max-width: 132px;
}

.portfolio_dash_panel--score .portfolio_dash_score_metrics {
  min-width: 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--score_inner {
  gap: 12px 14px;
}

.portfolio_overview__analytics--compact .portfolio_overview__analytics_top .portfolio_dash_donut {
  width: 132px;
  height: 132px;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--score .portfolio_dash_score_metrics {
  gap: 6px;
}

.portfolio_dash_score_metric {
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.portfolio_overview__analytics--compact .portfolio_dash_score_metric {
  padding: 6px 8px;
  border-radius: 8px;
}

.portfolio_overview__analytics--compact .portfolio_dash_score_metric__head {
  margin-bottom: 5px;
  font-size: 11px;
}

.portfolio_overview__analytics--compact .portfolio_dash_score_metric__head strong {
  font-size: 11px;
}

.portfolio_overview__analytics--compact .portfolio_dash_score_metric__track {
  height: 6px;
}

.portfolio_dash_score_metric__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
}

.portfolio_dash_score_metric__head span {
  min-width: 0;
  flex: 1 1 auto;
  line-height: 1.3;
}

.portfolio_dash_score_metric__head strong {
  flex-shrink: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.portfolio_dash_score_metric__track {
  height: 8px;
  border-radius: 999px;
  background: #e8ecf0;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
}

.portfolio_dash_score_metric__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #4ade80 0%, #22c55e 55%, #16a34a 100%);
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.25);
}

.portfolio_dash_panel--sector {
  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 48%, #f5f9ff 100%);
  border: 1px solid #e8ecf1;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.06);
  min-height: 300px;
  padding: 0;
  overflow: hidden;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--sector {
  min-height: 0;
}

.portfolio_dash_panel--sector .portfolio_dash_panel__title {
  margin: 0;
  padding: 18px 22px 10px;
  text-align: center;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.08em;
}

.portfolio_dash_panel__head_row--sector {
  align-items: flex-start;
}

.portfolio_dash_panel__head_row--sector .portfolio_dash_view_more {
  margin: 2px 0 0;
  flex-shrink: 0;
  font-size: 12px;
}

.portfolio_dash_panel--sector .portfolio_dash_panel__hint {
  margin: 0;
  padding: 10px 22px 0;
  text-align: center;
  font-size: 12px;
  color: #6b7280;
}

.portfolio_dash_panel--sector_body {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 18px 12px;
  width: 100%;
  min-height: 0;
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--sector_body {
  padding: 8px 10px 10px;
}

.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_dash_panel--sector_body {
  padding: 10px 16px 12px;
}

.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_chart--donut {
  gap: 20px;
  max-width: none;
  width: 100%;
  justify-content: flex-start;
}

.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_donut_svg {
  width: 120px;
  height: 120px;
}

.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_legend {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 4px;
  max-width: none;
}

.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_legend li {
  font-size: 12px;
}

.portfolio_overview__sector_chart--donut {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

.portfolio_overview__sector_donut_wrap {
  flex-shrink: 0;
  filter: drop-shadow(0 4px 14px rgba(59, 130, 246, 0.12));
}

.portfolio_overview__sector_donut_svg {
  width: 156px;
  height: 156px;
  display: block;
}

.portfolio_overview__analytics--compact .portfolio_overview__sector_chart--donut {
  gap: 10px;
  max-width: 100%;
}

.portfolio_overview__analytics--compact .portfolio_overview__sector_donut_svg {
  width: 108px;
  height: 108px;
}

.portfolio_overview__analytics--compact .portfolio_overview__sector_donut_center {
  font-size: 16px;
}

.portfolio_overview__analytics--compact .portfolio_overview__sector_legend {
  gap: 4px;
  max-width: none;
}

.portfolio_overview__analytics--compact .portfolio_overview__sector_legend li {
  font-size: 11px;
  padding: 2px 0;
}

.portfolio_overview__sector_legend_more {
  font-size: 11px;
  font-weight: 700;
  color: #2563eb;
  padding-top: 2px;
  list-style: none;
}

.portfolio_overview__sector_donut_hole {
  fill: #ffffff;
}

.portfolio_overview__sector_donut_center {
  font-size: 22px;
  font-weight: 800;
  fill: #0f172a;
  letter-spacing: -0.02em;
}

.portfolio_overview--mock .portfolio_overview__sector_legend {
  flex: 1 1;
  min-width: 0;
  max-width: 220px;
  gap: 9px;
}

.portfolio_overview--mock .portfolio_overview__sector_legend li {
  font-size: 12px;
  padding: 4px 0;
}

.portfolio_overview--mock .portfolio_overview__sector_legend_pct {
  font-weight: 800;
  color: #0f172a;
}

.portfolio_dash_panel--sector .portfolio_dash_view_more {
  margin: 0 22px 16px auto;
  padding-top: 4px;
}

.portfolio_dash_view_more {
  margin-top: auto;
  margin-left: auto;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-family: inherit;
}

.portfolio_dash_view_more:hover {
  text-decoration: underline;
}

.portfolio_dash_panel--meter {
  width: 100%;
  padding: 0;
  overflow: hidden;
  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 48%, #f5f9ff 100%);
  border: 1px solid #e8ecf1;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.06);
}

.portfolio_overview__analytics--compact .portfolio_dash_panel--meter {
  min-height: 0;
}

.portfolio_dash_panel--meter .portfolio_dash_panel__title {
  margin: 0;
  padding: 12px 14px 10px;
  text-align: center;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.08em;
  font-size: 12px;
}

.portfolio_dash_panel--meter_body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 1;
  width: 100%;
  padding: 10px 12px 12px;
  box-sizing: border-box;
}

.portfolio_dash_risk_split {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 20px 18px;
}

.portfolio_dash_panel--meter .portfolio_dash_risk_split .portfolio_dash_speedometer {
  flex: 0 0 auto;
  max-width: 280px;
  min-width: 0;
  gap: 6px;
  padding: 0 4px 2px;
}

.portfolio_dash_risk_side {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: center;
  padding: 4px 0;
}

.portfolio_dash_risk_badge {
  align-self: flex-start;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1d4ed8;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid rgba(37, 99, 235, 0.2);
}

.portfolio_dash_risk_badge.is_breadth {
  color: #9a3412;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border-color: rgba(234, 88, 12, 0.25);
}

.portfolio_dash_risk_badge.is_risk_low {
  color: #166534;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-color: rgba(22, 163, 74, 0.28);
}

.portfolio_dash_risk_badge.is_risk_moderate {
  color: #9a3412;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-color: rgba(217, 119, 6, 0.28);
}

.portfolio_dash_risk_badge.is_risk_high {
  color: #991b1b;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: rgba(220, 38, 38, 0.35);
}

.portfolio_dash_risk_blurb {
  margin: 0;
  font-size: 11px;
  line-height: 1.45;
  color: #475569;
  white-space: normal;
  overflow: visible;
}

.portfolio_dash_risk_chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.portfolio_dash_risk_chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.portfolio_dash_risk_chip strong {
  font-size: 11px;
  font-weight: 800;
  color: #0f172a;
}

.portfolio_dash_risk_chip.is_pos {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}

.portfolio_dash_risk_chip.is_pos strong {
  color: #15803d;
}

.portfolio_dash_risk_chip.is_neg {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.portfolio_dash_risk_chip.is_neg strong {
  color: #dc2626;
}

.portfolio_dash_risk_chip.is_high_risk {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #991b1b;
}

.portfolio_dash_risk_chip.is_high_risk strong {
  color: #dc2626;
  font-weight: 800;
}

.portfolio_dash_panel--meter .portfolio_dash_speedometer__svg {
  max-width: 280px;
  min-width: 240px;
  width: 100%;
}

.portfolio_overview__analytics_bottom .portfolio_dash_risk_split {
  gap: 24px;
  padding: 16px 22px 20px;
}

.portfolio_overview__analytics_bottom .portfolio_dash_panel--meter .portfolio_dash_speedometer__svg {
  max-width: 300px;
  min-width: 260px;
}

.portfolio_overview__analytics_bottom .portfolio_dash_panel--meter .portfolio_dash_speedometer__val {
  font-size: 26px;
}

.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__val {
  font-size: 17px;
  margin-top: 0;
}

.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__svg {
  max-width: 150px;
  min-width: 0;
}

.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__tick {
  font-size: 9px;
}

.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__extreme {
  font-size: 7px;
}

.portfolio_dash_speedometer {
  width: 100%;
  max-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.portfolio_dash_speedometer__hint {
  margin: 6px 0 0;
  max-width: 200px;
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  text-align: center;
  line-height: 1.4;
}

.portfolio_dash_speedometer__title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  line-height: 1.2;
}

.portfolio_dash_speedometer__svg {
  width: 100%;
  max-width: 280px;
  min-width: 220px;
  height: auto;
  display: block;
}

.portfolio_dash_speedometer__tick {
  font-size: 10px;
  font-weight: 700;
  fill: #475569;
}

.portfolio_dash_speedometer.is_percent_scale .portfolio_dash_speedometer__tick {
  font-size: 9px;
}

.portfolio_dash_speedometer__extreme {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.portfolio_dash_speedometer__extreme.is_low {
  fill: #dc2626;
}

.portfolio_dash_speedometer__extreme.is_high {
  fill: #16a34a;
}

.portfolio_dash_speedometer__hub {
  fill: #facc15;
  stroke: #ffffff;
  stroke-width: 2;
}

.portfolio_dash_speedometer__needle {
  stroke: #facc15;
  stroke-width: 3;
  stroke-linecap: round;
}

.portfolio_dash_speedometer.is_risk_gauge .portfolio_dash_speedometer__needle {
  stroke: #002141;
}

.portfolio_dash_speedometer__val {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.15;
  color: #111827;
  letter-spacing: -0.02em;
  text-align: center;
  margin: 4px 0 0;
}

.portfolio_dash_panel--meter .portfolio_dash_speedometer__val {
  margin-top: 6px;
}

.portfolio_overview__chart_section {
  width: 100%;
}

.portfolio_dash_panel--chart {
  padding: 0;
  overflow: hidden;
  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 50%, #f5f9ff 100%);
  border: 1px solid #e8ecf1;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.06);
}

.portfolio_overview__chart_head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.75);
}

.portfolio_overview__chart_head_text {
  min-width: 0;
  flex: 1 1;
}

.portfolio_overview__chart_title {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0f172a;
  line-height: 1.35;
}

.portfolio_overview__chart_sub {
  margin: 8px 0 0;
  padding: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #64748b;
  max-width: 36rem;
}

.portfolio_overview__chart_body {
  padding: 12px 16px 16px;
}

.portfolio_overview__chart_body .portfolio_chart.is_compact.is_premium {
  width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
}

.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin: 0 0 12px;
  padding: 0 4px;
}

.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend_item {
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #334155;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend_item.is_stock {
  color: #1d4ed8;
  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
  border-color: rgba(37, 99, 235, 0.22);
}

.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend_item.is_nifty {
  color: #047857;
  background: linear-gradient(180deg, #ecfdf5 0%, #ffffff 100%);
  border-color: rgba(5, 150, 105, 0.2);
}

.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__plot {
  width: 100%;
  min-height: 220px;
  border-radius: 14px;
  background: linear-gradient(180deg, #fafbfd 0%, #ffffff 42%, #f8fafc 100%);
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
  overflow: visible;
}

.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__svg {
  width: 100%;
  height: 100%;
  min-height: 220px;
  display: block;
}

.portfolio_overview_chart_alpha {
  flex-shrink: 0;
  margin-top: 2px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.portfolio_overview_chart_alpha.pos {
  color: #15803d;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.portfolio_overview_chart_alpha.neg {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fecaca;
}

.portfolio_chart--bars .portfolio_chart__svg {
  width: 100%;
  max-width: 560px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.portfolio_overview_bar.is_portfolio {
  fill: #3b82f6;
}

.portfolio_overview_bar.is_nifty {
  fill: #94a3b8;
}

.portfolio_overview_bar.is_alpha {
  fill: #8b5cf6;
}

.portfolio_overview_bar.is_neg {
  opacity: 0.85;
}

.portfolio_overview_bar__val {
  font-size: 11px;
  font-weight: 700;
  fill: #0f172a;
}

.portfolio_dash_section_title {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #111827;
}

.portfolio_dash_action_pills {
  background: transparent;
}

.portfolio_dash_action_pills__row {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 14px;
}

.portfolio_dash_action_pill {
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.portfolio_dash_action_pill__title {
  font-size: 13px;
  font-weight: 700;
}

.portfolio_dash_action_pill__count {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.9;
}

.portfolio_dash_action_pill__count strong {
  font-size: 22px;
  font-weight: 700;
  margin-right: 4px;
}

.portfolio_dash_action_pill.is_avg_up {
  background: #dcfce7;
  border-color: #86efac;
  color: #166534;
}

.portfolio_dash_action_pill.is_avg_down {
  background: #ffedd5;
  border-color: #fdba74;
  color: #c2410c;
}

.portfolio_dash_action_pill.is_hold {
  background: #dbeafe;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.portfolio_dash_action_pill.is_profit {
  background: #fef9c3;
  border-color: #fde047;
  color: #a16207;
}

.portfolio_dash_action_pill.is_cut_loss {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #b91c1c;
}

.portfolio_dash_action_pill.is_exit {
  background: #ede9fe;
  border-color: #c4b5fd;
  color: #6d28d9;
}

.portfolio_dash_badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 5px 10px;
  border-radius: 6px;
  white-space: nowrap;
}

.portfolio_dash_badge.is_avg_up {
  background: #dcfce7;
  color: #166534;
}

.portfolio_dash_badge.is_avg_down {
  background: #ffedd5;
  color: #c2410c;
}

.portfolio_dash_badge.is_hold {
  background: #dbeafe;
  color: #1d4ed8;
}

.portfolio_dash_badge.is_profit {
  background: #fef9c3;
  color: #a16207;
}

.portfolio_dash_badge.is_cut_loss {
  background: #fee2e2;
  color: #b91c1c;
}

.portfolio_dash_badge.is_exit {
  background: #ede9fe;
  color: #6d28d9;
}

.portfolio_dash_badge.is_buy {
  background: #ecfdf5;
  color: #15803d;
}

.portfolio_dash_badge.is_muted {
  background: #f3f4f6;
  color: #6b7280;
}

.portfolio_dash_stocks_table {
  padding: 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.portfolio_dash_stocks_table .portfolio_dash_section_title {
  padding: 18px 20px 0;
}

.portfolio_dash_stocks_table__wrap {
  overflow-x: auto;
  padding: 0 20px 18px;
}

.portfolio_dash_stocks_table__grid {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.portfolio_dash_stocks_table__grid th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
  padding: 12px 10px;
  border-bottom: 1px solid #e2e8f0;
}

.portfolio_dash_stocks_table__grid td {
  padding: 14px 10px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  color: #334155;
}

.portfolio_dash_stocks_table__stock {
  font-weight: 600;
  color: #111827;
}

.portfolio_dash_stocks_table__price {
  font-weight: 600;
  color: #111827;
}

.portfolio_dash_stocks_table__chg {
  font-weight: 700;
}

.portfolio_dash_stocks_table__reason {
  max-width: 360px;
  line-height: 1.5;
  color: #6b7280;
  font-size: 12px;
}

/* Narrow score panel: stack donut + metrics so bars never clip */
@container portfolio-score-panel (max-width: 460px) {
  .portfolio_dash_panel--score_inner {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 16px;
  }

  .portfolio_dash_panel--score .portfolio_dash_score_metrics {
    width: 100%;
    max-width: 340px;
  }
}

@media (max-width: 1320px) {
  .portfolio_overview__analytics_top {
    grid-template-columns: 1fr;
  }

  .portfolio_dash_panel--score_inner {
    grid-template-columns: auto minmax(0, 1fr);
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 1200px) {
  .portfolio_overview__analytics {
    grid-template-columns: 1fr;
  }

  .portfolio_overview__analytics_top {
    grid-template-columns: 1fr;
  }

  .portfolio_overview__analytics_bottom {
    grid-template-columns: 1fr;
  }

  .portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_legend {
    grid-template-columns: 1fr;
  }

  .portfolio_dash_panel--meter .portfolio_dash_speedometer__svg,
  .portfolio_overview__analytics_bottom .portfolio_dash_panel--meter .portfolio_dash_speedometer__svg {
    min-width: 0;
    max-width: 100%;
  }

  .portfolio_dash_panel--meter .portfolio_dash_risk_split .portfolio_dash_speedometer {
    flex: 0 0 auto;
    min-width: 0;
    max-width: 100%;
  }

  .portfolio_dash_action_pills__row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .portfolio_overview__summary_kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .portfolio_dash_summary_card__val,
  .portfolio_dash_summary_card__val_main {
    font-size: 26px;
  }
}

@media (max-width: 900px) {
  .portfolio_overview__summary_kpis {
    grid-template-columns: 1fr;
  }

  .portfolio_dash_action_pills__row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .portfolio_dash_panel--score_inner {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 18px;
    max-width: none;
  }

  .portfolio_dash_panel--score .portfolio_dash_score_metrics {
    max-width: 360px;
    width: 100%;
  }
}

.portfolio_overview__head {
  display: grid;
  grid-template-areas:
    "title title"
    "chips meta";
  grid-template-columns: 1fr auto;
  column-gap: 14px;
  row-gap: 10px;
  align-items: center;
}

.portfolio_overview__head_meta {
  grid-area: meta;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.portfolio_overview__title {
  grid-area: title;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.02em;
  color: #002141;
}

.portfolio_overview__stats_highlight {
  grid-area: chips;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.portfolio_overview__stat_chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.1);
  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.06);
}

.portfolio_overview__stat_chip_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: #e35834;
  color: #ffffff;
  flex-shrink: 0;
}

.portfolio_overview__stat_chip_icon svg {
  width: 14px;
  height: 14px;
}

.portfolio_overview__stat_chip_val {
  font-size: 17px;
  font-weight: 700;
  color: #002141;
  line-height: 1;
  letter-spacing: -0.02em;
}

.portfolio_overview__stat_chip_lbl {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  text-transform: lowercase;
}

.portfolio_overview__rating {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.1);
  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.06);
  flex-shrink: 0;
  width: auto;
}

.portfolio_overview__rating_lbl {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
}

.portfolio_overview__rating_stars {
  display: flex;
  align-items: center;
  gap: 1px;
}

.portfolio_overview__rating_star {
  display: flex;
  line-height: 0;
}

.portfolio_overview__rating_star_svg {
  width: 14px;
  height: 14px;
  display: block;
}

.portfolio_overview__rating_star_empty {
  fill: #e2e8f0;
}

.portfolio_overview__rating_star_filled {
  fill: #f59e0b;
}

.portfolio_overview__rating.is_high .portfolio_overview__rating_star_filled {
  fill: #16a34a;
}

.portfolio_overview__rating.is_mid .portfolio_overview__rating_star_filled {
  fill: #d97706;
}

.portfolio_overview__rating.is_low .portfolio_overview__rating_star_filled {
  fill: #ea580c;
}

.portfolio_overview__rating.is_muted .portfolio_overview__rating_star_filled {
  fill: #cbd5e1;
}

.portfolio_overview__rating_val {
  font-size: 17px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: #002141;
}

.portfolio_overview__rating_of {
  font-size: 10px;
  font-weight: 500;
  color: #94a3b8;
}

.portfolio_overview__rating.is_high .portfolio_overview__rating_val {
  color: #15803d;
}

.portfolio_overview__rating.is_mid .portfolio_overview__rating_val {
  color: #a16207;
}

.portfolio_overview__rating.is_low .portfolio_overview__rating_val {
  color: #c2410c;
}

.portfolio_overview__rating.is_muted .portfolio_overview__rating_val {
  color: #94a3b8;
}

.portfolio_overview__highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.portfolio_overview__action_graphic {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.05);
}

.portfolio_overview__action_graphic.is_reduce {
  background: linear-gradient(135deg, #fff1eb 0%, #ffe8dc 45%, #ffffff 100%);
  border-color: rgba(227, 88, 52, 0.35);
}

.portfolio_overview__action_graphic.is_reduce .portfolio_overview__action_graphic_icon {
  background: linear-gradient(145deg, #e35834, #c94a2c);
  color: #ffffff;
}

.portfolio_overview__action_graphic.is_hold {
  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 100%);
  border-color: rgba(37, 99, 235, 0.25);
}

.portfolio_overview__action_graphic.is_hold .portfolio_overview__action_graphic_icon {
  background: linear-gradient(145deg, #3b82f6, #2563eb);
  color: #ffffff;
}

.portfolio_overview__action_graphic.is_accumulate {
  background: linear-gradient(135deg, #ecfdf5 0%, #ffffff 100%);
  border-color: rgba(22, 163, 74, 0.25);
}

.portfolio_overview__action_graphic.is_accumulate .portfolio_overview__action_graphic_icon {
  background: linear-gradient(145deg, #22c55e, #16a34a);
  color: #ffffff;
}

.portfolio_overview__action_graphic.is_default {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
}

.portfolio_overview__action_graphic.is_default .portfolio_overview__action_graphic_icon {
  background: linear-gradient(145deg, #64748b, #475569);
  color: #ffffff;
}

.portfolio_overview__action_graphic_icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.portfolio_overview__action_graphic_icon svg {
  width: 12px;
  height: 12px;
}

.portfolio_overview__action_graphic_lbl {
  display: block;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 1px;
}

.portfolio_overview__action_graphic_val {
  display: block;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #002141;
  line-height: 1.2;
}

.portfolio_overview__action_graphic.is_reduce .portfolio_overview__action_graphic_val {
  color: #c94a2c;
}

.portfolio_overview__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;
}

.portfolio_overview__grid .portfolio_overview__insight_card {
  margin-bottom: 0;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  padding: 18px 20px 20px;
  box-shadow: 0 2px 8px rgba(0, 33, 65, 0.06);
  position: relative;
  overflow: hidden;
}

.portfolio_overview__grid .portfolio_overview__insight_card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #e35834 0%, #002141 100%);
}

.portfolio_overview__insight_lead {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.55;
  color: #002141;
  margin: 0 0 14px;
}

.portfolio_overview__insight_sub {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.55;
  color: #64748b;
  margin: 0 0 16px;
}

.portfolio_overview__insight_metrics {
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.06);
  border-radius: 10px;
  padding: 2px 14px;
}

.portfolio_overview__insight_metrics .portfolio_overview__kv {
  padding: 11px 0;
}

.portfolio_overview__insight_metrics .portfolio_overview__kv:last-child {
  border-bottom: none;
}

.portfolio_overview__kv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_overview__kv:last-child {
  border-bottom: none;
}

.portfolio_overview__kv_label {
  color: #475569;
  font-weight: 500;
}

.portfolio_overview__kv_val {
  color: #0f172a;
  font-weight: 700;
  text-align: right;
}

.portfolio_overview__kv_val_strong {
  color: #002141;
  font-weight: 700;
  text-transform: capitalize;
}

.portfolio_overview__kv_is_profit .portfolio_overview__kv_label,
.portfolio_overview__kv_is_profit .portfolio_overview__kv_val {
  color: #15803d;
  font-weight: 700;
}

.portfolio_overview__kv_is_loss .portfolio_overview__kv_label,
.portfolio_overview__kv_is_loss .portfolio_overview__kv_val {
  color: #dc2626;
  font-weight: 700;
}

.portfolio_overview__kv_val.pos {
  color: #15803d;
}

.portfolio_overview__kv_val.neg {
  color: #dc2626;
}

.portfolio_overview__note {
  font-size: 12px;
  color: #64748b;
  margin: 12px 0 0;
  line-height: 1.6;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_overview__breadth_dropdown {
  margin-top: 14px;
  border: 1px solid rgba(0, 33, 65, 0.1);
  border-radius: 10px;
  background: #fff8f4;
  overflow: hidden;
}

.portfolio_overview__breadth_dropdown_toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.portfolio_overview__breadth_dropdown_toggle:hover {
  background: rgba(227, 88, 52, 0.06);
}

.portfolio_overview__breadth_dropdown_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(227, 88, 52, 0.14);
  color: #e35834;
  flex-shrink: 0;
}

.portfolio_overview__breadth_dropdown_icon svg {
  width: 14px;
  height: 14px;
}

.portfolio_overview__breadth_dropdown_label {
  flex: 1 1;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #002141;
}

.portfolio_overview__breadth_dropdown_chevron {
  display: flex;
  color: #64748b;
  transition: transform 0.2s ease;
}

.portfolio_overview__breadth_dropdown_chevron svg {
  width: 18px;
  height: 18px;
}

.portfolio_overview__breadth_dropdown.is_open .portfolio_overview__breadth_dropdown_chevron {
  transform: rotate(180deg);
}

.portfolio_overview__breadth_dropdown_panel {
  padding: 0 14px 14px;
  border-top: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_overview__breadth_summary_list {
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.portfolio_overview__breadth_summary_list li {
  position: relative;
  padding-left: 14px;
  font-size: 13px;
  line-height: 1.65;
  color: #475569;
  font-weight: 500;
  margin-bottom: 9px;
}

.portfolio_overview__breadth_summary_list li:last-child {
  margin-bottom: 0;
}

.portfolio_overview__breadth_summary_list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.55em;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e35834;
}

.portfolio_overview__breadth_summary_list li strong {
  font-weight: 700;
  color: #e35834;
}

.portfolio_overview__breadth_hl_pos,
.portfolio_overview__breadth_hl_neg,
.portfolio_overview__breadth_hl_warn,
.portfolio_overview__breadth_hl_num {
  color: #e35834;
}

.portfolio_overview__insight_card_sector .portfolio_overview__sector_chart {
  justify-content: center;
  padding-top: 4px;
}

.portfolio_overview__sector_chart {
  display: flex;
  align-items: center;
  gap: 18px;
}

.portfolio_overview__sector_pie_svg,
.portfolio_overview__sector_donut_svg {
  flex-shrink: 0;
  width: 140px;
  height: 140px;
  filter: drop-shadow(0 2px 6px rgba(0, 33, 65, 0.1));
}

.portfolio_overview__sector_legend {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.portfolio_overview__sector_legend li {
  display: grid;
  grid-template-columns: 10px 1fr auto;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.portfolio_overview__sector_legend_dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.portfolio_overview__sector_legend_name {
  color: #334155;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.portfolio_overview__sector_legend_pct {
  color: #002141;
  font-weight: 700;
  font-size: 13px;
}

.portfolio_overview__sector_row {
  display: grid;
  grid-template-columns: 1fr minmax(60px, 100px) 40px;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
}

.portfolio_overview__sector_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text);
  font-weight: 500;
}

.portfolio_overview__sector_bar {
  height: 6px;
  background: #e8ecf1;
  border-radius: 999px;
  overflow: hidden;
}

.portfolio_overview__sector_fill {
  height: 100%;
  background: linear-gradient(90deg, var(--theme), #6b8cff);
  border-radius: 999px;
}

.portfolio_overview__sector_pct {
  text-align: right;
  color: var(--muted);
  font-weight: 600;
}

.portfolio_overview__action_panel {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.1);
  border-radius: 14px;
  padding: 20px 22px 22px;
  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.05);
}

.portfolio_overview__action_grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
}

.portfolio_overview__action_card {
  display: flex;
  flex-direction: column;
  min-height: 148px;
  padding: 16px 16px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 33, 65, 0.04);
}

.portfolio_overview__action_card_title {
  font-size: 13px;
  font-weight: 700;
  color: #002141;
  margin-bottom: 12px;
  line-height: 1.35;
  letter-spacing: 0.01em;
}

.portfolio_overview__action_card_count {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-bottom: 2px;
}

.portfolio_overview__action_card_count_num {
  font-size: 28px;
  font-weight: 800;
  color: #94a3b8;
  line-height: 1;
  letter-spacing: -0.02em;
}

.portfolio_overview__action_card_count_num.is_active {
  color: #002141;
}

.portfolio_overview__action_card_count_lbl {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}

.portfolio_overview__action_card_metrics {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 12px 10px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid rgba(0, 33, 65, 0.06);
  min-height: 52px;
  justify-content: center;
}

.portfolio_overview__action_card_metrics.is_empty {
  align-items: center;
}

.portfolio_overview__action_card_hint {
  margin: 8px 0 0;
  font-size: 11px;
  line-height: 1.55;
  color: #64748b;
}

.portfolio_overview__action_card_empty {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  text-align: center;
}

.portfolio_overview__action_metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  line-height: 1.35;
}

.portfolio_overview__action_metric_label {
  color: #64748b;
  font-weight: 500;
  flex-shrink: 0;
}

.portfolio_overview__action_metric_val {
  color: #0f172a;
  font-weight: 700;
  text-align: right;
  font-size: 13px;
}

.portfolio_overview__action_metric_val.is_pos {
  color: #15803d;
}

.portfolio_overview__action_metric_val.is_neg {
  color: #dc2626;
}

.portfolio_overview__action_metric_val.is_theme {
  color: #e35834;
}

.portfolio_overview__net_impact_panel {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.1);
  border-radius: 14px;
  padding: 20px 22px 22px;
  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.05);
}

.portfolio_overview__net_impact_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.portfolio_overview__net_impact_item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 10px;
}

.portfolio_overview__net_impact_label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.3;
  letter-spacing: 0.02em;
}

.portfolio_overview__net_impact_val {
  font-size: 18px;
  font-weight: 800;
  color: #002141;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.portfolio_overview__net_impact_val.is_pos {
  color: #15803d;
}

.portfolio_overview__net_impact_val.is_neg {
  color: #dc2626;
}

.portfolio_overview__net_impact_val.is_theme {
  color: #e35834;
}

.portfolio_overview__summary_grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 20px;
}

.portfolio_overview__phase_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.portfolio_overview__phase_card {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg);
}

.portfolio_overview__phase_title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--faint);
  margin-bottom: 8px;
}

@media (max-width: 1100px) {
  .portfolio_overview__grid {
    grid-template-columns: 1fr;
  }

  .portfolio_overview__phase_grid {
    grid-template-columns: 1fr;
  }

  .portfolio_overview__action_grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .portfolio_overview__net_impact_grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .portfolio_overview__action_grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .portfolio_overview__net_impact_grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .portfolio_overview__action_grid {
    grid-template-columns: 1fr;
  }
}

.portfolio_dashboard__detail_empty {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  font-size: 14px;
}

.portfolio_section_empty {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(480px, calc(100vh - 280px));
  padding: 48px 24px;
  margin: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.portfolio_section_empty__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #475569;
  text-align: center;
  line-height: 1.4;
}

.portfolio_dashboard__detail_head {
  padding: 18px 20px 12px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.portfolio_dashboard__detail_title {
  font-size: 22px;
  font-weight: 800;
  margin: 0;
}

.portfolio_dashboard__detail_sub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 4px;
}

.portfolio_dashboard__detail_kpis {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
  font-size: 12px;
}

.portfolio_dashboard__detail_kpis span {
  color: var(--muted);
}

.portfolio_dashboard__detail_kpis strong {
  display: block;
  font-size: 14px;
  color: var(--text);
}

.portfolio_dashboard__score_box {
  text-align: right;
  flex-shrink: 0;
}

.portfolio_dashboard__score_val {
  font-size: 32px;
  font-weight: 900;
  color: var(--theme);
  line-height: 1;
}

.portfolio_dashboard__score_lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--faint);
}

.portfolio_dashboard__tabs {
  display: flex;
  gap: 4px;
  padding: 0 20px;
  border-bottom: 1px solid var(--border);
}

.portfolio_dashboard__tab {
  border: none;
  background: transparent;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.portfolio_dashboard__tab.active {
  color: var(--theme);
  border-bottom-color: var(--theme);
}

.portfolio_dashboard__detail_body {
  flex: 1 0 auto;
  overflow: visible;
  padding: 16px 20px 20px;
}

.portfolio_dashboard__panel {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 14px 16px;
  margin-bottom: 14px;
}

.portfolio_dashboard__panel h4 {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--faint);
  margin: 0 0 10px;
}

.portfolio_overview__insight_card .portfolio_overview__insight_title {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #002141;
  margin: 0 0 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_overview__action_panel .portfolio_overview__action_panel_title {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #002141;
  margin: 0 0 18px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_overview__net_impact_panel .portfolio_overview__net_impact_title {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #002141;
  margin: 0 0 18px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_dashboard__panel p {
  font-size: 13px;
  line-height: 1.65;
  color: var(--text);
  margin: 0;
}

.portfolio_overview__summary_panel {
  background: #fff8f4;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 16px;
}

.portfolio_overview__summary_panel .portfolio_overview__summary_title {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #002141;
  margin: 0 0 10px;
}

.portfolio_overview__summary_text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  color: #1e293b;
  margin: 0;
}

.portfolio_dashboard__score_bars {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.portfolio_dashboard__bar_row {
  display: grid;
  grid-template-columns: 100px 1fr 36px;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}

.portfolio_dashboard__bar_track {
  height: 8px;
  background: #e8ecf1;
  border-radius: 999px;
  overflow: hidden;
}

.portfolio_dashboard__bar_fill {
  height: 100%;
  background: linear-gradient(90deg, var(--theme), #ff9a6c);
  border-radius: 999px;
}

.portfolio_dashboard__phase_foot {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 14px 20px;
  border-top: 1px solid var(--border);
  background: linear-gradient(180deg, #fff, var(--theme-light));
  font-size: 11px;
}

.portfolio_dashboard__phase_foot strong {
  display: block;
  font-size: 14px;
  margin-top: 2px;
}

@media (max-width: 1100px) {
  .portfolio_dashboard__kpis,
  .portfolio_dashboard__kpis--top {
    grid-template-columns: repeat(2, 1fr);
  }

  .portfolio_overview__kpis {
    grid-template-columns: repeat(2, 1fr);
  }

  .portfolio_dashboard__search_wrap {
    max-width: none;
    order: 3;
    flex: 1 1 100%;
  }

  .portfolio_dashboard__actions {
    margin-left: 0;
  }

  .portfolio_dashboard__split {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .portfolio_dashboard {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .portfolio_dashboard__sidebar.sidebar_premium {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    height: auto;
    max-height: none;
  }

  .portfolio_dashboard__main {
    margin-left: 0;
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .portfolio_dashboard__header_fixed {
    position: relative;
  }

  .portfolio_dashboard__scroll {
    overflow-y: visible;
    flex: none;
  }

  .portfolio_dashboard__split {
    flex: none;
  }

  .portfolio_dashboard__kpis,
  .portfolio_dashboard__kpis--top,
  .portfolio_overview__kpis {
    grid-template-columns: 1fr;
  }

  .portfolio_overview__head {
    grid-template-areas:
      "title"
      "chips"
      "meta";
    grid-template-columns: 1fr;
  }

  .portfolio_overview__head_meta {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .portfolio_holdings_page__head {
    padding: 14px 12px;
  }

  .portfolio_holding_card__stats {
    padding: 12px;
    gap: 10px;
  }

  .portfolio_holding_card__stat {
    min-height: 76px;
    padding: 14px 12px;
  }

  .portfolio_holding_card__stat_value {
    font-size: 15px;
  }

  .portfolio_detail_stack {
    grid-template-columns: 1fr;
  }

  .portfolio_stock_detail__metric {
    flex: 1 1 45%;
    border-right: none;
    border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  }

  .portfolio_stock_detail__metric:nth-child(odd) {
    border-right: 1px solid rgba(0, 33, 65, 0.06);
  }

  .portfolio_stock_detail__insights {
    grid-template-columns: 1fr;
  }

  .portfolio_siho_scores__grid.is_row {
    grid-template-columns: 1fr;
  }
}

.portfolio_dashboard__scroll--holdings {
  padding: 0 0 20px;
  gap: 0;
}

/* Portfolio holdings list */
.portfolio_holdings_page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}

.portfolio_holdings_page__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 16px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
  background: #ffffff;
}

.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__head {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 28px 24px 22px;
  margin-bottom: 20px;
}

.portfolio_holdings_page.is_detail .portfolio_holdings_page__head {
  margin-bottom: 12px;
  padding-bottom: 14px;
}

.portfolio_holdings_page.is_detail .portfolio_holdings_page__title {
  font-size: 22px;
}

.portfolio_holdings_page__titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__titles {
  align-items: center;
  gap: 8px;
  max-width: 520px;
}

.portfolio_holdings_page__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #002141;
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__title::after {
  content: "";
  display: block;
  width: 48px;
  height: 3px;
  margin: 12px auto 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #e35834, rgba(227, 88, 52, 0.35));
}

.portfolio_holdings_page__subtitle {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
}

.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__subtitle {
  font-size: 15px;
  font-weight: 500;
  color: #475569;
}

.portfolio_holdings_page__back {
  border: 1px solid rgba(0, 33, 65, 0.12);
  background: #ffffff;
  color: #002141;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);
}

.portfolio_holdings_table {
  padding: 0 20px 24px;
}

.portfolio_holdings_table__wrap {
  overflow-x: auto;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 33, 65, 0.05);
}

.portfolio_holdings_table__grid {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
  font-size: 13px;
}

.portfolio_holdings_table__grid th {
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #002141;
  padding: 14px 14px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.1);
  background: #eef2f7;
  white-space: nowrap;
}

.portfolio_holdings_table__grid td {
  padding: 14px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  vertical-align: middle;
  color: #334155;
  line-height: 1.4;
}

.portfolio_holdings_table__grid tbody tr:hover td {
  background: #fff8f4;
}

.portfolio_holdings_table__grid tbody tr:last-child td {
  border-bottom: none;
}

.portfolio_holdings_table__stock {
  font-weight: 700;
  color: #002141;
  min-width: 140px;
}

.portfolio_holdings_table__symbol {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}

.portfolio_holdings_table__isin {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.portfolio_holdings_table__price {
  font-weight: 700;
  color: #15803d;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.portfolio_holdings_table__num {
  font-weight: 600;
  color: #002141;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.portfolio_holdings_table__return {
  font-weight: 700;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.portfolio_holdings_table__return.pos {
  color: #15803d;
}

.portfolio_holdings_table__return.neg {
  color: #dc2626;
}

.portfolio_holdings_table__score {
  font-weight: 700;
  color: #002141;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.portfolio_holdings_table__action {
  text-align: right;
  white-space: nowrap;
}

.portfolio_holdings_table__detail_btn {
  border: 1px solid rgba(0, 33, 65, 0.1);
  background: #eef2f7;
  color: #002141;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.portfolio_holdings_table__detail_btn:hover {
  background: #e35834;
  color: #ffffff;
  border-color: #e35834;
  box-shadow: 0 4px 12px rgba(227, 88, 52, 0.22);
}

.portfolio_holding_card {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 2px 10px rgba(0, 33, 65, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.portfolio_holding_card:hover {
  border-color: rgba(227, 88, 52, 0.25);
  box-shadow: 0 6px 18px rgba(0, 33, 65, 0.08);
}

.portfolio_holding_card.is_active {
  border-color: rgba(227, 88, 52, 0.45);
  box-shadow: 0 12px 32px rgba(227, 88, 52, 0.12);
}

.portfolio_holding_card__head {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-start;
}

.portfolio_holding_card__identity {
  min-width: 0;
  flex: 1 1;
}

.portfolio_holding_card__name {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  color: #002141;
  line-height: 1.35;
  letter-spacing: -0.01em;
}

.portfolio_holding_card__subhead {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.portfolio_holding_card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.portfolio_holding_card__tag {
  font-size: 10px;
  font-weight: 700;
  color: #002141;
  background: #f1f5f9;
  border: 1px solid rgba(0, 33, 65, 0.08);
  padding: 3px 7px;
  border-radius: 5px;
  letter-spacing: 0.02em;
}

.portfolio_holding_card__industry {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  line-height: 1.35;
}

.portfolio_holding_card__isin {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.35;
}

.portfolio_holding_card__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 10px;
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.06);
  border-radius: 10px;
}

.portfolio_holding_card__stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  min-height: 62px;
  padding: 10px 12px;
  text-align: left;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.06);
  border-radius: 8px;
  box-sizing: border-box;
}

.portfolio_holding_card__stat_label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  line-height: 1.2;
}

.portfolio_holding_card__stat_value {
  display: block;
  width: 100%;
  font-size: 15px;
  font-weight: 700;
  color: #002141;
  line-height: 1.2;
  margin: 0;
  font-variant-numeric: tabular-nums;
}

.portfolio_holding_card__stat_value.pos {
  color: #15803d;
}

.portfolio_holding_card__stat_value.neg {
  color: #dc2626;
}

.portfolio_holding_card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-top: 2px;
}

.portfolio_holding_card__score_pill {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  background: #fff8f4;
  border: 1px solid rgba(227, 88, 52, 0.12);
  border-radius: 8px;
}

.portfolio_holding_card__score_lbl {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.portfolio_holding_card__score_pill strong {
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.portfolio_holding_card__score_pill strong small {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  margin-left: 2px;
}

.portfolio_holding_card__detail_btn {
  border: 1px solid rgba(0, 33, 65, 0.1);
  background: #eef2f7;
  color: #002141;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.portfolio_holding_card__detail_btn:hover {
  background: #e35834;
  color: #ffffff;
  border-color: #e35834;
  box-shadow: 0 4px 12px rgba(227, 88, 52, 0.22);
}

.portfolio_holdings_page__detail {
  scroll-margin-top: 88px;
  padding: 0 20px 24px;
}

/* Action section — sidebar list + detail (full viewport height) */
.portfolio_action_section {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  height: 100%;
  background: #f1f5f9;
}

.portfolio_dashboard__scroll--action {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: calc(100dvh - 96px);
  padding: 0;
  gap: 0;
}

/* Fill viewport below header — split/detail wrappers were flex:none */
.portfolio_dashboard__scroll--action .portfolio_dashboard__split {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.portfolio_dashboard__scroll--action .portfolio_dashboard__detail {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.portfolio_dashboard__scroll--action .portfolio_action_section {
  flex: 1 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.portfolio_action_section__layout {
  display: flex;
  align-items: stretch;
  flex: 1 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  gap: 12px;
  padding: 8px;
  box-sizing: border-box;
}

.portfolio_action_section__detail_panel {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e8ecf1;
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(26, 35, 58, 0.08);
}

.portfolio_action_section__detail_scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(227, 88, 52, 0.35) transparent;
}

.portfolio_action_section__placeholder {
  margin: 0;
  padding: 40px 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  background: #ffffff;
  border: 1px dashed rgba(0, 33, 65, 0.12);
  border-radius: 14px;
}

.portfolio_action_section__stock_card {
  margin: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.portfolio_action_sidebar {
  flex: 0 0 340px;
  width: 340px;
  max-width: 38vw;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  padding: 0;
  background: transparent;
}

.portfolio_action_sidebar__card {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e8ecf1;
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(26, 35, 58, 0.08);
  overflow: hidden;
}

.portfolio_action_sidebar__controls {
  flex-shrink: 0;
  padding: 18px 16px 14px;
  background: #ffffff;
}

.portfolio_action_sidebar__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}

.portfolio_action_sidebar__title {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1a233a;
  line-height: 1.2;
}

.portfolio_action_sidebar__count {
  font-size: 11px;
  font-weight: 800;
  color: #ffffff;
  background: #ff6b35;
  border: none;
  min-width: 26px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 0 8px;
  line-height: 1;
}

.portfolio_action_sidebar__search_wrap {
  position: relative;
  margin-bottom: 14px;
}

.portfolio_action_sidebar__search_icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: #9aa5b5;
  pointer-events: none;
}

.portfolio_action_sidebar__search {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #dfe5ec;
  border-radius: 999px;
  padding: 11px 14px 11px 40px;
  font-size: 13px;
  font-family: inherit;
  color: #1a233a;
  background: #ffffff;
  outline: none;
}

.portfolio_action_sidebar__search::placeholder {
  color: #aab4c4;
  font-weight: 400;
}

.portfolio_action_sidebar__search:focus {
  border-color: #9aa5b5;
  box-shadow: none;
}

.portfolio_action_sidebar__chips {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  margin-bottom: 12px;
  overflow-x: auto;
  padding-bottom: 2px;
  scrollbar-width: none;
}

.portfolio_action_sidebar__chips::-webkit-scrollbar {
  display: none;
}

.portfolio_action_sidebar__chip {
  border: 1px solid #dfe5ec;
  background: #ffffff;
  color: #5c6b82;
  font-size: 11px;
  font-weight: 600;
  font-family: inherit;
  padding: 6px 11px;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 1.2;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.portfolio_action_sidebar__chip:hover {
  border-color: #c5ced8;
  color: #1a233a;
}

.portfolio_action_sidebar__chip.is_active {
  background: #1a233a;
  border-color: #1a233a;
  color: #ffffff;
}

.portfolio_action_sidebar__sort {
  display: flex;
  align-items: center;
  gap: 8px;
}

.portfolio_action_sidebar__sort_lbl {
  font-size: 12px;
  font-weight: 500;
  color: #9aa5b5;
  white-space: nowrap;
}

.portfolio_action_sidebar__sort_select {
  flex: 0 1 auto;
  min-width: 108px;
  border: 1px solid #dfe5ec;
  border-radius: 8px;
  padding: 7px 28px 7px 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  color: #1a233a;
  background: #ffffff
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat right 10px center;
  appearance: none;
  cursor: pointer;
}

.portfolio_action_sidebar__sort_select:focus {
  outline: none;
  border-color: #9aa5b5;
}

.portfolio_action_sidebar__list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  min-height: 0;
  border-top: 1px solid #eef1f5;
  scrollbar-width: thin;
  scrollbar-color: rgba(26, 35, 58, 0.25) transparent;
}

.portfolio_action_sidebar__empty {
  padding: 28px 16px;
  text-align: center;
  font-size: 13px;
  color: #9aa5b5;
}

.portfolio_action_sidebar__row {
  border-bottom: 1px solid #eef1f5;
}

.portfolio_action_sidebar__row:last-child {
  border-bottom: none;
}

.portfolio_action_sidebar__item {
  width: 100%;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 14px 14px 14px 12px;
  border: none;
  border-left: 3px solid transparent;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.15s ease;
}

.portfolio_action_sidebar__item:hover {
  background: #fafbfc;
}

.portfolio_action_sidebar__item.is_active {
  background: #fff6f3;
  border-left-color: #e35834;
}

.portfolio_action_sidebar__item.is_active.is_watch .portfolio_action_sidebar__name {
  color: #c45c26;
}

.portfolio_action_sidebar__avatar {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.02em;
}

.portfolio_action_sidebar__avatar.accumulate.tone_a {
  background: #e8f8ef;
  color: #2d8a56;
}

.portfolio_action_sidebar__avatar.accumulate.tone_b {
  background: #e3f0ff;
  color: #2f6eb3;
}

.portfolio_action_sidebar__avatar.accumulate.tone_c {
  background: #fff4df;
  color: #b07a12;
}

.portfolio_action_sidebar__avatar.accumulate.tone_d {
  background: #fde8ef;
  color: #c44d74;
}

.portfolio_action_sidebar__avatar.accumulate.tone_e {
  background: #efe9ff;
  color: #6b4fc7;
}

.portfolio_action_sidebar__avatar.buy.tone_a,
.portfolio_action_sidebar__avatar.buy.tone_c {
  background: #e8eeff;
  color: #3b5ccc;
}

.portfolio_action_sidebar__avatar.buy.tone_b,
.portfolio_action_sidebar__avatar.buy.tone_e {
  background: #e3f0ff;
  color: #2f6eb3;
}

.portfolio_action_sidebar__avatar.buy.tone_d {
  background: #efe9ff;
  color: #6b4fc7;
}

.portfolio_action_sidebar__avatar.watch,
.portfolio_action_sidebar__avatar.watch.tone_a,
.portfolio_action_sidebar__avatar.watch.tone_b,
.portfolio_action_sidebar__avatar.watch.tone_c,
.portfolio_action_sidebar__avatar.watch.tone_d,
.portfolio_action_sidebar__avatar.watch.tone_e {
  background: #fff8e6;
  color: #c45c26;
}

.portfolio_action_sidebar__center {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.portfolio_action_sidebar__name {
  font-size: 15px;
  font-weight: 700;
  color: #1a233a;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.portfolio_action_sidebar__sector_line {
  font-size: 12px;
  font-weight: 500;
  color: #7b8798;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.portfolio_action_sidebar__rail {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  min-width: 72px;
}

.portfolio_action_sidebar__chg {
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  line-height: 1.2;
}

.portfolio_action_sidebar__chg.pos {
  color: #2eb872;
}

.portfolio_action_sidebar__chg.neg {
  color: #f05454;
}

.badge_sidebar_accumulate {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 9px;
  border-radius: 999px;
  line-height: 1.2;
  background: #e5f7ed;
  color: #2d8a56;
}

.badge_sidebar_buy {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 9px;
  border-radius: 999px;
  line-height: 1.2;
  background: #e8eeff;
  color: #3b5ccc;
}

.badge_sidebar_watch {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 9px;
  border-radius: 999px;
  line-height: 1.2;
  background: #fff4df;
  color: #c45c26;
}

.portfolio_action_pills {
  flex-shrink: 0;
  padding: 14px 20px 12px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.04);
}

.portfolio_action_pills__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.portfolio_action_pills__pill {
  border: 1px solid rgba(0, 33, 65, 0.1);
  background: #ffffff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  padding: 9px 16px;
  border-radius: 999px;
  cursor: pointer;
  max-width: 168px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.12s ease;
}

.portfolio_action_pills__pill:hover {
  background: #ffffff;
  border-color: rgba(227, 88, 52, 0.4);
  color: #002141;
  box-shadow: 0 2px 8px rgba(227, 88, 52, 0.12);
  transform: translateY(-1px);
}

.portfolio_action_pills__pill.is_active {
  background: linear-gradient(135deg, #002141 0%, #0a3a6b 100%);
  border-color: #002141;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 33, 65, 0.22);
}

.portfolio_action_pills__pill.is_more {
  background: #ffffff;
  border-style: dashed;
  color: #e35834;
  font-weight: 700;
  max-width: none;
}

.portfolio_action_pills__pill.is_more:hover {
  background: #fff8f4;
  border-color: #e35834;
}

.portfolio_action_section .portfolio_dashboard__detail_head {
  border-top: none;
}

@media (max-width: 960px) {
  .portfolio_action_section__layout {
    flex-direction: column;
    min-height: 0;
    padding: 8px;
  }

  .portfolio_action_sidebar {
    flex: 0 0 auto;
    width: 100%;
    max-width: none;
    max-height: 42vh;
  }

  .portfolio_action_section__detail_panel {
    flex: 1 1 auto;
    min-height: 48vh;
  }
}

/* Stock detail header — title row + compact SIHO */
.portfolio_detail_head__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.portfolio_detail_head__identity {
  flex: 1 1;
  min-width: 0;
}

.portfolio_execution_step {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.portfolio_execution_step__section {
  min-width: 0;
}

.portfolio_execution_step__section--steps {
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid rgba(0, 33, 65, 0.08);
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);
}

.portfolio_execution_step__heading {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.portfolio_execution_step__empty {
  margin: 0;
  padding: 20px 16px;
  font-size: 14px;
  color: #64748b;
  text-align: center;
}

.portfolio_execution_step .portfolio_action_item_card {
  margin-top: 0;
}

.portfolio_execution_step .portfolio_action_plan {
  margin-top: 0;
}

.portfolio_action_item_card {
  margin-top: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(0, 33, 65, 0.1);
  background: linear-gradient(160deg, #f8fafc 0%, #ffffff 72%);
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.05);
}

.portfolio_action_item_card__title {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.portfolio_action_item_card__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
  gap: 12px 18px;
  margin: 0;
}

.portfolio_action_item_card__row {
  margin: 0;
  min-width: 0;
}

.portfolio_action_item_card__row dt {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.35;
}

.portfolio_action_item_card__row dd {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #002141;
  line-height: 1.3;
  word-break: break-word;
}

.portfolio_action_item_card__row dd.pos {
  color: #059669;
}

.portfolio_action_item_card__row dd.neg {
  color: #dc2626;
}

.portfolio_detail_head__title_row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-bottom: 2px;
}

.portfolio_detail_head__name_block {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.portfolio_detail_head__name_icon {
  font-size: 22px;
  line-height: 1;
  flex-shrink: 0;
}

.portfolio_action_section .portfolio_dashboard__detail_title {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.portfolio_detail_head__nse_code {
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.portfolio_detail_head__score_icon {
  margin-right: 4px;
}

.portfolio_detail_kpi__icon {
  display: block;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 4px;
  opacity: 0.85;
}

.portfolio_detail_head__return {
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.portfolio_detail_head__return.pos {
  color: #2eb872;
}

.portfolio_detail_head__return.neg {
  color: #f05454;
}

.portfolio_detail_head__score_simple {
  flex-shrink: 0;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  padding: 0;
  background: none;
  border: none;
  box-shadow: none;
  text-align: right;
}

.portfolio_detail_head__score_simple .portfolio_dashboard__score_lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.portfolio_detail_head__score_simple .portfolio_dashboard__score_val {
  font-size: 22px;
  font-weight: 900;
  color: #e35834;
  line-height: 1;
}

.portfolio_detail_head__score_simple .portfolio_dashboard__score_of {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_detail_head__score_simple .portfolio_dashboard__score_meter {
  width: 72px;
  margin-top: 2px;
}

.portfolio_detail_head__meta {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.portfolio_detail_head__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.portfolio_detail_head__tag {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid rgba(0, 33, 65, 0.08);
  padding: 5px 10px;
  border-radius: 8px;
  line-height: 1.2;
}

.portfolio_detail_head__tag--exchange {
  color: #002141;
  background: #eef2f7;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.portfolio_detail_head__meta_line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  font-size: 14px;
  color: #475569;
}

.portfolio_detail_head__sector {
  font-weight: 600;
  color: #1e293b;
}

.portfolio_detail_head__dot {
  color: #cbd5e1;
  font-weight: 400;
  -webkit-user-select: none;
          user-select: none;
}

.portfolio_detail_head__isin {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  font-family: ui-monospace, "Cascadia Code", monospace;
}

.portfolio_dashboard__score_box--compact {
  flex-shrink: 0;
  align-self: flex-start;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  padding: 8px 14px;
  min-width: 0;
  height: auto;
  line-height: 1;
}

.portfolio_dashboard__score_box--compact .portfolio_dashboard__score_lbl {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  order: 0;
}

.portfolio_dashboard__score_box--compact .portfolio_dashboard__score_val {
  font-size: 22px;
  font-weight: 900;
  color: #e35834;
  line-height: 1;
  order: 1;
}

.portfolio_dashboard__score_box--compact .portfolio_dashboard__score_of {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  order: 2;
}

/* —— Action section: stock header + KPI tiles —— */
.portfolio_action_section .portfolio_dashboard__detail_head {
  padding: 16px 18px 14px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);
  display: block;
}

.portfolio_action_section .portfolio_dashboard__detail_title {
  font-size: 24px;
  letter-spacing: -0.02em;
  color: #002141;
  margin: 0;
}

.portfolio_action_section .portfolio_dashboard__detail_kpis {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin-top: 16px;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  overflow: hidden;
}

.portfolio_action_section .portfolio_dashboard__detail_kpis > span {
  flex: 1 1;
  min-width: 110px;
  background: transparent;
  border: none;
  border-right: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 0;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: none;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.portfolio_action_section .portfolio_dashboard__detail_kpis > span:last-child {
  border-right: none;
}

.portfolio_action_section .portfolio_dashboard__detail_kpis > span strong {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  text-transform: none;
  letter-spacing: 0;
}

.portfolio_dashboard__score_box--detail {
  flex-shrink: 0;
  align-self: flex-start;
  min-width: 120px;
  padding: 12px 14px;
  text-align: left;
  background: linear-gradient(145deg, #fff8f4 0%, #ffffff 100%);
  border: 1px solid rgba(227, 88, 52, 0.22);
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(227, 88, 52, 0.1);
}

.portfolio_dashboard__score_box--detail .portfolio_dashboard__score_lbl {
  display: block;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.portfolio_dashboard__score_detail_val {
  display: flex;
  align-items: baseline;
  gap: 4px;
  line-height: 1;
}

.portfolio_dashboard__score_box--detail .portfolio_dashboard__score_val {
  font-size: 24px;
  font-weight: 900;
  color: #e35834;
}

.portfolio_dashboard__score_box--detail .portfolio_dashboard__score_of {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_dashboard__score_meter {
  margin-top: 8px;
  height: 4px;
  border-radius: 999px;
  background: rgba(0, 33, 65, 0.08);
  overflow: hidden;
}

.portfolio_dashboard__score_meter > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #e35834, #f59e0b);
}

.portfolio_action_section .portfolio_dashboard__tabs {
  padding: 0 18px;
  background: #fafbfc;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
  gap: 8px;
}

/* Prominent segmented tabs on Cut Loss / action stock detail */
.portfolio_detail_tabs_bar.is_action_section {
  padding: 16px 18px 18px;
  background: linear-gradient(180deg, #f1f5f9 0%, #ffffff 55%);
  border-top: 1px solid rgba(0, 33, 65, 0.06);
  border-bottom: 2px solid rgba(0, 33, 65, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.portfolio_detail_tabs_bar__label {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #002141;
}

.portfolio_detail_tabs_bar.is_action_section .portfolio_detail_tabs_bar__tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 0;
  margin: 0;
  border-bottom: none;
  background: transparent;
}

.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  width: 100%;
  min-height: 52px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1.15;
  border-radius: 12px;
  border: 1.5px solid rgba(0, 33, 65, 0.14);
  background: #ffffff;
  color: #475569;
  margin-bottom: 0;
  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);
  box-sizing: border-box;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    box-shadow 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;
}

.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab .portfolio_dashboard__tab_icon {
  font-size: 18px;
  line-height: 1;
}

.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab:not(.active):hover {
  border-color: rgba(0, 33, 65, 0.22);
  background: #f8fafc;
  color: #002141;
  box-shadow:
    0 0 0 1px rgba(0, 33, 65, 0.04),
    0 8px 18px rgba(0, 33, 65, 0.08);
  transform: translateY(-1px);
}

.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab:focus-visible {
  outline: none;
  border-color: rgba(227, 88, 52, 0.45);
  box-shadow:
    0 0 0 4px rgba(227, 88, 52, 0.16),
    0 8px 18px rgba(0, 33, 65, 0.08);
}

.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab.active {
  color: #c2410c;
  background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);
  border-color: #e35834;
  border-bottom-color: #e35834;
  box-shadow:
    0 0 0 1px rgba(227, 88, 52, 0.12),
    0 6px 16px rgba(227, 88, 52, 0.2);
}

@media (max-width: 520px) {
  .portfolio_detail_tabs_bar.is_action_section .portfolio_detail_tabs_bar__tabs {
    grid-template-columns: 1fr;
  }
}

.portfolio_action_section .portfolio_dashboard__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.portfolio_dashboard__tab_icon {
  font-size: 14px;
  line-height: 1;
}

.portfolio_action_section .portfolio_dashboard__tab.active {
  color: #e35834;
  border-bottom-color: #e35834;
  background: rgba(227, 88, 52, 0.06);
  border-radius: 8px 8px 0 0;
}

.portfolio_action_section .portfolio_dashboard__detail_body {
  padding: 16px 18px 18px;
  background: #ffffff;
}

/* Section tint: left accent on action step cards */
.portfolio_action_detail--accumulate .portfolio_action_steps__card {
  border-left-color: #10b981;
}

.portfolio_action_detail--average_down .portfolio_action_steps__card {
  border-left-color: #3b82f6;
}

.portfolio_action_detail--cut_loss .portfolio_action_steps__card,
.portfolio_action_detail--exit .portfolio_action_steps__card {
  border-left-color: #f97316;
}

.portfolio_action_detail--profit_booking .portfolio_action_steps__card {
  border-left-color: #f59e0b;
}

.portfolio_action_detail--hold .portfolio_action_steps__card {
  border-left-color: #64748b;
}

@media (max-width: 900px) {
  .portfolio_action_section .portfolio_dashboard__detail_kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* Three-phase execution plan */
.portfolio_execution_page {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.portfolio_execution_page .portfolio_overview__head {
  margin-bottom: 0;
}

.portfolio_execution_page .portfolio_overview__action_grid {
  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));
  gap: 14px;
}

.portfolio_execution_page .portfolio_overview__action_card {
  min-height: 0;
  padding: 14px;
}

.portfolio_execution_page .portfolio_overview__action_card_count_num {
  font-size: 24px;
}

.portfolio_execution_page .portfolio_overview__net_impact_panel {
  padding: 18px 20px;
}

.portfolio_tph {
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  background: #fff9f6;
  overflow: hidden;
  box-shadow: 0 2px 14px rgba(0, 33, 65, 0.05);
}

.portfolio_tph--page {
  margin-bottom: 0;
  background: #ffffff;
}

.portfolio_tph--execution_tab {
  margin-bottom: 16px;
}

.portfolio_execution_tab {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.portfolio_action_execution_layout {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.portfolio_action_submetrics {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  background: #f1f5f9;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  overflow: hidden;
}

.portfolio_action_submetrics__item {
  flex: 1 1;
  min-width: 140px;
  padding: 14px 18px;
  border-right: 1px solid rgba(0, 33, 65, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.portfolio_action_submetrics__item:last-child {
  border-right: none;
}

.portfolio_action_submetrics__lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.portfolio_action_submetrics__item strong {
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  line-height: 1.25;
}

.portfolio_action_submetrics__item strong.pos {
  color: #15803d;
}

.portfolio_action_submetrics__item strong.neg {
  color: #dc2626;
}

.portfolio_action_steps__title {
  margin: 0 0 12px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.portfolio_action_steps__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portfolio_action_steps__card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-left: 3px solid #002141;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 33, 65, 0.04);
}

.portfolio_action_steps__num {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: linear-gradient(145deg, #002141 0%, #0a3a6b 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.portfolio_action_steps__headline {
  display: block;
  font-size: 15px;
  font-weight: 800;
  color: #002141;
  line-height: 1.35;
  margin-bottom: 6px;
}

.portfolio_action_steps__desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #64748b;
}

.portfolio_tph__head {
  padding: 18px 22px;
  background: #f8fafc;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 20px;
}

.portfolio_tph__head_text {
  min-width: 0;
  flex: 1 1;
}

.portfolio_tph__title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  letter-spacing: 0.02em;
  line-height: 1.35;
}

.portfolio_tph__head_sub {
  margin: 6px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  color: #64748b;
}

.portfolio_tph__head_stats {
  margin: 4px 0 0;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  white-space: nowrap;
}

.portfolio_tph__inner {
  padding: 20px 22px 22px;
}

.portfolio_tph__intro_details {
  margin-bottom: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  overflow: hidden;
}

.portfolio_tph__intro_details > summary {
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  list-style: none;
}

.portfolio_tph__intro_details > summary::-webkit-details-marker {
  display: none;
}

.portfolio_tph__intro_details .portfolio_tph__note {
  margin: 0;
  padding: 0 14px 12px;
  font-size: 12px;
  line-height: 1.55;
}

.portfolio_tph__note {
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
}

.portfolio_tph__note strong {
  color: #002141;
  font-weight: 700;
}

.portfolio_tph__phase_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 18px;
  align-items: start;
}

.portfolio_tph--page .portfolio_tph__phase_grid {
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px;
}

.portfolio_tph__phase_card {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 16px 18px;
  min-width: 0;
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);
}

.portfolio_tph--page .portfolio_tph__phase_card--now {
  padding: 18px 20px;
}

.portfolio_tph__phase_title {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #002141;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_tph__phase_note {
  margin: -6px 0 14px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

.portfolio_tph__phase_group {
  margin-bottom: 16px;
}

.portfolio_tph__phase_group:last-of-type {
  margin-bottom: 0;
}

.portfolio_tph__phase_group_title {
  margin-bottom: 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #94a3b8;
}

.portfolio_tph__metric {
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 33, 65, 0.05);
}

.portfolio_tph__metric:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.portfolio_tph__metric_main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px 16px;
}

.portfolio_tph__metric_lbl {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  line-height: 1.4;
}

.portfolio_tph__metric_val {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  text-align: right;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.portfolio_tph__metric_val .pos,
.portfolio_tph__metric_val.pos {
  color: #16a34a;
}

.portfolio_tph__metric_val .neg,
.portfolio_tph__metric_val.neg {
  color: #dc2626;
}

.portfolio_tph__metric_badge {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  padding: 2px 7px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.portfolio_tph__metric_ctx {
  margin: 6px 0 0;
  font-size: 11px;
  line-height: 1.45;
  color: #94a3b8;
}

.portfolio_tph__metric_ctx strong {
  color: #64748b;
  font-weight: 700;
}

.portfolio_tph__baseline_details {
  margin-top: 14px;
  border: 1px dashed #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  overflow: hidden;
}

.portfolio_tph__baseline_details > summary {
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  list-style: none;
}

.portfolio_tph__baseline_details > summary::-webkit-details-marker {
  display: none;
}

.portfolio_tph__baseline_list {
  margin: 0;
  padding: 0 14px 12px;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.portfolio_tph__baseline_list li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
}

.portfolio_tph__baseline_list li span:first-child {
  font-weight: 700;
  color: #334155;
}

.portfolio_tph__baseline_list li strong {
  color: #0f172a;
}

/* Legacy row classes (stock detail tab) */
.portfolio_tph__row {
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: 4px 12px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_tph__row:last-child {
  border-bottom: none;
}

.portfolio_tph__row_lbl {
  color: #475569;
  font-weight: 600;
  flex: 1 1 auto;
  min-width: 120px;
}

.portfolio_tph__row_val {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  text-align: right;
}

.portfolio_tph__row_val .pos,
.portfolio_tph__row_val.pos {
  color: #16a34a;
}

.portfolio_tph__row_val .neg,
.portfolio_tph__row_val.neg {
  color: #dc2626;
}

.portfolio_tph__row_sub {
  flex: 1 1 100%;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 4px;
  line-height: 1.45;
}

.portfolio_tph__row_sub strong {
  color: #64748b;
  font-weight: 700;
}

.portfolio_tph__pct {
  color: #94a3b8;
}

.portfolio_tph__collapsible {
  margin-top: 6px;
  border-top: 1px solid rgba(0, 33, 65, 0.06);
  padding-top: 8px;
}

.portfolio_tph__collapsible > summary {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #475569;
}

.portfolio_tph__collapsible > summary::-webkit-details-marker {
  display: none;
}

.portfolio_tph__collapsible_peek {
  font-weight: 800;
  color: #002141;
}

.portfolio_tph__collapsible_panel {
  padding: 10px 0 2px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.55;
}

.portfolio_tph__collapsible_panel p {
  margin: 8px 0 0;
}

.portfolio_tph__footer {
  padding: 16px 18px;
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
}

.portfolio_tph__footer_heading {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #002141;
  margin-bottom: 10px;
}

.portfolio_tph__footer_row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px 16px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  font-size: 13px;
}

.portfolio_tph__footer_row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.portfolio_tph__footer_lbl {
  color: #475569;
  font-weight: 600;
  line-height: 1.4;
}

.portfolio_tph__footer_val {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  text-align: right;
  white-space: nowrap;
}

.portfolio_tph__footer_val.neg {
  color: #dc2626;
}

@media (max-width: 960px) {
  .portfolio_tph__phase_grid,
  .portfolio_tph--page .portfolio_tph__phase_grid {
    grid-template-columns: 1fr;
  }

  .portfolio_tph__metric_main,
  .portfolio_tph__footer_row {
    grid-template-columns: 1fr;
  }

  .portfolio_tph__metric_val,
  .portfolio_tph__footer_val {
    text-align: left;
    justify-content: flex-start;
  }
}

/* Action section bucket totals */
.portfolio_action_totals {
  margin: 0;
  border-radius: 14px;
  padding: 12px 14px 14px;
  border: 1px solid rgba(0, 33, 65, 0.08);
  box-shadow: 0 2px 14px rgba(0, 33, 65, 0.05);
}

.portfolio_action_totals--accumulate {
  background: linear-gradient(135deg, #ecfdf5 0%, #ffffff 55%);
  border-color: rgba(16, 185, 129, 0.2);
}

.portfolio_action_totals--average_down {
  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 55%);
  border-color: rgba(59, 130, 246, 0.2);
}

.portfolio_action_totals--cut_loss,
.portfolio_action_totals--exit {
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 55%);
  border-color: rgba(249, 115, 22, 0.22);
}

.portfolio_action_totals--profit_booking {
  background: linear-gradient(135deg, #fffbeb 0%, #ffffff 55%);
  border-color: rgba(245, 158, 11, 0.22);
}

.portfolio_action_totals__title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: none;
  color: #002141;
}

.portfolio_action_totals__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.portfolio_action_totals__chip {
  flex: 1 1 140px;
  min-width: 120px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow:
    0 1px 4px rgba(0, 33, 65, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.portfolio_action_totals--accumulate .portfolio_action_totals__chip {
  background: #ffffff;
  border-color: rgba(16, 185, 129, 0.12);
}

.portfolio_action_totals--average_down .portfolio_action_totals__chip {
  background: #ffffff;
  border-color: rgba(59, 130, 246, 0.12);
}

.portfolio_action_totals--cut_loss .portfolio_action_totals__chip,
.portfolio_action_totals--exit .portfolio_action_totals__chip {
  background: #ffffff;
  border-color: rgba(249, 115, 22, 0.12);
}

.portfolio_action_totals--profit_booking .portfolio_action_totals__chip {
  background: #ffffff;
  border-color: rgba(245, 158, 11, 0.14);
}

.portfolio_action_totals__chip span {
  font-size: 12px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.02em;
  color: #475569;
}

.portfolio_action_totals__chip strong {
  font-size: 17px;
  font-weight: 800;
  color: #002141;
  letter-spacing: -0.02em;
}

.portfolio_action_totals__hint {
  margin: 10px 0 0;
  font-size: 11px;
  line-height: 1.55;
  color: #64748b;
}

/* Per-stock action plan cards */
.portfolio_action_plan {
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 14px;
  border: 1px solid rgba(0, 33, 65, 0.1);
  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.05);
}

.portfolio_action_plan--cut {
  background: linear-gradient(160deg, #fff7ed 0%, #ffffff 65%);
  border-color: rgba(249, 115, 22, 0.22);
}

/* Staggered cut loss — execution step card */
.portfolio_cut_loss_plan {
  margin-top: 4px;
  margin-bottom: 14px;
  padding: 18px 20px;
  border-radius: 14px;
  border: 1px dashed rgba(220, 38, 38, 0.28);
  background: linear-gradient(165deg, rgba(254, 242, 242, 0.55) 0%, rgba(255, 255, 255, 0.92) 48%);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
}

.portfolio_cut_loss_plan__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 16px;
  margin-bottom: 16px;
}

.portfolio_cut_loss_plan__title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #002141;
}

.portfolio_cut_loss_plan__lead {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
  max-width: 42ch;
}

.portfolio_cut_loss_plan__badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #b91c1c;
  background: rgba(254, 226, 226, 0.85);
  border: 1px solid rgba(220, 38, 38, 0.18);
}

.portfolio_cut_loss_plan__subhead {
  margin: 14px 0 10px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #ea580c;
}

.portfolio_cut_loss_plan__empty {
  margin: 8px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_cut_loss_step {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr) auto;
  gap: 10px 14px;
  align-items: center;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(0, 33, 65, 0.08);
  box-shadow: 0 1px 2px rgba(0, 33, 65, 0.04);
}

.portfolio_cut_loss_step + .portfolio_cut_loss_step,
.portfolio_cut_loss_plan__subhead + .portfolio_cut_loss_step {
  margin-top: 8px;
}

.portfolio_cut_loss_step--now {
  border-color: rgba(220, 38, 38, 0.16);
  background: linear-gradient(90deg, rgba(254, 242, 242, 0.45) 0%, rgba(255, 255, 255, 0.95) 36%);
}

.portfolio_cut_loss_step__left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.portfolio_cut_loss_step__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
  background: #002141;
}

.portfolio_cut_loss_step--now .portfolio_cut_loss_step__num {
  background: #dc2626;
}

.portfolio_cut_loss_step__lbl {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.portfolio_cut_loss_step__body {
  min-width: 0;
}

.portfolio_cut_loss_step__trade {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #334155;
}

.portfolio_cut_loss_step__trade strong {
  font-weight: 800;
  color: #002141;
}

.portfolio_cut_loss_step__price {
  color: #002141;
}

.portfolio_cut_loss_step__upside {
  margin: 4px 0 0;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_cut_loss_step__metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 8px;
}

.portfolio_cut_loss_metric {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.portfolio_cut_loss_metric__lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #94a3b8;
}

.portfolio_cut_loss_metric__val {
  font-size: 12px;
  font-weight: 800;
  color: #334155;
}

.portfolio_cut_loss_step__tag {
  justify-self: end;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

.portfolio_cut_prob--spot {
  color: #64748b;
  background: rgba(100, 116, 139, 0.1);
}

.portfolio_cut_prob--hi {
  color: #15803d;
  background: rgba(34, 197, 94, 0.12);
}

.portfolio_cut_prob--md {
  color: #b45309;
  background: rgba(245, 158, 11, 0.14);
}

.portfolio_cut_prob--lo {
  color: #64748b;
  background: rgba(100, 116, 139, 0.1);
}

.portfolio_cut_prob--muted {
  color: #94a3b8;
  background: rgba(148, 163, 184, 0.12);
}

.portfolio_cut_loss_plan__stop {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(254, 226, 226, 0.45);
  border: 1px solid rgba(220, 38, 38, 0.18);
}

.portfolio_cut_loss_plan__stop_icon {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1.2;
}

.portfolio_cut_loss_plan__stop_text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  line-height: 1.45;
  color: #7f1d1d;
}

.portfolio_cut_loss_plan__stop_text strong {
  font-weight: 800;
  color: #b91c1c;
}

.portfolio_cut_loss_plan__stop_text span {
  color: #991b1b;
}

@media (max-width: 640px) {
  .portfolio_cut_loss_plan {
    padding: 14px 14px;
  }

  .portfolio_cut_loss_plan__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .portfolio_cut_loss_step {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .portfolio_cut_loss_step__tag {
    justify-self: start;
  }
}

.portfolio_action_plan--avg {
  background: linear-gradient(160deg, #eff6ff 0%, #ffffff 65%);
  border-color: rgba(59, 130, 246, 0.22);
}

.portfolio_action_plan__title {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  letter-spacing: 0.01em;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_action_plan__intro,
.portfolio_action_plan__muted {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.55;
  color: #64748b;
}

.portfolio_action_plan__subhead {
  margin: 12px 0 8px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #002141;
}

.portfolio_action_plan__metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(148px, 1fr));
  gap: 10px;
  margin-bottom: 4px;
}

.portfolio_action_plan__metrics > div {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow:
    0 1px 4px rgba(0, 33, 65, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.portfolio_action_plan--buy .portfolio_action_plan__metrics > div {
  background: #f0fdf4;
  border-color: rgba(16, 185, 129, 0.14);
}

.portfolio_action_plan--avg .portfolio_action_plan__metrics > div {
  background: #f0f9ff;
  border-color: rgba(59, 130, 246, 0.14);
}

.portfolio_action_plan--cut .portfolio_action_plan__metrics > div {
  background: #fff7ed;
  border-color: rgba(249, 115, 22, 0.14);
}

.portfolio_action_plan--profit .portfolio_action_plan__metrics > div {
  background: #fffbeb;
  border-color: rgba(245, 158, 11, 0.16);
}

.portfolio_action_plan--hold .portfolio_action_plan__metrics > div {
  background: #f8fafc;
  border-color: rgba(100, 116, 139, 0.1);
}

.portfolio_action_plan--trade .portfolio_action_plan__metrics > div {
  background: #f8fafc;
  border-color: rgba(0, 33, 65, 0.08);
}

.portfolio_action_plan__metrics span {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: none;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
}

.portfolio_action_plan__metrics strong {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.25;
}

.portfolio_action_plan__foot {
  margin: 12px 0 0;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 33, 65, 0.08);
  font-size: 12px;
  color: #64748b;
}

.portfolio_lh_phase_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.portfolio_lh_phase_row {
  display: grid;
  grid-template-columns: 72px 1fr auto;
  gap: 8px 12px;
  align-items: start;
  font-size: 12px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 8px;
  border: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_lh_phase_lbl {
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  color: #64748b;
}

.portfolio_lh_phase_body {
  color: #334155;
  line-height: 1.5;
}

.portfolio_lh_price {
  font-weight: 700;
  color: #002141;
}

.portfolio_lh_muted {
  font-size: 11px;
  color: #94a3b8;
}

.portfolio_lh_prob {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .portfolio_lh_phase_row {
    grid-template-columns: 1fr;
  }

  .portfolio_lh_prob {
    padding-left: 0;
  }
}

/* AI expert view */
.portfolio_expert_view {
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #1e293b;
  font-size: 15px;
}

.portfolio_action_section .portfolio_dashboard__detail_body {
  color: #1e293b;
  font-size: 15px;
}

.portfolio_expert_section {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.04);
}

.portfolio_expert_section__title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: none;
  color: #002141;
  display: flex;
  align-items: center;
  gap: 8px;
}

.portfolio_expert_section__icon {
  font-size: 17px;
  line-height: 1;
  flex-shrink: 0;
}

.portfolio_expert_section__text {
  margin: 0;
  font-size: 15px;
  line-height: 1.75;
  color: #1e293b;
}

/* SIHO score cards (replaces progress bars) */
.portfolio_siho_scores_panel {
  background: linear-gradient(160deg, #f8fafc 0%, #ffffff 100%);
}

.portfolio_siho_scores_grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.portfolio_siho_score_card {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 14px 12px;
  text-align: center;
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);
}

.portfolio_siho_score_card.is_combined {
  background: linear-gradient(145deg, #fff8f4 0%, #ffffff 100%);
  border-color: rgba(227, 88, 52, 0.2);
  box-shadow: 0 2px 10px rgba(227, 88, 52, 0.08);
}

.portfolio_siho_score_card__lbl {
  display: block;
  font-size: 13px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
  color: #334155;
  margin-bottom: 8px;
}

.portfolio_siho_score_card__val {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 3px;
  line-height: 1;
}

.portfolio_siho_score_card__val strong {
  font-size: 26px;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.portfolio_siho_score_card__val small {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_siho_score_card.is_high .portfolio_siho_score_card__val strong {
  color: #16a34a;
}

.portfolio_siho_score_card.is_mid .portfolio_siho_score_card__val strong {
  color: #d97706;
}

.portfolio_siho_score_card.is_low .portfolio_siho_score_card__val strong {
  color: #dc2626;
}

.portfolio_siho_score_card.is_combined .portfolio_siho_score_card__val strong {
  color: #e35834;
}

.portfolio_siho_score_card.is_muted .portfolio_siho_score_card__val strong {
  color: #94a3b8;
}

@media (max-width: 768px) {
  .portfolio_siho_scores_grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* Stock deep dive — collapsible dropdown sections */
.portfolio_analysis_stack {
  margin-top: 4px;
  padding-top: 0;
  border-top: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.portfolio_analysis_stack__title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: none;
  color: #002141;
  display: flex;
  align-items: center;
  gap: 8px;
}

.portfolio_analysis_stack__icon {
  font-size: 18px;
  line-height: 1;
}

.portfolio_analysis_dropdown {
  border: 1px solid rgba(0, 33, 65, 0.1);
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);
}

.portfolio_analysis_dropdown__summary {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  font-family: inherit;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  -webkit-user-select: none;
          user-select: none;
}

.portfolio_analysis_dropdown__summary::-webkit-details-marker {
  display: none;
}

.portfolio_analysis_dropdown[open] .portfolio_analysis_dropdown__summary {
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_analysis_dropdown__icon {
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
}

.portfolio_analysis_dropdown__title {
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  color: #002141;
  text-align: left;
}

.portfolio_analysis_dropdown__chev {
  font-size: 12px;
  color: #94a3b8;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.portfolio_analysis_dropdown[open] .portfolio_analysis_dropdown__chev {
  transform: rotate(180deg);
}

.portfolio_analysis_dropdown__body {
  padding: 12px 14px 14px;
  background: #ffffff;
}

.portfolio_analysis_section {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 33, 65, 0.04);
}

.portfolio_analysis_section__title {
  margin: 0;
  padding: 14px 18px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: none;
  color: #002141;
  background: linear-gradient(180deg, #eef2f7 0%, #f8fafc 100%);
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
}

.portfolio_analysis_section__icon {
  font-size: 17px;
  line-height: 1;
}

.portfolio_analysis_section__body {
  padding: 14px 16px 16px;
  background: #ffffff;
}

.portfolio_analysis_acc {
  margin-bottom: 8px;
  border: 1px solid rgba(0, 33, 65, 0.1);
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);
}

.portfolio_analysis_acc__toggle {
  width: 100%;
  border: none;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.portfolio_analysis_acc__toggle.is_open {
  border-bottom: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_analysis_acc__icon {
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
}

.portfolio_analysis_acc__title {
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  color: #002141;
}

.portfolio_analysis_acc__arrow {
  font-size: 10px;
  color: #94a3b8;
  transition: transform 0.2s ease;
}

.portfolio_analysis_acc__toggle.is_open .portfolio_analysis_acc__arrow {
  transform: rotate(180deg);
}

.portfolio_analysis_acc__body {
  padding: 12px 14px 14px;
  background: #ffffff;
}

.portfolio_analysis_row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: 4px 12px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
  font-size: 15px;
}

.portfolio_analysis_row:last-child {
  border-bottom: none;
}

.portfolio_analysis_row__lbl {
  color: #475569;
  font-weight: 600;
  flex: 1 1 140px;
}

.portfolio_analysis_row__val {
  font-weight: 700;
  color: #0f172a;
  text-align: right;
}

.portfolio_analysis_row__val.is_strong {
  color: #e35834;
}

.portfolio_analysis_note {
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 1.65;
  color: #475569;
}

.portfolio_analysis_insight_grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.portfolio_analysis_insight_card {
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.06);
  border-radius: 10px;
  padding: 10px 12px;
}

.portfolio_analysis_insight_card--wide h5 {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
  letter-spacing: 0.01em;
  color: #002141;
}

.portfolio_analysis_insight_card--wide p {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #1e293b;
}

/* Future outlook — narrative blocks (matches dashboard cards) */
.portfolio_future_outlook {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portfolio_future_outlook__scores {
  padding: 12px 14px;
  background: #fff9f6;
  border-color: rgba(0, 33, 65, 0.07);
}

.portfolio_narrative_grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portfolio_narrative_card {
  background: #fff9f6;
  border: 1px solid rgba(0, 33, 65, 0.07);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);
}

.portfolio_narrative_card__title {
  margin: 0;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 800;
  color: #002141;
  background: #f3eeea;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_narrative_card__body {
  padding: 14px 16px 16px;
  background: #fff9f6;
}

.portfolio_narrative_card__topic {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
  color: #002141;
}

.portfolio_narrative_card__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.portfolio_narrative_card__item {
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_narrative_card__item:first-child {
  padding-top: 0;
}

.portfolio_narrative_card__item:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

.portfolio_narrative_card__line {
  margin: 0;
  font-size: 15px;
  line-height: 1.75;
  color: #1e293b;
  font-weight: 400;
}

.portfolio_narrative_card__note {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.65;
  color: #64748b;
}

.portfolio_narrative__metric {
  font-weight: 700;
  color: #002141;
}

.portfolio_analysis_sr_table_wrap {
  margin-top: 12px;
}

.portfolio_analysis_sr_table_wrap h5 {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
  color: #002141;
}

.portfolio_analysis_sr_table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.portfolio_analysis_sr_table th,
.portfolio_analysis_sr_table td {
  padding: 6px 8px;
  text-align: center;
  border: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_analysis_sr_table th {
  background: #f8fafc;
  font-weight: 700;
  color: #475569;
}

.portfolio_analysis_sr_table td {
  color: #0f172a;
}

.portfolio_analysis_muted {
  color: #94a3b8 !important;
}

/* Industry peers */
.portfolio_peers_panel__industry {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  line-height: 1.45;
}

.portfolio_peers_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.portfolio_peer_card {
  background: #fff9f6;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 14px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 100%;
  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);
}

.portfolio_peer_card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.portfolio_peer_card__identity {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.portfolio_peer_card__code {
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

.portfolio_peer_card__name {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.35;
  word-break: break-word;
}

.portfolio_peer_card__score {
  flex-shrink: 0;
  text-align: right;
  padding: 6px 10px;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_peer_card__score.is_high {
  background: #ecfdf5;
  border-color: rgba(22, 163, 74, 0.2);
}

.portfolio_peer_card__score.is_mid {
  background: #fffbeb;
  border-color: rgba(217, 119, 6, 0.2);
}

.portfolio_peer_card__score.is_low {
  background: #fef2f2;
  border-color: rgba(220, 38, 38, 0.18);
}

.portfolio_peer_card__score_lbl {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 2px;
}

.portfolio_peer_card__score_val {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 2px;
  line-height: 1;
}

.portfolio_peer_card__score_val strong {
  font-size: 18px;
  font-weight: 900;
  color: #002141;
}

.portfolio_peer_card__score.is_high .portfolio_peer_card__score_val strong {
  color: #16a34a;
}

.portfolio_peer_card__score.is_mid .portfolio_peer_card__score_val strong {
  color: #d97706;
}

.portfolio_peer_card__score.is_low .portfolio_peer_card__score_val strong {
  color: #dc2626;
}

.portfolio_peer_card__score_val small {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_peer_card__mcap {
  font-size: 14px;
  font-weight: 700;
  color: #002141;
  padding-top: 2px;
  border-top: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_peer_card__breakdown {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: auto;
}

.portfolio_peer_chip {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.07);
  border-radius: 8px;
  padding: 8px 6px;
  text-align: center;
}

.portfolio_peer_chip__lbl {
  display: block;
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.2;
  margin-bottom: 4px;
}

.portfolio_peer_chip strong {
  font-size: 14px;
  font-weight: 800;
  color: #002141;
}

.portfolio_peer_chip.is_high strong {
  color: #16a34a;
}

.portfolio_peer_chip.is_mid strong {
  color: #d97706;
}

.portfolio_peer_chip.is_low strong {
  color: #dc2626;
}

.portfolio_peer_chip.is_muted strong {
  color: #94a3b8;
}

@media (max-width: 960px) {
  .portfolio_peers_grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 961px) and (max-width: 1100px) {
  .portfolio_peers_grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.portfolio_action_plan--buy {
  background: linear-gradient(160deg, #ecfdf5 0%, #ffffff 60%);
  border-color: rgba(16, 185, 129, 0.22);
}

.portfolio_action_plan--hold {
  background: linear-gradient(160deg, #f1f5f9 0%, #ffffff 60%);
  border-color: rgba(100, 116, 139, 0.15);
}

.portfolio_action_plan--profit {
  background: linear-gradient(160deg, #fffbeb 0%, #ffffff 60%);
  border-color: rgba(245, 158, 11, 0.22);
}

.portfolio_action_plan--trade {
  background: linear-gradient(160deg, #f8fafc 0%, #ffffff 60%);
}

.portfolio_action_rationale {
  margin-top: 0;
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 14px 16px !important;
  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);
}

.portfolio_action_rationale h4 {
  font-size: 15px;
  font-weight: 800;
  text-transform: none;
  letter-spacing: 0.01em;
  color: #002141;
  margin: 0 0 8px;
}

.portfolio_action_rationale p {
  font-size: 15px;
  line-height: 1.65;
  color: #1e293b;
}

.portfolio_dashboard__panel h4 {
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  margin: 0 0 10px;
}

.portfolio_dashboard__panel p {
  font-size: 15px;
  line-height: 1.65;
  color: #1e293b;
}

.portfolio_lh_phase_row {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 33, 65, 0.08);
  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.04);
}

.portfolio_action_section .portfolio_expert_view {
  gap: 14px;
}

.portfolio_action_section .portfolio_analysis_dropdown__body .portfolio_analysis_insight_card {
  background: #f8fafc;
}

/* —— Portfolio stock detail (holdings view) —— */
.portfolio_stock_detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portfolio_stock_detail__summary {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 12px 16px 0;
  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);
}

.portfolio_stock_detail__summary_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
}

.portfolio_stock_detail__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.portfolio_stock_detail__tag {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
}

.portfolio_stock_detail__score_inline {
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 8px;
  background: rgba(227, 88, 52, 0.08);
}

.portfolio_stock_detail__score_cap {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-right: 2px;
}

.portfolio_stock_detail__score_inline strong {
  font-size: 16px;
  font-weight: 800;
  color: #e35834;
  line-height: 1;
}

.portfolio_stock_detail__score_of {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
}

.portfolio_stock_detail__metrics {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid rgba(0, 33, 65, 0.08);
}

.portfolio_stock_detail__metric {
  flex: 1 1;
  min-width: 100px;
  padding: 10px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-right: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_stock_detail__metric:last-child {
  border-right: none;
}

.portfolio_stock_detail__metric span {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.portfolio_stock_detail__metric strong {
  font-size: 14px;
  font-weight: 800;
  color: #002141;
}

.portfolio_stock_detail__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portfolio_stock_detail__insights {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: start;
}

.portfolio_stock_detail__insights > .portfolio_detail_card {
  align-self: start;
  height: auto;
  min-height: 0;
}

.portfolio_detail_card {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 10px rgba(0, 33, 65, 0.04);
}

.portfolio_siho_scores.portfolio_detail_card {
  padding-bottom: 14px;
  display: flex;
  flex-direction: column;
  align-self: start;
}

.portfolio_detail_card__title {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: none;
  color: #002141;
  margin: 0 0 10px;
}

.portfolio_detail_card__text {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: #1e293b;
}

.portfolio_chart_panel--tight {
  padding: 12px 14px 8px;
}

.portfolio_chart_panel--tight .portfolio_chart_panel__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px 12px;
  margin-bottom: 6px;
}

.portfolio_chart_panel--tight .portfolio_detail_card__title {
  margin: 0;
}

.portfolio_chart_panel--tight .portfolio_chart_panel__sub {
  margin: 0;
  font-size: 11px;
  color: #94a3b8;
}

.portfolio_chart.is_compact {
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
}

.portfolio_chart.is_compact .portfolio_chart__legend {
  margin-bottom: 2px;
  padding-left: 0;
}

.portfolio_chart.is_compact .portfolio_chart__svg {
  width: 100%;
  height: auto;
  max-height: 168px;
  display: block;
}

.portfolio_panel_title {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #002141;
  margin: 0 0 12px;
}

.portfolio_detail_stack {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.portfolio_siho_scores__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.portfolio_siho_scores__item {
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.portfolio_siho_scores__score_line {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.portfolio_siho_scores__grid.is_row {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  flex: 0 0 auto;
}

.portfolio_siho_scores__grid.is_row .portfolio_siho_scores__item.is_highlight {
  grid-column: auto;
  background: linear-gradient(145deg, #fff8f4 0%, #ffffff 100%);
  border-color: rgba(227, 88, 52, 0.22);
  box-shadow: 0 2px 10px rgba(227, 88, 52, 0.08);
}

.portfolio_impact_card.portfolio_detail_card {
  align-self: start;
  height: auto;
}

.portfolio_siho_scores__item.is_highlight {
  grid-column: 1 / -1;
  background: #fff8f4;
  border-color: rgba(227, 88, 52, 0.2);
}

.portfolio_siho_scores__label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
}

.portfolio_siho_scores__grid.is_row .portfolio_siho_scores__val {
  font-size: 18px;
}

.portfolio_siho_scores__val {
  font-size: 22px;
  color: #002141;
  line-height: 1;
}

.portfolio_siho_scores__of {
  font-size: 12px;
  color: #94a3b8;
}

.portfolio_impact_card__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.portfolio_impact_card__chip {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(0, 33, 65, 0.08);
  color: #002141;
}

.portfolio_impact_card__chip.is_muted {
  background: #f1f5f9;
  color: #64748b;
}

.portfolio_impact_card__metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
  margin-bottom: 12px;
}

.portfolio_impact_card.portfolio_detail_card .portfolio_impact_card__metrics > div {
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.06);
  border-radius: 10px;
  padding: 10px 12px;
}

.portfolio_impact_card__metrics > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.portfolio_impact_card__metrics span {
  font-size: 13px;
  color: #475569;
  font-weight: 600;
}

.portfolio_impact_card__metrics strong {
  font-size: 16px;
  color: #0f172a;
}

.portfolio_impact_summary {
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-left: 3px solid #e35834;
  border-radius: 10px;
  padding: 14px 18px;
}

.portfolio_impact_summary__text {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.85;
  color: #1e293b;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

.portfolio_impact_summary__highlight {
  font-weight: 800;
  color: #002141;
}

.portfolio_chart_panel__sub {
  margin: -6px 0 14px;
  font-size: 14px;
  color: #475569;
}

.portfolio_chart {
  background: #f8fafc;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 12px 12px 8px;
}

.portfolio_chart__plot {
  width: 100%;
}

.portfolio_chart__legend {
  display: flex;
  gap: 18px;
  margin-bottom: 8px;
  padding-left: 4px;
}

.portfolio_chart__legend_item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.portfolio_chart__legend_dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.portfolio_chart__legend_item.is_stock .portfolio_chart__legend_dot {
  background: #3b82f6;
}

.portfolio_chart__legend_item.is_nifty .portfolio_chart__legend_dot {
  background: transparent;
  border: 2px dashed #22c55e;
  border-radius: 2px;
  width: 14px;
  height: 0;
}

.portfolio_chart__svg {
  width: 100%;
  height: auto;
  display: block;
}

.portfolio_chart__grid {
  stroke: rgba(148, 163, 184, 0.22);
  stroke-width: 1;
}

.portfolio_chart__zero {
  stroke: rgba(100, 116, 139, 0.45);
  stroke-width: 1.25;
  stroke-dasharray: 6 5;
}

.portfolio_chart__area {
  pointer-events: none;
}

.portfolio_chart__line.is_stock {
  stroke: #2563eb;
  stroke-width: 3.25;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.portfolio_chart.is_premium .portfolio_chart__line.is_stock {
  stroke-width: 3.5;
}

.portfolio_chart__line.is_nifty {
  stroke: #059669;
  stroke-width: 2.75;
  stroke-dasharray: 10 7;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.92;
}

.portfolio_chart__point.is_stock {
  fill: #2563eb;
  stroke: #ffffff;
  stroke-width: 2.5;
  pointer-events: none;
}

.portfolio_chart__point.is_nifty {
  fill: #059669;
  stroke: #ffffff;
  stroke-width: 2;
  pointer-events: none;
}

.portfolio_chart__point_halo.is_stock {
  fill: rgba(37, 99, 235, 0.14);
  stroke: none;
  pointer-events: none;
}

.portfolio_chart__hit {
  cursor: pointer;
}

.portfolio_chart__hit_dot {
  cursor: pointer;
  pointer-events: all;
}

.portfolio_chart__period_hit {
  pointer-events: all;
}

.portfolio_chart__hover_layer {
  pointer-events: none;
}

.portfolio_chart__axis_label {
  fill: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.portfolio_chart__axis_label.is_period {
  fill: #334155;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.portfolio_chart__marker {
  stroke: rgba(37, 99, 235, 0.35);
  stroke-width: 1.5;
  stroke-dasharray: 5 5;
}

.portfolio_chart__tooltip {
  fill: rgba(15, 23, 42, 0.94);
  stroke: rgba(255, 255, 255, 0.08);
  stroke-width: 1;
  filter: drop-shadow(0 8px 20px rgba(15, 23, 42, 0.22));
}

/* Reports page */
.portfolio_reports_page {
  padding: 20px 22px 28px;
  width: 100%;
  box-sizing: border-box;
}

.portfolio_reports_hero {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  width: 100%;
  padding: 22px 24px;
  background: linear-gradient(135deg, #fff9f6 0%, #ffffff 55%);
  border: 1px solid rgba(241, 86, 35, 0.18);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 33, 65, 0.06);
  margin-bottom: 20px;
}

.portfolio_reports_hero__copy {
  flex: 1 1;
  min-width: 200px;
}

.portfolio_reports_hero__title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 800;
  color: #002141;
  letter-spacing: -0.02em;
}

.portfolio_reports_hero__sub {
  margin: 0;
  font-size: 15px;
  line-height: 1.55;
  color: #475569;
}

.portfolio_reports_hero__btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 22px;
  font-size: 15px;
  flex-shrink: 0;
}

.portfolio_reports_stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.portfolio_reports_stat {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);
}

.portfolio_reports_stat__lbl {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 6px;
}

.portfolio_reports_stat__val {
  display: block;
  font-size: 18px;
  font-weight: 800;
  color: #002141;
  line-height: 1.2;
}

.portfolio_reports_stat__val.pos {
  color: #16a34a;
}

.portfolio_reports_stat__val.neg {
  color: #dc2626;
}

.portfolio_reports_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
}

.portfolio_reports_card {
  background: #ffffff;
  border: 1px solid rgba(0, 33, 65, 0.08);
  border-radius: 14px;
  padding: 20px 22px;
  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.05);
}

.portfolio_reports_card--tip {
  background: #f8fafc;
}

.portfolio_reports_card__title {
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 800;
  color: #002141;
}

.portfolio_reports_list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.portfolio_reports_list li {
  position: relative;
  padding: 10px 0 10px 22px;
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
  border-bottom: 1px solid rgba(0, 33, 65, 0.06);
}

.portfolio_reports_list li:last-child {
  border-bottom: none;
}

.portfolio_reports_list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 16px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f15623;
}

.portfolio_reports_steps {
  margin: 0 0 16px;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.65;
  color: #475569;
}

.portfolio_reports_steps li + li {
  margin-top: 8px;
}

.portfolio_reports_card__btn {
  width: 100%;
  justify-content: center;
}

@media (max-width: 900px) {
  .portfolio_reports_stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .portfolio_reports_grid {
    grid-template-columns: 1fr;
  }

  .portfolio_reports_hero__btn {
    width: 100%;
    justify-content: center;
  }
}

/* ── Print report (Download Report) ───────────────────────────── */
.portfolio_print_report {
  display: none;
}

.portfolio_print__header {
  text-align: center;
  padding: 0 0 20px;
  margin-bottom: 24px;
  border-bottom: 2px solid #002141;
}

.portfolio_print__logo {
  display: block;
  margin: 0 auto 16px;
  max-height: 72px;
  width: auto;
}

.portfolio_print__title {
  margin: 0 0 6px;
  font-size: 26px;
  font-weight: 800;
  color: #002141;
  letter-spacing: -0.02em;
}

.portfolio_print__meta {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 600;
  color: #f15623;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.portfolio_print__date {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.portfolio_print__section {
  margin-bottom: 28px;
  page-break-inside: avoid;
}

.portfolio_print__section_title {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 800;
  color: #002141;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.portfolio_print__subsection_title {
  margin: 18px 0 10px;
  font-size: 13px;
  font-weight: 800;
  color: #334155;
}

.portfolio_print__metric_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 16px;
}

.portfolio_print__metric {
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.portfolio_print__metric_lbl {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 4px;
}

.portfolio_print__metric_val {
  display: block;
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.portfolio_print__metric_val.is_pos {
  color: #16a34a;
}

.portfolio_print__metric_val.is_neg {
  color: #dc2626;
}

.portfolio_print__metric_val.is_theme {
  color: #f15623;
}

.portfolio_print__summary,
.portfolio_print__note {
  margin: 14px 0 0;
  font-size: 13px;
  line-height: 1.65;
  color: #334155;
}

.portfolio_print__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.portfolio_print__table th {
  text-align: left;
  padding: 10px 12px;
  background: #002141;
  color: #ffffff;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.portfolio_print__table td {
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
  vertical-align: top;
}

.portfolio_print__table tbody tr:nth-child(even) td {
  background: #f8fafc;
}

.portfolio_print__num {
  font-weight: 800;
  white-space: nowrap;
}

/* Holdings table — minimal report style */
.portfolio_print__section--holdings {
  margin-bottom: 32px;
}

.portfolio_print__holdings_title {
  margin: 0 0 18px;
  padding: 0;
  border: none;
  font-size: 15px;
  font-weight: 800;
  color: #002141;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.portfolio_print__holdings_table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  line-height: 1.4;
}

.portfolio_print__holdings_table thead tr {
  border-bottom: 1px solid #e2e8f0;
}

.portfolio_print__holdings_table th {
  padding: 10px 0 12px;
  background: transparent;
  color: #94a3b8;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  text-align: left;
  vertical-align: bottom;
}

.portfolio_print__holdings_th_score,
.portfolio_print__holdings_score_cell {
  text-align: right;
}

.portfolio_print__holdings_table td {
  padding: 14px 0;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: transparent;
  vertical-align: middle;
}

.portfolio_print__holdings_table tbody tr:nth-child(even) td {
  background: transparent;
}

.portfolio_print__holdings_table tbody tr:last-child td {
  border-bottom: none;
}

.portfolio_print__holdings_name {
  color: #002141;
  font-weight: 500;
  font-size: 14px;
  padding-right: 16px;
}

.portfolio_print__holdings_action {
  color: #64748b;
  font-weight: 500;
  font-size: 13px;
  padding-right: 16px;
}

.portfolio_print__holdings_score {
  display: inline-block;
  white-space: nowrap;
}

.portfolio_print__holdings_score strong {
  font-weight: 700;
  color: #002141;
  font-size: 14px;
}

.portfolio_print__holdings_score_suffix {
  color: #94a3b8;
  font-weight: 500;
  font-size: 13px;
}

.portfolio_print__holdings_score_muted {
  color: #94a3b8;
  font-weight: 500;
}

.portfolio_print__phase_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.portfolio_print__phase_card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  background: #ffffff;
}

.portfolio_print__phase_name {
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 800;
  color: #002141;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.portfolio_print__list {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  line-height: 1.55;
  color: #334155;
}

.portfolio_print__list li + li {
  margin-top: 6px;
}

.portfolio_print__footer_box {
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff9f6;
}

.portfolio_print__foot {
  margin-top: 32px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
  font-size: 10px;
  color: #94a3b8;
  text-align: center;
}

@media print {
  @page {
    margin: 14mm 12mm;
    size: A4;
  }

  body {
    background: #ffffff !important;
  }

  .no_print,
  .portfolio_dashboard__sidebar,
  .portfolio_dashboard__header_fixed,
  .portfolio_dashboard__scroll,
  .portfolio_dashboard__main {
    display: none !important;
  }

  .portfolio_print_report {
    display: block !important;
    width: 100%;
    max-width: none;
    padding: 0;
    background: #ffffff;
    color: #0f172a;
  }

  .portfolio_print__phase_grid,
  .portfolio_print__metric_grid {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .portfolio_print__section {
    page-break-inside: avoid;
  }

  .portfolio_print__holdings_table thead tr,
  .portfolio_print__holdings_table td {
    print-color-adjust: exact;
  }

  .portfolio_print__holdings_table th {
    background: transparent !important;
    color: #94a3b8 !important;
  }

  .portfolio_print__holdings_table tbody tr:nth-child(even) td {
    background: transparent !important;
  }
}

.portfolio_chart__tooltip_title {
  fill: #94a3b8;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.portfolio_chart__tooltip_stock {
  fill: #93c5fd;
  font-size: 11px;
  font-weight: 700;
}

.portfolio_chart__tooltip_nifty {
  fill: #6ee7b7;
  font-size: 11px;
  font-weight: 700;
}

.portfolio_chart__empty {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/portfolio_dashboard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;EACzC,8CAA8C;EAC9C,kDAAkD;EAClD,yBAAyB;;EAEzB,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,4CAA4C;EAC5C,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf;;;wBAGsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf;;mBAEiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB;;;;yBAIuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uEAAuE;AACvE;EACE,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB;;qCAEmC;EACnC,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,yEAAyE;EACzE,2CAA2C;AAC7C;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB;;qCAEmC;EACnC,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,0EAA0E;EAC1E,yBAAyB;EACzB;;qCAEmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,0EAA0E;EAC1E,yBAAyB;EACzB;;qCAEmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,0EAA0E;EAC1E,0CAA0C;EAC1C,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb;;gBAEc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;EAC3C,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,0EAA0E;EAC1E,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yDAAyD;EACzD,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yDAAyD;EACzD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE;;;YAGQ;IACR,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,8CAA8C;EAChD;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,MAAM;AACR;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,oEAAoE;AACtE;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C;;;;wBAIsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;0BAEwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C;;;;wBAIsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAY;EACZ,+BAA+B;EAC/B,UAAU;EACV,MAAM;AACR;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAY;EACZ,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,SAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,SAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB;;;oBAGkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd;;+BAE6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;EAC1B,8CAA8C;EAC9C,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C;;;;;wBAKsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,4DAA4D;EAC5D,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,QAAQ;AACV;;AAEA,mDAAmD;AACnD;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,yCAAyC;EACzC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,QAAQ;AACV;;AAEA,+DAA+D;AAC/D;EACE,uBAAuB;EACvB,4DAA4D;EAC5D,2CAA2C;EAC3C,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;EACtB;;;;;wBAKsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd;;oCAEkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC;;oCAEkC;AACpC;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,4BAA4B;EAC5B;;qCAEmC;AACrC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA,iCAAiC;AACjC;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,4DAA4D;EAC5D,qCAAqC;AACvC;;AAEA;EACE,4DAA4D;EAC5D,qCAAqC;AACvC;;AAEA;;EAEE,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;;0CAEwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;EAEE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,gGAAgG;EAChG,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,+FAA+F;AACjG;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB;;2CAEyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,6DAA6D;EAC7D,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,6DAA6D;EAC7D,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,4DAA4D;EAC5D,uCAAuC;AACzC;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gDAAgD;EAChD,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,eAAe;EACf,sDAAsD;AACxD;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,4DAA4D;EAC5D,yCAAyC;EACzC,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,oEAAoE;AACpE;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB","sourcesContent":[".portfolio_dashboard .pos {\n  color: #16a34a;\n}\n\n.portfolio_dashboard .neg {\n  color: #dc2626;\n}\n\n.portfolio_dashboard strong.pos,\n.portfolio_dashboard span.pos,\n.portfolio_dashboard .portfolio_holding_card__stat_value.pos {\n  color: #16a34a;\n}\n\n.portfolio_dashboard strong.neg,\n.portfolio_dashboard span.neg,\n.portfolio_dashboard .portfolio_holding_card__stat_value.neg {\n  color: #dc2626;\n}\n\n.portfolio_dashboard__detail_kpis strong.pos,\n.portfolio_stock_detail__metric strong.pos,\n.portfolio_action_section .portfolio_dashboard__detail_kpis > span strong.pos,\n.portfolio_action_plan__metrics strong.pos {\n  color: #16a34a;\n}\n\n.portfolio_dashboard__detail_kpis strong.neg,\n.portfolio_stock_detail__metric strong.neg,\n.portfolio_action_section .portfolio_dashboard__detail_kpis > span strong.neg,\n.portfolio_action_plan__metrics strong.neg {\n  color: #dc2626;\n}\n\n.portfolio_analysis_row__val.pos {\n  color: #16a34a;\n}\n\n.portfolio_analysis_row__val.neg {\n  color: #dc2626;\n}\n\n.portfolio_dashboard {\n  --dash-sidebar-w: 268px;\n  --dash-main-bg: #fff8f4;\n  height: 100vh;\n  min-height: 100vh;\n  display: flex;\n  background: var(--dash-main-bg);\n  color: var(--text);\n  overflow: hidden;\n}\n\n/* ── Premium sidebar (#002141) ─────────────────────────────────── */\n.portfolio_dashboard__sidebar.sidebar_premium {\n  --sidebar-bg: #002141;\n  --sidebar-bg-soft: #001a33;\n  --sidebar-text: #ffffff;\n  --sidebar-muted: rgba(255, 255, 255, 0.72);\n  --sidebar-border: rgba(255, 255, 255, 0.12);\n  --sidebar-hover: rgba(255, 255, 255, 0.1);\n  --sidebar-active-bg: rgba(255, 255, 255, 0.14);\n  --sidebar-active-border: rgba(255, 255, 255, 0.22);\n  --sidebar-accent: #e35834;\n\n  width: var(--dash-sidebar-w);\n  height: 100vh;\n  max-height: 100vh;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--sidebar-bg);\n  border-right: 1px solid #001530;\n  box-shadow: 4px 0 20px rgba(0, 33, 65, 0.35);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 30;\n  overflow: hidden;\n}\n\n.sidebar_premium__brand {\n  flex-shrink: 0;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  border-bottom: 1px solid var(--sidebar-border);\n}\n\n.sidebar_premium__logo {\n  display: block;\n  width: auto;\n  max-width: 92%;\n  max-height: 68px;\n  height: auto;\n  margin: 0 auto;\n  padding: 14px 14px 12px;\n  border-radius: 0;\n  background: var(--sidebar-bg);\n  box-shadow: none;\n  object-fit: contain;\n  box-sizing: border-box;\n}\n\n.sidebar_premium__nav {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 4px 10px 2px;\n}\n\n.sidebar_premium__nav_group + .sidebar_premium__nav_group {\n  margin-top: 0;\n}\n\n.sidebar_premium__section {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--sidebar-muted);\n  padding: 8px 10px 4px;\n}\n\n.sidebar_premium__section:first-child {\n  padding-top: 2px;\n}\n\n.sidebar_premium__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  padding: 7px 10px;\n  margin-bottom: 2px;\n  border-radius: 10px;\n  font-size: 14.5px;\n  font-weight: 500;\n  color: var(--sidebar-text);\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    color 0.2s ease,\n    box-shadow 0.2s ease;\n  position: relative;\n}\n\n.sidebar_premium__item::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%) scaleY(0);\n  width: 4px;\n  height: 68%;\n  border-radius: 0 4px 4px 0;\n  background: var(--sidebar-accent);\n  box-shadow: none;\n  transition: transform 0.2s ease;\n}\n\n.sidebar_premium__item:hover {\n  background: var(--sidebar-hover);\n  color: #ffffff;\n}\n\n.sidebar_premium__item.is_active {\n  background: var(--sidebar-active-bg);\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: inset 0 0 0 1px var(--sidebar-active-border);\n}\n\n.sidebar_premium__item.is_active::before {\n  transform: translateY(-50%) scaleY(1);\n}\n\n.sidebar_premium__item_left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.sidebar_nav__icon_wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.1);\n  transition: background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.sidebar_nav__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--sidebar-muted);\n  transition: color 0.2s ease;\n}\n\n.sidebar_nav__icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.sidebar_premium__item:hover .sidebar_nav__icon_wrap {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.sidebar_premium__item:hover .sidebar_nav__icon {\n  color: #ffffff;\n}\n\n.sidebar_premium__item.is_active .sidebar_nav__icon_wrap {\n  background: rgba(227, 88, 52, 0.45);\n  box-shadow: 0 0 0 1px rgba(227, 88, 52, 0.55);\n}\n\n.sidebar_premium__item.is_active .sidebar_nav__icon {\n  color: #ffffff;\n}\n\n.sidebar_premium__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar_premium__badge {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  min-width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.sidebar_premium__badge.is_active {\n  background: var(--sidebar-accent);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(227, 88, 52, 0.4);\n}\n\n.sidebar_premium__badge.is_count {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.88);\n  min-width: auto;\n  padding: 0 4px;\n}\n\n.sidebar_premium__item.is_active .sidebar_premium__badge.is_count {\n  color: #ffffff;\n  font-weight: 800;\n}\n\n.sidebar_premium__badge.is_danger {\n  background: rgba(127, 29, 29, 0.55);\n  color: #ffffff;\n}\n\n.sidebar_premium__badge.is_success {\n  background: rgba(20, 83, 45, 0.55);\n  color: #ffffff;\n}\n\n.sidebar_premium__badge.is_muted {\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n}\n\n.sidebar_premium__footer {\n  flex-shrink: 0;\n  padding: 10px 10px 14px;\n  border-top: 1px solid var(--sidebar-border);\n  background: var(--sidebar-bg);\n}\n\n.sidebar_premium__logout {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  padding: 10px 10px;\n  border-radius: 10px;\n  font-size: 14.5px;\n  font-weight: 500;\n  color: var(--sidebar-muted);\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    color 0.2s ease;\n}\n\n.sidebar_premium__logout:hover {\n  background: var(--sidebar-hover);\n  color: #ffffff;\n}\n\n.sidebar_premium__logout:hover .sidebar_nav__icon {\n  color: #ffffff;\n}\n\n.sidebar_premium__foot {\n  flex-shrink: 0;\n  padding: 10px 10px 12px;\n  border-top: 1px solid var(--sidebar-border);\n  background: var(--sidebar-bg);\n}\n\n.sidebar_premium__foot_card {\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--sidebar-bg-soft);\n  border: 1px solid var(--sidebar-border);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.sidebar_premium__foot_lbl {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sidebar-muted);\n  margin-bottom: 6px;\n}\n\n.sidebar_premium__foot_val {\n  font-size: 19px;\n  font-weight: 800;\n  color: #ffffff;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n}\n\n.sidebar_premium__foot_sub {\n  font-size: 11px;\n  margin-top: 5px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.sidebar_premium__foot_trend {\n  font-size: 12px;\n  line-height: 1;\n}\n\n.sidebar_premium__foot_sub.pos {\n  color: #86efac;\n}\n\n.sidebar_premium__foot_sub.neg {\n  color: #fca5a5;\n}\n\n.portfolio_dashboard__main {\n  flex: 1;\n  min-width: 0;\n  margin-left: var(--dash-sidebar-w);\n  height: 100vh;\n  max-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n  background: var(--dash-main-bg);\n}\n\n.portfolio_dashboard__header_fixed {\n  flex-shrink: 0;\n  z-index: 15;\n  padding: 16px 20px 14px;\n  background: var(--dash-main-bg);\n  border-bottom: 1px solid rgba(227, 88, 52, 0.12);\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);\n}\n\n.portfolio_dashboard__scroll {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 20px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(227, 88, 52, 0.35) transparent;\n}\n\n.portfolio_dashboard__topbar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.portfolio_dashboard__title {\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  margin: 0;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.portfolio_dashboard__title--theme {\n  color: var(--theme, #f15623);\n}\n\n.portfolio_dashboard__search_wrap {\n  flex: 1;\n  min-width: 220px;\n  max-width: 560px;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.portfolio_dashboard__search_icon {\n  position: absolute;\n  left: 14px;\n  color: var(--faint);\n  pointer-events: none;\n}\n\n.portfolio_dashboard__search {\n  width: 100%;\n  height: 42px;\n  padding: 0 16px 0 42px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--text);\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.portfolio_dashboard__search::placeholder {\n  color: var(--faint);\n}\n\n.portfolio_dashboard__search:hover {\n  border-color: var(--theme-border);\n}\n\n.portfolio_dashboard__search:focus {\n  outline: none;\n  border-color: var(--theme);\n  box-shadow: 0 0 0 3px var(--theme-glow);\n}\n\n.portfolio_dashboard__search_dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 50;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.12);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 33, 65, 0.12);\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 6px;\n}\n\n.portfolio_dashboard__search_empty {\n  padding: 14px 12px;\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n}\n\n.portfolio_dashboard__search_result {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: background 0.15s ease;\n}\n\n.portfolio_dashboard__search_result:hover,\n.portfolio_dashboard__search_result:focus {\n  outline: none;\n  background: #fff8f4;\n}\n\n.portfolio_dashboard__search_result_main {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  min-width: 0;\n}\n\n.portfolio_dashboard__search_result_name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #002141;\n  line-height: 1.3;\n}\n\n.portfolio_dashboard__search_result_meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 10px;\n}\n\n.portfolio_dashboard__search_result_action {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: capitalize;\n}\n\n.portfolio_dashboard__search_result_section {\n  font-size: 11px;\n  font-weight: 700;\n  color: #e35834;\n}\n\n.portfolio_dashboard__search_result_codes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #e35834;\n}\n\n.portfolio_dashboard__search_result_codes span {\n  padding: 2px 8px;\n  background: rgba(227, 88, 52, 0.08);\n  border-radius: 4px;\n}\n\n.portfolio_dashboard__actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n  margin-left: auto;\n  align-items: center;\n}\n\n.portfolio_dashboard__btn {\n  height: 42px;\n  padding: 0 18px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.portfolio_dashboard__btn_secondary {\n  border: 1px solid var(--border);\n  background: #ffffff;\n  color: var(--text);\n}\n\n.portfolio_dashboard__btn_secondary:hover {\n  border-color: var(--theme-border);\n  background: var(--theme-light);\n  color: var(--theme);\n}\n\n.portfolio_dashboard__btn_primary {\n  border: 1px solid var(--theme);\n  background: var(--theme);\n  color: #ffffff;\n  box-shadow: 0 4px 14px var(--theme-glow);\n}\n\n.portfolio_dashboard__btn_primary:hover {\n  background: var(--theme-hover);\n  border-color: var(--theme-hover);\n}\n\n.portfolio_dashboard__kpis {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.portfolio_dashboard__kpis--top {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.portfolio_overview__kpis {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.portfolio_dashboard__kpi {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 14px 16px;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);\n}\n\n.portfolio_dashboard__kpi.theme {\n  background: #ffedd5;\n  border-color: rgba(234, 88, 12, 0.28);\n}\n\n.portfolio_dashboard__kpi.theme .portfolio_dashboard__kpi_lbl {\n  color: #c2410c;\n}\n\n.portfolio_dashboard__kpi.theme .portfolio_dashboard__kpi_val {\n  color: #9a3412;\n}\n\n.portfolio_dashboard__kpi.theme .portfolio_dashboard__kpi_sub {\n  color: #b45309;\n}\n\n.portfolio_dashboard__kpi.green {\n  background: #bbf7d0;\n  border-color: rgba(22, 163, 74, 0.3);\n}\n\n.portfolio_dashboard__kpi.green .portfolio_dashboard__kpi_lbl {\n  color: #166534;\n}\n\n.portfolio_dashboard__kpi.green .portfolio_dashboard__kpi_val {\n  color: #14532d;\n}\n\n.portfolio_dashboard__kpi.green .portfolio_dashboard__kpi_sub {\n  color: #15803d;\n}\n\n.portfolio_dashboard__kpi.emerald {\n  background: #a7f3d0;\n  border-color: rgba(5, 150, 105, 0.32);\n}\n\n.portfolio_dashboard__kpi.emerald .portfolio_dashboard__kpi_lbl {\n  color: #047857;\n}\n\n.portfolio_dashboard__kpi.red {\n  background: #fecaca;\n  border-color: rgba(220, 38, 38, 0.28);\n}\n\n.portfolio_dashboard__kpi.orange {\n  background: #fde68a;\n  border-color: rgba(217, 119, 6, 0.3);\n}\n\n.portfolio_dashboard__kpi.orange .portfolio_dashboard__kpi_lbl {\n  color: #b45309;\n}\n\n.portfolio_dashboard__kpi.orange .portfolio_dashboard__kpi_val {\n  color: #92400e;\n}\n\n.portfolio_dashboard__kpi.blue {\n  background: #bfdbfe;\n  border-color: rgba(37, 99, 235, 0.3);\n}\n\n.portfolio_dashboard__kpi.blue .portfolio_dashboard__kpi_lbl {\n  color: #1d4ed8;\n}\n\n.portfolio_dashboard__kpi.blue .portfolio_dashboard__kpi_val {\n  color: #1e3a8a;\n}\n\n.portfolio_dashboard__kpi.purple {\n  background: #ddd6fe;\n  border-color: rgba(124, 58, 237, 0.28);\n}\n\n.portfolio_dashboard__kpi.purple .portfolio_dashboard__kpi_lbl {\n  color: #6d28d9;\n}\n\n.portfolio_dashboard__kpi.purple .portfolio_dashboard__kpi_sub {\n  color: #7c3aed;\n}\n\n.portfolio_dashboard__kpi.slate {\n  background: #e2e8f0;\n  border-color: rgba(71, 85, 105, 0.28);\n}\n\n.portfolio_dashboard__kpi.slate .portfolio_dashboard__kpi_lbl {\n  color: #475569;\n}\n\n.portfolio_dashboard__kpi.slate .portfolio_dashboard__kpi_val {\n  color: #1e293b;\n}\n\n.portfolio_dashboard__kpi_lbl {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--faint);\n}\n\n.portfolio_dashboard__kpi_val {\n  font-size: 24px;\n  font-weight: 800;\n  margin: 6px 0 2px;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_dashboard__kpi_sub {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.portfolio_dashboard__kpi_sub.pos {\n  color: var(--acc);\n  font-weight: 600;\n}\n\n.portfolio_dashboard__kpi_sub.neg {\n  color: var(--red);\n  font-weight: 600;\n}\n\n.portfolio_dashboard__split {\n  display: flex;\n  flex-direction: column;\n  flex: none;\n  min-height: auto;\n}\n\n.portfolio_dashboard__stocks {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);\n}\n\n.portfolio_dashboard__stocks_head {\n  padding: 12px 14px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--faint);\n  border-bottom: 1px solid var(--border);\n}\n\n.portfolio_dashboard__stocks_list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.portfolio_dashboard__stock_row {\n  width: 100%;\n  text-align: left;\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 12px;\n  padding: 12px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n}\n\n.portfolio_dashboard__stock_row:hover {\n  background: var(--theme-light);\n  border-color: var(--theme-border);\n}\n\n.portfolio_dashboard__stock_row.active {\n  background: #fff;\n  border-color: var(--theme);\n  box-shadow: inset -3px 0 0 var(--theme), 0 4px 12px var(--theme-glow);\n}\n\n.portfolio_dashboard__stock_top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.portfolio_dashboard__stock_code {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--text);\n}\n\n.portfolio_dashboard__stock_name {\n  font-size: 11px;\n  color: var(--muted);\n  margin-top: 2px;\n  line-height: 1.3;\n}\n\n.portfolio_dashboard__badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.badge_acc {\n  background: var(--acc-bg);\n  color: var(--acc);\n}\n\n.badge_hold {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.badge_exit,\n.badge_trim {\n  background: #fff7ed;\n  color: #ea580c;\n}\n\n.badge_cut {\n  background: #fef2f2;\n  color: var(--red);\n}\n\n.badge_muted {\n  background: #f1f5f9;\n  color: var(--muted);\n}\n\n.portfolio_dashboard__stock_stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 10px;\n  font-size: 11px;\n  color: var(--muted);\n}\n\n.portfolio_dashboard__stock_stats strong {\n  color: var(--text);\n  font-weight: 700;\n}\n\n.portfolio_dashboard__detail {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  min-height: min-content;\n  flex: 1 0 auto;\n  overflow: visible;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);\n}\n\n.portfolio_dashboard__detail--overview {\n  overflow: visible;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.portfolio_dashboard.is_dashboard_page {\n  --dash-main-bg: #f3f4f6;\n}\n\n.portfolio_dashboard.is_dashboard_page .portfolio_dashboard__header_fixed.is_dashboard_header {\n  background: #f3f4f6;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.portfolio_dashboard.is_dashboard_page .portfolio_dashboard__topbar.is_dashboard_topbar {\n  justify-content: flex-end;\n}\n\n.portfolio_overview {\n  padding: 20px 22px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Dashboard mock layout (portfolio overview page) ─────────────── */\n.portfolio_overview--mock {\n  gap: 18px;\n  padding: 8px 24px 28px;\n  background: transparent;\n  max-width: 1280px;\n}\n\n.portfolio_overview__page_head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.portfolio_overview__page_title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #111827;\n}\n\n.portfolio_overview__updated {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.portfolio_overview__updated svg {\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n}\n\n.portfolio_overview__summary_kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.portfolio_dash_summary_card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px 18px 18px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 132px;\n  min-width: 0;\n  overflow: visible;\n}\n\n.portfolio_dash_summary_card.is_value {\n  background: linear-gradient(160deg, #ffffff 0%, #f0f7ff 100%);\n  border-color: #dbeafe;\n}\n\n.portfolio_dash_summary_card.is_score {\n  background: linear-gradient(160deg, #ffffff 0%, #fff7ed 100%);\n  border-color: #ffedd5;\n}\n\n.portfolio_dash_summary_card.is_returns {\n  background: linear-gradient(160deg, #ffffff 0%, #f0fdf4 100%);\n  border-color: #dcfce7;\n}\n\n.portfolio_dash_summary_card.is_invested {\n  background: linear-gradient(160deg, #ffffff 0%, #ecfdf5 100%);\n  border-color: #d1fae5;\n}\n\n.portfolio_dash_summary_card__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.portfolio_dash_summary_card__metrics {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  width: 100%;\n}\n\n.portfolio_dash_summary_card__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #ffffff;\n}\n\n.portfolio_dash_summary_card__icon svg {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n.portfolio_dash_summary_card__icon.is_value {\n  background: linear-gradient(145deg, #3b82f6, #2563eb);\n  box-shadow: 0 0 0 6px rgba(59, 130, 246, 0.12);\n}\n\n.portfolio_dash_summary_card__icon.is_score {\n  background: linear-gradient(145deg, #f97316, #ea580c);\n  box-shadow: 0 0 0 6px rgba(249, 115, 22, 0.12);\n}\n\n.portfolio_dash_summary_card__icon.is_returns {\n  background: linear-gradient(145deg, #22c55e, #16a34a);\n  box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.12);\n}\n\n.portfolio_dash_summary_card__icon.is_invested {\n  background: linear-gradient(145deg, #10b981, #059669);\n  box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.12);\n}\n\n.portfolio_dash_summary_card__lbl {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  color: #374151;\n  line-height: 1.3;\n  flex: 1;\n  min-width: 0;\n}\n\n.portfolio_dash_summary_card__val {\n  font-size: clamp(24px, 2.4vw, 32px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n  word-break: keep-all;\n  overflow: visible;\n  width: 100%;\n}\n\n.portfolio_dash_summary_card__val--score {\n  display: flex;\n  align-items: baseline;\n  gap: 3px;\n  flex-wrap: nowrap;\n}\n\n.portfolio_dash_summary_card__val_main {\n  font-size: clamp(26px, 2.5vw, 34px);\n  font-weight: 800;\n  line-height: 1;\n  color: #0f172a;\n}\n\n.portfolio_dash_summary_card__val_suffix {\n  font-size: 17px;\n  font-weight: 600;\n  color: #9ca3af;\n  line-height: 1;\n}\n\n.portfolio_dash_summary_card__val.is_return {\n  font-size: clamp(26px, 2.5vw, 34px);\n}\n\n.portfolio_dash_summary_card__val.is_return.pos {\n  color: #16a34a;\n}\n\n.portfolio_dash_summary_card__val.is_return.neg {\n  color: #dc2626;\n}\n\n.portfolio_dash_summary_card__extra {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.portfolio_dash_summary_card__extra.pos {\n  color: #16a34a;\n}\n\n.portfolio_dash_summary_card__extra.neg {\n  color: #dc2626;\n}\n\n.portfolio_dash_summary_card__tag {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.portfolio_dash_summary_card__tag.is_good {\n  color: #22c55e;\n}\n\n.portfolio_dash_summary_card__tag.is_fair {\n  color: #f59e0b;\n}\n\n.portfolio_dash_summary_card__tag.is_attention {\n  color: #ef4444;\n}\n\n.portfolio_dash_summary_card__bar {\n  height: 5px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  overflow: hidden;\n  margin-top: 6px;\n}\n\n.portfolio_dash_summary_card__bar_fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #f97316 0%, #fdba74 55%, #e5e7eb 100%);\n}\n\n.portfolio_dash_summary_card__bar_fill.is_good {\n  background: linear-gradient(90deg, #22c55e 0%, #86efac 55%, #e5e7eb 100%);\n}\n\n.portfolio_overview__analytics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  align-items: stretch;\n}\n\n.portfolio_overview__analytics--split {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.portfolio_overview__analytics_top {\n  display: grid;\n  grid-template-columns: minmax(300px, 1fr) minmax(0, 2fr);\n  gap: 14px;\n  align-items: stretch;\n}\n\n.portfolio_overview__analytics_bottom {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n  align-items: stretch;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel {\n  min-height: 0;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--score,\n.portfolio_overview__analytics--compact .portfolio_dash_panel--sector,\n.portfolio_overview__analytics--compact .portfolio_dash_panel--meter {\n  min-height: 0;\n}\n\n.portfolio_dash_panel {\n  padding: 20px 22px 16px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n}\n\n.portfolio_dash_panel__head_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  background: rgba(255, 255, 255, 0.65);\n}\n\n.portfolio_dash_panel__head_row .portfolio_dash_panel__title {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-size: 12px;\n  letter-spacing: 0.07em;\n  white-space: nowrap;\n}\n\n.portfolio_dash_panel__head_stack {\n  min-width: 0;\n  flex: 1;\n}\n\n.portfolio_dash_panel__hint_inline {\n  margin: 4px 0 0;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #64748b;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.portfolio_dash_panel__title {\n  margin: 0 0 14px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #111827;\n}\n\n.portfolio_dash_panel__hint {\n  margin: -8px 0 10px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #6b7280;\n}\n\n.portfolio_dash_panel--score {\n  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 48%, #fff9f5 100%);\n  border: 1px solid #e8ecf1;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 8px 24px rgba(15, 23, 42, 0.06);\n  min-height: 300px;\n  padding: 0;\n  overflow: visible;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--score {\n  min-height: 0;\n}\n\n.portfolio_dash_panel--score .portfolio_dash_panel__title {\n  margin: 0;\n  padding: 18px 22px 14px;\n  text-align: center;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  background: rgba(255, 255, 255, 0.65);\n  letter-spacing: 0.08em;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--score .portfolio_dash_panel__title {\n  padding: 12px 14px 10px;\n  font-size: 12px;\n}\n\n.portfolio_dash_panel--score_body {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 0;\n  padding: 20px 18px 24px;\n  container-type: inline-size;\n  container-name: portfolio-score-panel;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--score_body {\n  padding: 10px 12px 14px;\n}\n\n.portfolio_dash_panel--score_inner {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  justify-content: center;\n  gap: 16px 20px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  min-width: 0;\n}\n\n.portfolio_dash_donut_wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.portfolio_overview__analytics_top .portfolio_dash_donut_wrap {\n  max-width: 168px;\n}\n\n.portfolio_overview__analytics_top .portfolio_dash_donut {\n  width: 160px;\n  height: 160px;\n}\n\n.portfolio_overview__analytics_top .portfolio_dash_donut__svg {\n  width: 100%;\n  height: 100%;\n}\n\n.portfolio_overview__analytics_top .portfolio_dash_donut__val {\n  font-size: 26px;\n}\n\n.portfolio_overview__analytics_top .portfolio_dash_donut__of {\n  font-size: 13px;\n}\n\n.portfolio_overview__analytics_top .portfolio_dash_donut__caption {\n  font-size: 12px;\n  max-width: 160px;\n}\n\n.portfolio_dash_donut {\n  position: relative;\n  width: 188px;\n  height: 188px;\n  flex-shrink: 0;\n  filter: drop-shadow(0 4px 14px rgba(249, 115, 22, 0.14));\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_donut {\n  width: 132px;\n  height: 132px;\n  filter: drop-shadow(0 2px 8px rgba(249, 115, 22, 0.12));\n}\n\n.portfolio_dash_donut__svg {\n  width: 188px;\n  height: 188px;\n  display: block;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_donut__svg {\n  width: 132px;\n  height: 132px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_donut__val {\n  font-size: 22px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_donut__of {\n  font-size: 12px;\n}\n\n\n.portfolio_dash_donut__track {\n  stroke: #e5e7eb;\n}\n\n.portfolio_dash_donut__fill {\n  stroke: #f97316;\n  stroke-linecap: round;\n}\n\n.portfolio_dash_donut__fill.is_good {\n  stroke: #22c55e;\n}\n\n.portfolio_dash_donut__fill.is_fair {\n  stroke: #f97316;\n}\n\n.portfolio_dash_donut__fill.is_attention {\n  stroke: #ef4444;\n}\n\n.portfolio_dash_donut__center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  pointer-events: none;\n  padding: 0 8px;\n  box-sizing: border-box;\n}\n\n.portfolio_dash_donut__val {\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1.05;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n}\n\n.portfolio_dash_donut__of {\n  font-size: 15px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_dash_donut__caption {\n  margin: 8px 0 0;\n  padding: 0 4px;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: 0.02em;\n  text-align: center;\n  text-wrap: balance;\n  max-width: 188px;\n}\n\n.portfolio_dash_donut__caption.is_good {\n  color: #22c55e;\n}\n\n.portfolio_dash_donut__caption.is_fair {\n  color: #f59e0b;\n}\n\n.portfolio_dash_donut__caption.is_attention {\n  color: #ef4444;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_donut__caption {\n  margin-top: 6px;\n  font-size: 11px;\n  max-width: 132px;\n}\n\n.portfolio_dash_panel--score .portfolio_dash_score_metrics {\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  justify-content: center;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--score_inner {\n  gap: 12px 14px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_overview__analytics_top .portfolio_dash_donut {\n  width: 132px;\n  height: 132px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--score .portfolio_dash_score_metrics {\n  gap: 6px;\n}\n\n.portfolio_dash_score_metric {\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_score_metric {\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_score_metric__head {\n  margin-bottom: 5px;\n  font-size: 11px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_score_metric__head strong {\n  font-size: 11px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_score_metric__track {\n  height: 6px;\n}\n\n.portfolio_dash_score_metric__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.portfolio_dash_score_metric__head span {\n  min-width: 0;\n  flex: 1 1 auto;\n  line-height: 1.3;\n}\n\n.portfolio_dash_score_metric__head strong {\n  flex-shrink: 0;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.portfolio_dash_score_metric__track {\n  height: 8px;\n  border-radius: 999px;\n  background: #e8ecf0;\n  overflow: hidden;\n  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.portfolio_dash_score_metric__fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #4ade80 0%, #22c55e 55%, #16a34a 100%);\n  box-shadow: 0 0 8px rgba(34, 197, 94, 0.25);\n}\n\n.portfolio_dash_panel--sector {\n  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 48%, #f5f9ff 100%);\n  border: 1px solid #e8ecf1;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 8px 24px rgba(15, 23, 42, 0.06);\n  min-height: 300px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--sector {\n  min-height: 0;\n}\n\n.portfolio_dash_panel--sector .portfolio_dash_panel__title {\n  margin: 0;\n  padding: 18px 22px 10px;\n  text-align: center;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  background: rgba(255, 255, 255, 0.65);\n  letter-spacing: 0.08em;\n}\n\n.portfolio_dash_panel__head_row--sector {\n  align-items: flex-start;\n}\n\n.portfolio_dash_panel__head_row--sector .portfolio_dash_view_more {\n  margin: 2px 0 0;\n  flex-shrink: 0;\n  font-size: 12px;\n}\n\n.portfolio_dash_panel--sector .portfolio_dash_panel__hint {\n  margin: 0;\n  padding: 10px 22px 0;\n  text-align: center;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.portfolio_dash_panel--sector_body {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 18px 12px;\n  width: 100%;\n  min-height: 0;\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--sector_body {\n  padding: 8px 10px 10px;\n}\n\n.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_dash_panel--sector_body {\n  padding: 10px 16px 12px;\n}\n\n.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_chart--donut {\n  gap: 20px;\n  max-width: none;\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_donut_svg {\n  width: 120px;\n  height: 120px;\n}\n\n.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_legend {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 16px;\n  row-gap: 4px;\n  max-width: none;\n}\n\n.portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_legend li {\n  font-size: 12px;\n}\n\n.portfolio_overview__sector_chart--donut {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  width: 100%;\n  max-width: 420px;\n  margin: 0 auto;\n}\n\n.portfolio_overview__sector_donut_wrap {\n  flex-shrink: 0;\n  filter: drop-shadow(0 4px 14px rgba(59, 130, 246, 0.12));\n}\n\n.portfolio_overview__sector_donut_svg {\n  width: 156px;\n  height: 156px;\n  display: block;\n}\n\n.portfolio_overview__analytics--compact .portfolio_overview__sector_chart--donut {\n  gap: 10px;\n  max-width: 100%;\n}\n\n.portfolio_overview__analytics--compact .portfolio_overview__sector_donut_svg {\n  width: 108px;\n  height: 108px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_overview__sector_donut_center {\n  font-size: 16px;\n}\n\n.portfolio_overview__analytics--compact .portfolio_overview__sector_legend {\n  gap: 4px;\n  max-width: none;\n}\n\n.portfolio_overview__analytics--compact .portfolio_overview__sector_legend li {\n  font-size: 11px;\n  padding: 2px 0;\n}\n\n.portfolio_overview__sector_legend_more {\n  font-size: 11px;\n  font-weight: 700;\n  color: #2563eb;\n  padding-top: 2px;\n  list-style: none;\n}\n\n.portfolio_overview__sector_donut_hole {\n  fill: #ffffff;\n}\n\n.portfolio_overview__sector_donut_center {\n  font-size: 22px;\n  font-weight: 800;\n  fill: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_overview--mock .portfolio_overview__sector_legend {\n  flex: 1;\n  min-width: 0;\n  max-width: 220px;\n  gap: 9px;\n}\n\n.portfolio_overview--mock .portfolio_overview__sector_legend li {\n  font-size: 12px;\n  padding: 4px 0;\n}\n\n.portfolio_overview--mock .portfolio_overview__sector_legend_pct {\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.portfolio_dash_panel--sector .portfolio_dash_view_more {\n  margin: 0 22px 16px auto;\n  padding-top: 4px;\n}\n\n.portfolio_dash_view_more {\n  margin-top: auto;\n  margin-left: auto;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2563eb;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-family: inherit;\n}\n\n.portfolio_dash_view_more:hover {\n  text-decoration: underline;\n}\n\n.portfolio_dash_panel--meter {\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 48%, #f5f9ff 100%);\n  border: 1px solid #e8ecf1;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.portfolio_overview__analytics--compact .portfolio_dash_panel--meter {\n  min-height: 0;\n}\n\n.portfolio_dash_panel--meter .portfolio_dash_panel__title {\n  margin: 0;\n  padding: 12px 14px 10px;\n  text-align: center;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  background: rgba(255, 255, 255, 0.65);\n  letter-spacing: 0.08em;\n  font-size: 12px;\n}\n\n.portfolio_dash_panel--meter_body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n  width: 100%;\n  padding: 10px 12px 12px;\n  box-sizing: border-box;\n}\n\n.portfolio_dash_risk_split {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 14px 20px 18px;\n}\n\n.portfolio_dash_panel--meter .portfolio_dash_risk_split .portfolio_dash_speedometer {\n  flex: 0 0 auto;\n  max-width: 280px;\n  min-width: 0;\n  gap: 6px;\n  padding: 0 4px 2px;\n}\n\n.portfolio_dash_risk_side {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-self: center;\n  padding: 4px 0;\n}\n\n.portfolio_dash_risk_badge {\n  align-self: flex-start;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #1d4ed8;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  border: 1px solid rgba(37, 99, 235, 0.2);\n}\n\n.portfolio_dash_risk_badge.is_breadth {\n  color: #9a3412;\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);\n  border-color: rgba(234, 88, 12, 0.25);\n}\n\n.portfolio_dash_risk_badge.is_risk_low {\n  color: #166534;\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border-color: rgba(22, 163, 74, 0.28);\n}\n\n.portfolio_dash_risk_badge.is_risk_moderate {\n  color: #9a3412;\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  border-color: rgba(217, 119, 6, 0.28);\n}\n\n.portfolio_dash_risk_badge.is_risk_high {\n  color: #991b1b;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border-color: rgba(220, 38, 38, 0.35);\n}\n\n.portfolio_dash_risk_blurb {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: #475569;\n  white-space: normal;\n  overflow: visible;\n}\n\n.portfolio_dash_risk_chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.portfolio_dash_risk_chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748b;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.portfolio_dash_risk_chip strong {\n  font-size: 11px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.portfolio_dash_risk_chip.is_pos {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n  color: #166534;\n}\n\n.portfolio_dash_risk_chip.is_pos strong {\n  color: #15803d;\n}\n\n.portfolio_dash_risk_chip.is_neg {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.portfolio_dash_risk_chip.is_neg strong {\n  color: #dc2626;\n}\n\n.portfolio_dash_risk_chip.is_high_risk {\n  background: #fef2f2;\n  border-color: #fca5a5;\n  color: #991b1b;\n}\n\n.portfolio_dash_risk_chip.is_high_risk strong {\n  color: #dc2626;\n  font-weight: 800;\n}\n\n.portfolio_dash_panel--meter .portfolio_dash_speedometer__svg {\n  max-width: 280px;\n  min-width: 240px;\n  width: 100%;\n}\n\n.portfolio_overview__analytics_bottom .portfolio_dash_risk_split {\n  gap: 24px;\n  padding: 16px 22px 20px;\n}\n\n.portfolio_overview__analytics_bottom .portfolio_dash_panel--meter .portfolio_dash_speedometer__svg {\n  max-width: 300px;\n  min-width: 260px;\n}\n\n.portfolio_overview__analytics_bottom .portfolio_dash_panel--meter .portfolio_dash_speedometer__val {\n  font-size: 26px;\n}\n\n.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__val {\n  font-size: 17px;\n  margin-top: 0;\n}\n\n.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__svg {\n  max-width: 150px;\n  min-width: 0;\n}\n\n.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__tick {\n  font-size: 9px;\n}\n\n.portfolio_dash_speedometer.is_compact .portfolio_dash_speedometer__extreme {\n  font-size: 7px;\n}\n\n.portfolio_dash_speedometer {\n  width: 100%;\n  max-width: 280px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_dash_speedometer__hint {\n  margin: 6px 0 0;\n  max-width: 200px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.portfolio_dash_speedometer__title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n  line-height: 1.2;\n}\n\n.portfolio_dash_speedometer__svg {\n  width: 100%;\n  max-width: 280px;\n  min-width: 220px;\n  height: auto;\n  display: block;\n}\n\n.portfolio_dash_speedometer__tick {\n  font-size: 10px;\n  font-weight: 700;\n  fill: #475569;\n}\n\n.portfolio_dash_speedometer.is_percent_scale .portfolio_dash_speedometer__tick {\n  font-size: 9px;\n}\n\n.portfolio_dash_speedometer__extreme {\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n\n.portfolio_dash_speedometer__extreme.is_low {\n  fill: #dc2626;\n}\n\n.portfolio_dash_speedometer__extreme.is_high {\n  fill: #16a34a;\n}\n\n.portfolio_dash_speedometer__hub {\n  fill: #facc15;\n  stroke: #ffffff;\n  stroke-width: 2;\n}\n\n.portfolio_dash_speedometer__needle {\n  stroke: #facc15;\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n\n.portfolio_dash_speedometer.is_risk_gauge .portfolio_dash_speedometer__needle {\n  stroke: #002141;\n}\n\n.portfolio_dash_speedometer__val {\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.15;\n  color: #111827;\n  letter-spacing: -0.02em;\n  text-align: center;\n  margin: 4px 0 0;\n}\n\n.portfolio_dash_panel--meter .portfolio_dash_speedometer__val {\n  margin-top: 6px;\n}\n\n.portfolio_overview__chart_section {\n  width: 100%;\n}\n\n.portfolio_dash_panel--chart {\n  padding: 0;\n  overflow: hidden;\n  background: linear-gradient(165deg, #ffffff 0%, #f8fafc 50%, #f5f9ff 100%);\n  border: 1px solid #e8ecf1;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.portfolio_overview__chart_head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 22px 16px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  background: rgba(255, 255, 255, 0.75);\n}\n\n.portfolio_overview__chart_head_text {\n  min-width: 0;\n  flex: 1;\n}\n\n.portfolio_overview__chart_title {\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #0f172a;\n  line-height: 1.35;\n}\n\n.portfolio_overview__chart_sub {\n  margin: 8px 0 0;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #64748b;\n  max-width: 36rem;\n}\n\n.portfolio_overview__chart_body {\n  padding: 12px 16px 16px;\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_compact.is_premium {\n  width: 100%;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin: 0 0 12px;\n  padding: 0 4px;\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend_item {\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #334155;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend_item.is_stock {\n  color: #1d4ed8;\n  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);\n  border-color: rgba(37, 99, 235, 0.22);\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__legend_item.is_nifty {\n  color: #047857;\n  background: linear-gradient(180deg, #ecfdf5 0%, #ffffff 100%);\n  border-color: rgba(5, 150, 105, 0.2);\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__plot {\n  width: 100%;\n  min-height: 220px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #fafbfd 0%, #ffffff 42%, #f8fafc 100%);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\n  overflow: visible;\n}\n\n.portfolio_overview__chart_body .portfolio_chart.is_premium .portfolio_chart__svg {\n  width: 100%;\n  height: 100%;\n  min-height: 220px;\n  display: block;\n}\n\n.portfolio_overview_chart_alpha {\n  flex-shrink: 0;\n  margin-top: 2px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.portfolio_overview_chart_alpha.pos {\n  color: #15803d;\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.portfolio_overview_chart_alpha.neg {\n  color: #dc2626;\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.portfolio_chart--bars .portfolio_chart__svg {\n  width: 100%;\n  max-width: 560px;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n}\n\n.portfolio_overview_bar.is_portfolio {\n  fill: #3b82f6;\n}\n\n.portfolio_overview_bar.is_nifty {\n  fill: #94a3b8;\n}\n\n.portfolio_overview_bar.is_alpha {\n  fill: #8b5cf6;\n}\n\n.portfolio_overview_bar.is_neg {\n  opacity: 0.85;\n}\n\n.portfolio_overview_bar__val {\n  font-size: 11px;\n  font-weight: 700;\n  fill: #0f172a;\n}\n\n.portfolio_dash_section_title {\n  margin: 0 0 14px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #111827;\n}\n\n.portfolio_dash_action_pills {\n  background: transparent;\n}\n\n.portfolio_dash_action_pills__row {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.portfolio_dash_action_pill {\n  border-radius: 10px;\n  padding: 14px 16px;\n  border: 1px solid transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.portfolio_dash_action_pill__title {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.portfolio_dash_action_pill__count {\n  font-size: 12px;\n  font-weight: 500;\n  opacity: 0.9;\n}\n\n.portfolio_dash_action_pill__count strong {\n  font-size: 22px;\n  font-weight: 700;\n  margin-right: 4px;\n}\n\n.portfolio_dash_action_pill.is_avg_up {\n  background: #dcfce7;\n  border-color: #86efac;\n  color: #166534;\n}\n\n.portfolio_dash_action_pill.is_avg_down {\n  background: #ffedd5;\n  border-color: #fdba74;\n  color: #c2410c;\n}\n\n.portfolio_dash_action_pill.is_hold {\n  background: #dbeafe;\n  border-color: #93c5fd;\n  color: #1d4ed8;\n}\n\n.portfolio_dash_action_pill.is_profit {\n  background: #fef9c3;\n  border-color: #fde047;\n  color: #a16207;\n}\n\n.portfolio_dash_action_pill.is_cut_loss {\n  background: #fee2e2;\n  border-color: #fca5a5;\n  color: #b91c1c;\n}\n\n.portfolio_dash_action_pill.is_exit {\n  background: #ede9fe;\n  border-color: #c4b5fd;\n  color: #6d28d9;\n}\n\n.portfolio_dash_badge {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 5px 10px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.portfolio_dash_badge.is_avg_up {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.portfolio_dash_badge.is_avg_down {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.portfolio_dash_badge.is_hold {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.portfolio_dash_badge.is_profit {\n  background: #fef9c3;\n  color: #a16207;\n}\n\n.portfolio_dash_badge.is_cut_loss {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.portfolio_dash_badge.is_exit {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n.portfolio_dash_badge.is_buy {\n  background: #ecfdf5;\n  color: #15803d;\n}\n\n.portfolio_dash_badge.is_muted {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.portfolio_dash_stocks_table {\n  padding: 0;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n\n.portfolio_dash_stocks_table .portfolio_dash_section_title {\n  padding: 18px 20px 0;\n}\n\n.portfolio_dash_stocks_table__wrap {\n  overflow-x: auto;\n  padding: 0 20px 18px;\n}\n\n.portfolio_dash_stocks_table__grid {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.portfolio_dash_stocks_table__grid th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n  padding: 12px 10px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.portfolio_dash_stocks_table__grid td {\n  padding: 14px 10px;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  color: #334155;\n}\n\n.portfolio_dash_stocks_table__stock {\n  font-weight: 600;\n  color: #111827;\n}\n\n.portfolio_dash_stocks_table__price {\n  font-weight: 600;\n  color: #111827;\n}\n\n.portfolio_dash_stocks_table__chg {\n  font-weight: 700;\n}\n\n.portfolio_dash_stocks_table__reason {\n  max-width: 360px;\n  line-height: 1.5;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n/* Narrow score panel: stack donut + metrics so bars never clip */\n@container portfolio-score-panel (max-width: 460px) {\n  .portfolio_dash_panel--score_inner {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: 16px;\n  }\n\n  .portfolio_dash_panel--score .portfolio_dash_score_metrics {\n    width: 100%;\n    max-width: 340px;\n  }\n}\n\n@media (max-width: 1320px) {\n  .portfolio_overview__analytics_top {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_dash_panel--score_inner {\n    grid-template-columns: auto minmax(0, 1fr);\n    max-width: 520px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n@media (max-width: 1200px) {\n  .portfolio_overview__analytics {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__analytics_top {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__analytics_bottom {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__analytics--split .portfolio_dash_panel--sector.is_wide .portfolio_overview__sector_legend {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_dash_panel--meter .portfolio_dash_speedometer__svg,\n  .portfolio_overview__analytics_bottom .portfolio_dash_panel--meter .portfolio_dash_speedometer__svg {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .portfolio_dash_panel--meter .portfolio_dash_risk_split .portfolio_dash_speedometer {\n    flex: 0 0 auto;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .portfolio_dash_action_pills__row {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1100px) {\n  .portfolio_overview__summary_kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .portfolio_dash_summary_card__val,\n  .portfolio_dash_summary_card__val_main {\n    font-size: 26px;\n  }\n}\n\n@media (max-width: 900px) {\n  .portfolio_overview__summary_kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_dash_action_pills__row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .portfolio_dash_panel--score_inner {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: 18px;\n    max-width: none;\n  }\n\n  .portfolio_dash_panel--score .portfolio_dash_score_metrics {\n    max-width: 360px;\n    width: 100%;\n  }\n}\n\n.portfolio_overview__head {\n  display: grid;\n  grid-template-areas:\n    \"title title\"\n    \"chips meta\";\n  grid-template-columns: 1fr auto;\n  column-gap: 14px;\n  row-gap: 10px;\n  align-items: center;\n}\n\n.portfolio_overview__head_meta {\n  grid-area: meta;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.portfolio_overview__title {\n  grid-area: title;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -0.02em;\n  color: #002141;\n}\n\n.portfolio_overview__stats_highlight {\n  grid-area: chips;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.portfolio_overview__stat_chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_overview__stat_chip_icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  background: #e35834;\n  color: #ffffff;\n  flex-shrink: 0;\n}\n\n.portfolio_overview__stat_chip_icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.portfolio_overview__stat_chip_val {\n  font-size: 17px;\n  font-weight: 700;\n  color: #002141;\n  line-height: 1;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_overview__stat_chip_lbl {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: lowercase;\n}\n\n.portfolio_overview__rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.06);\n  flex-shrink: 0;\n  width: auto;\n}\n\n.portfolio_overview__rating_lbl {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.portfolio_overview__rating_stars {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n}\n\n.portfolio_overview__rating_star {\n  display: flex;\n  line-height: 0;\n}\n\n.portfolio_overview__rating_star_svg {\n  width: 14px;\n  height: 14px;\n  display: block;\n}\n\n.portfolio_overview__rating_star_empty {\n  fill: #e2e8f0;\n}\n\n.portfolio_overview__rating_star_filled {\n  fill: #f59e0b;\n}\n\n.portfolio_overview__rating.is_high .portfolio_overview__rating_star_filled {\n  fill: #16a34a;\n}\n\n.portfolio_overview__rating.is_mid .portfolio_overview__rating_star_filled {\n  fill: #d97706;\n}\n\n.portfolio_overview__rating.is_low .portfolio_overview__rating_star_filled {\n  fill: #ea580c;\n}\n\n.portfolio_overview__rating.is_muted .portfolio_overview__rating_star_filled {\n  fill: #cbd5e1;\n}\n\n.portfolio_overview__rating_val {\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: #002141;\n}\n\n.portfolio_overview__rating_of {\n  font-size: 10px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.portfolio_overview__rating.is_high .portfolio_overview__rating_val {\n  color: #15803d;\n}\n\n.portfolio_overview__rating.is_mid .portfolio_overview__rating_val {\n  color: #a16207;\n}\n\n.portfolio_overview__rating.is_low .portfolio_overview__rating_val {\n  color: #c2410c;\n}\n\n.portfolio_overview__rating.is_muted .portfolio_overview__rating_val {\n  color: #94a3b8;\n}\n\n.portfolio_overview__highlights {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.portfolio_overview__action_graphic {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_overview__action_graphic.is_reduce {\n  background: linear-gradient(135deg, #fff1eb 0%, #ffe8dc 45%, #ffffff 100%);\n  border-color: rgba(227, 88, 52, 0.35);\n}\n\n.portfolio_overview__action_graphic.is_reduce .portfolio_overview__action_graphic_icon {\n  background: linear-gradient(145deg, #e35834, #c94a2c);\n  color: #ffffff;\n}\n\n.portfolio_overview__action_graphic.is_hold {\n  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 100%);\n  border-color: rgba(37, 99, 235, 0.25);\n}\n\n.portfolio_overview__action_graphic.is_hold .portfolio_overview__action_graphic_icon {\n  background: linear-gradient(145deg, #3b82f6, #2563eb);\n  color: #ffffff;\n}\n\n.portfolio_overview__action_graphic.is_accumulate {\n  background: linear-gradient(135deg, #ecfdf5 0%, #ffffff 100%);\n  border-color: rgba(22, 163, 74, 0.25);\n}\n\n.portfolio_overview__action_graphic.is_accumulate .portfolio_overview__action_graphic_icon {\n  background: linear-gradient(145deg, #22c55e, #16a34a);\n  color: #ffffff;\n}\n\n.portfolio_overview__action_graphic.is_default {\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n}\n\n.portfolio_overview__action_graphic.is_default .portfolio_overview__action_graphic_icon {\n  background: linear-gradient(145deg, #64748b, #475569);\n  color: #ffffff;\n}\n\n.portfolio_overview__action_graphic_icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.portfolio_overview__action_graphic_icon svg {\n  width: 12px;\n  height: 12px;\n}\n\n.portfolio_overview__action_graphic_lbl {\n  display: block;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-bottom: 1px;\n}\n\n.portfolio_overview__action_graphic_val {\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #002141;\n  line-height: 1.2;\n}\n\n.portfolio_overview__action_graphic.is_reduce .portfolio_overview__action_graphic_val {\n  color: #c94a2c;\n}\n\n.portfolio_overview__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  align-items: start;\n}\n\n.portfolio_overview__grid .portfolio_overview__insight_card {\n  margin-bottom: 0;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  padding: 18px 20px 20px;\n  box-shadow: 0 2px 8px rgba(0, 33, 65, 0.06);\n  position: relative;\n  overflow: hidden;\n}\n\n.portfolio_overview__grid .portfolio_overview__insight_card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #e35834 0%, #002141 100%);\n}\n\n.portfolio_overview__insight_lead {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.55;\n  color: #002141;\n  margin: 0 0 14px;\n}\n\n.portfolio_overview__insight_sub {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.55;\n  color: #64748b;\n  margin: 0 0 16px;\n}\n\n.portfolio_overview__insight_metrics {\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n  border-radius: 10px;\n  padding: 2px 14px;\n}\n\n.portfolio_overview__insight_metrics .portfolio_overview__kv {\n  padding: 11px 0;\n}\n\n.portfolio_overview__insight_metrics .portfolio_overview__kv:last-child {\n  border-bottom: none;\n}\n\n.portfolio_overview__kv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_overview__kv:last-child {\n  border-bottom: none;\n}\n\n.portfolio_overview__kv_label {\n  color: #475569;\n  font-weight: 500;\n}\n\n.portfolio_overview__kv_val {\n  color: #0f172a;\n  font-weight: 700;\n  text-align: right;\n}\n\n.portfolio_overview__kv_val_strong {\n  color: #002141;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.portfolio_overview__kv_is_profit .portfolio_overview__kv_label,\n.portfolio_overview__kv_is_profit .portfolio_overview__kv_val {\n  color: #15803d;\n  font-weight: 700;\n}\n\n.portfolio_overview__kv_is_loss .portfolio_overview__kv_label,\n.portfolio_overview__kv_is_loss .portfolio_overview__kv_val {\n  color: #dc2626;\n  font-weight: 700;\n}\n\n.portfolio_overview__kv_val.pos {\n  color: #15803d;\n}\n\n.portfolio_overview__kv_val.neg {\n  color: #dc2626;\n}\n\n.portfolio_overview__note {\n  font-size: 12px;\n  color: #64748b;\n  margin: 12px 0 0;\n  line-height: 1.6;\n  padding-top: 10px;\n  border-top: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_overview__breadth_dropdown {\n  margin-top: 14px;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  border-radius: 10px;\n  background: #fff8f4;\n  overflow: hidden;\n}\n\n.portfolio_overview__breadth_dropdown_toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n\n.portfolio_overview__breadth_dropdown_toggle:hover {\n  background: rgba(227, 88, 52, 0.06);\n}\n\n.portfolio_overview__breadth_dropdown_icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: rgba(227, 88, 52, 0.14);\n  color: #e35834;\n  flex-shrink: 0;\n}\n\n.portfolio_overview__breadth_dropdown_icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.portfolio_overview__breadth_dropdown_label {\n  flex: 1;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #002141;\n}\n\n.portfolio_overview__breadth_dropdown_chevron {\n  display: flex;\n  color: #64748b;\n  transition: transform 0.2s ease;\n}\n\n.portfolio_overview__breadth_dropdown_chevron svg {\n  width: 18px;\n  height: 18px;\n}\n\n.portfolio_overview__breadth_dropdown.is_open .portfolio_overview__breadth_dropdown_chevron {\n  transform: rotate(180deg);\n}\n\n.portfolio_overview__breadth_dropdown_panel {\n  padding: 0 14px 14px;\n  border-top: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_overview__breadth_summary_list {\n  margin: 12px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.portfolio_overview__breadth_summary_list li {\n  position: relative;\n  padding-left: 14px;\n  font-size: 13px;\n  line-height: 1.65;\n  color: #475569;\n  font-weight: 500;\n  margin-bottom: 9px;\n}\n\n.portfolio_overview__breadth_summary_list li:last-child {\n  margin-bottom: 0;\n}\n\n.portfolio_overview__breadth_summary_list li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.55em;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #e35834;\n}\n\n.portfolio_overview__breadth_summary_list li strong {\n  font-weight: 700;\n  color: #e35834;\n}\n\n.portfolio_overview__breadth_hl_pos,\n.portfolio_overview__breadth_hl_neg,\n.portfolio_overview__breadth_hl_warn,\n.portfolio_overview__breadth_hl_num {\n  color: #e35834;\n}\n\n.portfolio_overview__insight_card_sector .portfolio_overview__sector_chart {\n  justify-content: center;\n  padding-top: 4px;\n}\n\n.portfolio_overview__sector_chart {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.portfolio_overview__sector_pie_svg,\n.portfolio_overview__sector_donut_svg {\n  flex-shrink: 0;\n  width: 140px;\n  height: 140px;\n  filter: drop-shadow(0 2px 6px rgba(0, 33, 65, 0.1));\n}\n\n.portfolio_overview__sector_legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.portfolio_overview__sector_legend li {\n  display: grid;\n  grid-template-columns: 10px 1fr auto;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.portfolio_overview__sector_legend_dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.portfolio_overview__sector_legend_name {\n  color: #334155;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.portfolio_overview__sector_legend_pct {\n  color: #002141;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.portfolio_overview__sector_row {\n  display: grid;\n  grid-template-columns: 1fr minmax(60px, 100px) 40px;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.portfolio_overview__sector_name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--text);\n  font-weight: 500;\n}\n\n.portfolio_overview__sector_bar {\n  height: 6px;\n  background: #e8ecf1;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.portfolio_overview__sector_fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--theme), #6b8cff);\n  border-radius: 999px;\n}\n\n.portfolio_overview__sector_pct {\n  text-align: right;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.portfolio_overview__action_panel {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  border-radius: 14px;\n  padding: 20px 22px 22px;\n  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_overview__action_grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.portfolio_overview__action_card {\n  display: flex;\n  flex-direction: column;\n  min-height: 148px;\n  padding: 16px 16px 14px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_overview__action_card_title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #002141;\n  margin-bottom: 12px;\n  line-height: 1.35;\n  letter-spacing: 0.01em;\n}\n\n.portfolio_overview__action_card_count {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  margin-bottom: 2px;\n}\n\n.portfolio_overview__action_card_count_num {\n  font-size: 28px;\n  font-weight: 800;\n  color: #94a3b8;\n  line-height: 1;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_overview__action_card_count_num.is_active {\n  color: #002141;\n}\n\n.portfolio_overview__action_card_count_lbl {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.portfolio_overview__action_card_metrics {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 12px 10px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n  min-height: 52px;\n  justify-content: center;\n}\n\n.portfolio_overview__action_card_metrics.is_empty {\n  align-items: center;\n}\n\n.portfolio_overview__action_card_hint {\n  margin: 8px 0 0;\n  font-size: 11px;\n  line-height: 1.55;\n  color: #64748b;\n}\n\n.portfolio_overview__action_card_empty {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.portfolio_overview__action_metric {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.portfolio_overview__action_metric_label {\n  color: #64748b;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.portfolio_overview__action_metric_val {\n  color: #0f172a;\n  font-weight: 700;\n  text-align: right;\n  font-size: 13px;\n}\n\n.portfolio_overview__action_metric_val.is_pos {\n  color: #15803d;\n}\n\n.portfolio_overview__action_metric_val.is_neg {\n  color: #dc2626;\n}\n\n.portfolio_overview__action_metric_val.is_theme {\n  color: #e35834;\n}\n\n.portfolio_overview__net_impact_panel {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  border-radius: 14px;\n  padding: 20px 22px 22px;\n  box-shadow: 0 1px 4px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_overview__net_impact_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.portfolio_overview__net_impact_item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 10px;\n}\n\n.portfolio_overview__net_impact_label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1.3;\n  letter-spacing: 0.02em;\n}\n\n.portfolio_overview__net_impact_val {\n  font-size: 18px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_overview__net_impact_val.is_pos {\n  color: #15803d;\n}\n\n.portfolio_overview__net_impact_val.is_neg {\n  color: #dc2626;\n}\n\n.portfolio_overview__net_impact_val.is_theme {\n  color: #e35834;\n}\n\n.portfolio_overview__summary_grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 4px 20px;\n}\n\n.portfolio_overview__phase_grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.portfolio_overview__phase_card {\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  background: var(--bg);\n}\n\n.portfolio_overview__phase_title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--faint);\n  margin-bottom: 8px;\n}\n\n@media (max-width: 1100px) {\n  .portfolio_overview__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__phase_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__action_grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .portfolio_overview__net_impact_grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .portfolio_overview__action_grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .portfolio_overview__net_impact_grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .portfolio_overview__action_grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.portfolio_dashboard__detail_empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--muted);\n  font-size: 14px;\n}\n\n.portfolio_section_empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: min(480px, calc(100vh - 280px));\n  padding: 48px 24px;\n  margin: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.portfolio_section_empty__title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #475569;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.portfolio_dashboard__detail_head {\n  padding: 18px 20px 12px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.portfolio_dashboard__detail_title {\n  font-size: 22px;\n  font-weight: 800;\n  margin: 0;\n}\n\n.portfolio_dashboard__detail_sub {\n  font-size: 12px;\n  color: var(--muted);\n  margin-top: 4px;\n}\n\n.portfolio_dashboard__detail_kpis {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 10px;\n  font-size: 12px;\n}\n\n.portfolio_dashboard__detail_kpis span {\n  color: var(--muted);\n}\n\n.portfolio_dashboard__detail_kpis strong {\n  display: block;\n  font-size: 14px;\n  color: var(--text);\n}\n\n.portfolio_dashboard__score_box {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.portfolio_dashboard__score_val {\n  font-size: 32px;\n  font-weight: 900;\n  color: var(--theme);\n  line-height: 1;\n}\n\n.portfolio_dashboard__score_lbl {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--faint);\n}\n\n.portfolio_dashboard__tabs {\n  display: flex;\n  gap: 4px;\n  padding: 0 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.portfolio_dashboard__tab {\n  border: none;\n  background: transparent;\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n\n.portfolio_dashboard__tab.active {\n  color: var(--theme);\n  border-bottom-color: var(--theme);\n}\n\n.portfolio_dashboard__detail_body {\n  flex: 1 0 auto;\n  overflow: visible;\n  padding: 16px 20px 20px;\n}\n\n.portfolio_dashboard__panel {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 14px 16px;\n  margin-bottom: 14px;\n}\n\n.portfolio_dashboard__panel h4 {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--faint);\n  margin: 0 0 10px;\n}\n\n.portfolio_overview__insight_card .portfolio_overview__insight_title {\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  color: #002141;\n  margin: 0 0 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_overview__action_panel .portfolio_overview__action_panel_title {\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #002141;\n  margin: 0 0 18px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_overview__net_impact_panel .portfolio_overview__net_impact_title {\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #002141;\n  margin: 0 0 18px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_dashboard__panel p {\n  font-size: 13px;\n  line-height: 1.65;\n  color: var(--text);\n  margin: 0;\n}\n\n.portfolio_overview__summary_panel {\n  background: #fff8f4;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 16px 18px;\n  margin-bottom: 16px;\n}\n\n.portfolio_overview__summary_panel .portfolio_overview__summary_title {\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #002141;\n  margin: 0 0 10px;\n}\n\n.portfolio_overview__summary_text {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.7;\n  color: #1e293b;\n  margin: 0;\n}\n\n.portfolio_dashboard__score_bars {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.portfolio_dashboard__bar_row {\n  display: grid;\n  grid-template-columns: 100px 1fr 36px;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.portfolio_dashboard__bar_track {\n  height: 8px;\n  background: #e8ecf1;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.portfolio_dashboard__bar_fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--theme), #ff9a6c);\n  border-radius: 999px;\n}\n\n.portfolio_dashboard__phase_foot {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border);\n  background: linear-gradient(180deg, #fff, var(--theme-light));\n  font-size: 11px;\n}\n\n.portfolio_dashboard__phase_foot strong {\n  display: block;\n  font-size: 14px;\n  margin-top: 2px;\n}\n\n@media (max-width: 1100px) {\n  .portfolio_dashboard__kpis,\n  .portfolio_dashboard__kpis--top {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .portfolio_overview__kpis {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .portfolio_dashboard__search_wrap {\n    max-width: none;\n    order: 3;\n    flex: 1 1 100%;\n  }\n\n  .portfolio_dashboard__actions {\n    margin-left: 0;\n  }\n\n  .portfolio_dashboard__split {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .portfolio_dashboard {\n    flex-direction: column;\n    height: auto;\n    min-height: 100vh;\n    overflow: visible;\n  }\n\n  .portfolio_dashboard__sidebar.sidebar_premium {\n    position: relative;\n    top: auto;\n    left: auto;\n    width: 100%;\n    height: auto;\n    max-height: none;\n  }\n\n  .portfolio_dashboard__main {\n    margin-left: 0;\n    height: auto;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .portfolio_dashboard__header_fixed {\n    position: relative;\n  }\n\n  .portfolio_dashboard__scroll {\n    overflow-y: visible;\n    flex: none;\n  }\n\n  .portfolio_dashboard__split {\n    flex: none;\n  }\n\n  .portfolio_dashboard__kpis,\n  .portfolio_dashboard__kpis--top,\n  .portfolio_overview__kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__head {\n    grid-template-areas:\n      \"title\"\n      \"chips\"\n      \"meta\";\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_overview__head_meta {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .portfolio_holdings_page__head {\n    padding: 14px 12px;\n  }\n\n  .portfolio_holding_card__stats {\n    padding: 12px;\n    gap: 10px;\n  }\n\n  .portfolio_holding_card__stat {\n    min-height: 76px;\n    padding: 14px 12px;\n  }\n\n  .portfolio_holding_card__stat_value {\n    font-size: 15px;\n  }\n\n  .portfolio_detail_stack {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_stock_detail__metric {\n    flex: 1 1 45%;\n    border-right: none;\n    border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  }\n\n  .portfolio_stock_detail__metric:nth-child(odd) {\n    border-right: 1px solid rgba(0, 33, 65, 0.06);\n  }\n\n  .portfolio_stock_detail__insights {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_siho_scores__grid.is_row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.portfolio_dashboard__scroll--holdings {\n  padding: 0 0 20px;\n  gap: 0;\n}\n\n/* Portfolio holdings list */\n.portfolio_holdings_page {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 0;\n}\n\n.portfolio_holdings_page__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 0 0 16px;\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n  background: #ffffff;\n}\n\n.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__head {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 28px 24px 22px;\n  margin-bottom: 20px;\n}\n\n.portfolio_holdings_page.is_detail .portfolio_holdings_page__head {\n  margin-bottom: 12px;\n  padding-bottom: 14px;\n}\n\n.portfolio_holdings_page.is_detail .portfolio_holdings_page__title {\n  font-size: 22px;\n}\n\n.portfolio_holdings_page__titles {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__titles {\n  align-items: center;\n  gap: 8px;\n  max-width: 520px;\n}\n\n.portfolio_holdings_page__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__title {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__title::after {\n  content: \"\";\n  display: block;\n  width: 48px;\n  height: 3px;\n  margin: 12px auto 0;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #e35834, rgba(227, 88, 52, 0.35));\n}\n\n.portfolio_holdings_page__subtitle {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.portfolio_holdings_page:not(.is_detail) .portfolio_holdings_page__subtitle {\n  font-size: 15px;\n  font-weight: 500;\n  color: #475569;\n}\n\n.portfolio_holdings_page__back {\n  border: 1px solid rgba(0, 33, 65, 0.12);\n  background: #ffffff;\n  color: #002141;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: inherit;\n  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_holdings_table {\n  padding: 0 20px 24px;\n}\n\n.portfolio_holdings_table__wrap {\n  overflow-x: auto;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 2px 10px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_holdings_table__grid {\n  width: 100%;\n  min-width: 1080px;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.portfolio_holdings_table__grid th {\n  text-align: left;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #002141;\n  padding: 14px 14px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.1);\n  background: #eef2f7;\n  white-space: nowrap;\n}\n\n.portfolio_holdings_table__grid td {\n  padding: 14px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  vertical-align: middle;\n  color: #334155;\n  line-height: 1.4;\n}\n\n.portfolio_holdings_table__grid tbody tr:hover td {\n  background: #fff8f4;\n}\n\n.portfolio_holdings_table__grid tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.portfolio_holdings_table__stock {\n  font-weight: 700;\n  color: #002141;\n  min-width: 140px;\n}\n\n.portfolio_holdings_table__symbol {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.portfolio_holdings_table__isin {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.portfolio_holdings_table__price {\n  font-weight: 700;\n  color: #15803d;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_holdings_table__num {\n  font-weight: 600;\n  color: #002141;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_holdings_table__return {\n  font-weight: 700;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_holdings_table__return.pos {\n  color: #15803d;\n}\n\n.portfolio_holdings_table__return.neg {\n  color: #dc2626;\n}\n\n.portfolio_holdings_table__score {\n  font-weight: 700;\n  color: #002141;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_holdings_table__action {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.portfolio_holdings_table__detail_btn {\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  background: #eef2f7;\n  color: #002141;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);\n  transition:\n    background 0.2s ease,\n    color 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.portfolio_holdings_table__detail_btn:hover {\n  background: #e35834;\n  color: #ffffff;\n  border-color: #e35834;\n  box-shadow: 0 4px 12px rgba(227, 88, 52, 0.22);\n}\n\n.portfolio_holding_card {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  padding: 16px 18px;\n  box-shadow: 0 2px 10px rgba(0, 33, 65, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition:\n    box-shadow 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.portfolio_holding_card:hover {\n  border-color: rgba(227, 88, 52, 0.25);\n  box-shadow: 0 6px 18px rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_holding_card.is_active {\n  border-color: rgba(227, 88, 52, 0.45);\n  box-shadow: 0 12px 32px rgba(227, 88, 52, 0.12);\n}\n\n.portfolio_holding_card__head {\n  display: flex;\n  justify-content: space-between;\n  gap: 14px;\n  align-items: flex-start;\n}\n\n.portfolio_holding_card__identity {\n  min-width: 0;\n  flex: 1;\n}\n\n.portfolio_holding_card__name {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #002141;\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n}\n\n.portfolio_holding_card__subhead {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.portfolio_holding_card__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.portfolio_holding_card__tag {\n  font-size: 10px;\n  font-weight: 700;\n  color: #002141;\n  background: #f1f5f9;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  padding: 3px 7px;\n  border-radius: 5px;\n  letter-spacing: 0.02em;\n}\n\n.portfolio_holding_card__industry {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  line-height: 1.35;\n}\n\n.portfolio_holding_card__isin {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.portfolio_holding_card__stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  padding: 10px;\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n  border-radius: 10px;\n}\n\n.portfolio_holding_card__stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 6px;\n  min-height: 62px;\n  padding: 10px 12px;\n  text-align: left;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.portfolio_holding_card__stat_label {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.portfolio_holding_card__stat_value {\n  display: block;\n  width: 100%;\n  font-size: 15px;\n  font-weight: 700;\n  color: #002141;\n  line-height: 1.2;\n  margin: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_holding_card__stat_value.pos {\n  color: #15803d;\n}\n\n.portfolio_holding_card__stat_value.neg {\n  color: #dc2626;\n}\n\n.portfolio_holding_card__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding-top: 2px;\n}\n\n.portfolio_holding_card__score_pill {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 10px;\n  background: #fff8f4;\n  border: 1px solid rgba(227, 88, 52, 0.12);\n  border-radius: 8px;\n}\n\n.portfolio_holding_card__score_lbl {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n}\n\n.portfolio_holding_card__score_pill strong {\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_holding_card__score_pill strong small {\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  margin-left: 2px;\n}\n\n.portfolio_holding_card__detail_btn {\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  background: #eef2f7;\n  color: #002141;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);\n  transition:\n    background 0.2s ease,\n    color 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.portfolio_holding_card__detail_btn:hover {\n  background: #e35834;\n  color: #ffffff;\n  border-color: #e35834;\n  box-shadow: 0 4px 12px rgba(227, 88, 52, 0.22);\n}\n\n.portfolio_holdings_page__detail {\n  scroll-margin-top: 88px;\n  padding: 0 20px 24px;\n}\n\n/* Action section — sidebar list + detail (full viewport height) */\n.portfolio_action_section {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n  min-height: 0;\n  height: 100%;\n  background: #f1f5f9;\n}\n\n.portfolio_dashboard__scroll--action {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n  min-height: calc(100dvh - 96px);\n  padding: 0;\n  gap: 0;\n}\n\n/* Fill viewport below header — split/detail wrappers were flex:none */\n.portfolio_dashboard__scroll--action .portfolio_dashboard__split {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n  min-height: 0;\n}\n\n.portfolio_dashboard__scroll--action .portfolio_dashboard__detail {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n  min-height: 0;\n  overflow: hidden;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.portfolio_dashboard__scroll--action .portfolio_action_section {\n  flex: 1 1 0%;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.portfolio_action_section__layout {\n  display: flex;\n  align-items: stretch;\n  flex: 1 1 0%;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n  gap: 12px;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.portfolio_action_section__detail_panel {\n  flex: 1 1 0%;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid #e8ecf1;\n  border-radius: 16px;\n  box-shadow: 0 4px 18px rgba(26, 35, 58, 0.08);\n}\n\n.portfolio_action_section__detail_scroll {\n  flex: 1 1 0%;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(227, 88, 52, 0.35) transparent;\n}\n\n.portfolio_action_section__placeholder {\n  margin: 0;\n  padding: 40px 16px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  background: #ffffff;\n  border: 1px dashed rgba(0, 33, 65, 0.12);\n  border-radius: 14px;\n}\n\n.portfolio_action_section__stock_card {\n  margin: 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.portfolio_action_sidebar {\n  flex: 0 0 340px;\n  width: 340px;\n  max-width: 38vw;\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n  padding: 0;\n  background: transparent;\n}\n\n.portfolio_action_sidebar__card {\n  flex: 1 1 0%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e8ecf1;\n  border-radius: 16px;\n  box-shadow: 0 4px 18px rgba(26, 35, 58, 0.08);\n  overflow: hidden;\n}\n\n.portfolio_action_sidebar__controls {\n  flex-shrink: 0;\n  padding: 18px 16px 14px;\n  background: #ffffff;\n}\n\n.portfolio_action_sidebar__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.portfolio_action_sidebar__title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #1a233a;\n  line-height: 1.2;\n}\n\n.portfolio_action_sidebar__count {\n  font-size: 11px;\n  font-weight: 800;\n  color: #ffffff;\n  background: #ff6b35;\n  border: none;\n  min-width: 26px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  padding: 0 8px;\n  line-height: 1;\n}\n\n.portfolio_action_sidebar__search_wrap {\n  position: relative;\n  margin-bottom: 14px;\n}\n\n.portfolio_action_sidebar__search_icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  color: #9aa5b5;\n  pointer-events: none;\n}\n\n.portfolio_action_sidebar__search {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #dfe5ec;\n  border-radius: 999px;\n  padding: 11px 14px 11px 40px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #1a233a;\n  background: #ffffff;\n  outline: none;\n}\n\n.portfolio_action_sidebar__search::placeholder {\n  color: #aab4c4;\n  font-weight: 400;\n}\n\n.portfolio_action_sidebar__search:focus {\n  border-color: #9aa5b5;\n  box-shadow: none;\n}\n\n.portfolio_action_sidebar__chips {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 6px;\n  margin-bottom: 12px;\n  overflow-x: auto;\n  padding-bottom: 2px;\n  scrollbar-width: none;\n}\n\n.portfolio_action_sidebar__chips::-webkit-scrollbar {\n  display: none;\n}\n\n.portfolio_action_sidebar__chip {\n  border: 1px solid #dfe5ec;\n  background: #ffffff;\n  color: #5c6b82;\n  font-size: 11px;\n  font-weight: 600;\n  font-family: inherit;\n  padding: 6px 11px;\n  border-radius: 999px;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  line-height: 1.2;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.portfolio_action_sidebar__chip:hover {\n  border-color: #c5ced8;\n  color: #1a233a;\n}\n\n.portfolio_action_sidebar__chip.is_active {\n  background: #1a233a;\n  border-color: #1a233a;\n  color: #ffffff;\n}\n\n.portfolio_action_sidebar__sort {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_action_sidebar__sort_lbl {\n  font-size: 12px;\n  font-weight: 500;\n  color: #9aa5b5;\n  white-space: nowrap;\n}\n\n.portfolio_action_sidebar__sort_select {\n  flex: 0 1 auto;\n  min-width: 108px;\n  border: 1px solid #dfe5ec;\n  border-radius: 8px;\n  padding: 7px 28px 7px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  color: #1a233a;\n  background: #ffffff\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%239aa5b5' d='M2.5 4.5 6 8l3.5-3.5'/%3E%3C/svg%3E\")\n    no-repeat right 10px center;\n  appearance: none;\n  cursor: pointer;\n}\n\n.portfolio_action_sidebar__sort_select:focus {\n  outline: none;\n  border-color: #9aa5b5;\n}\n\n.portfolio_action_sidebar__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1 1 auto;\n  min-height: 0;\n  border-top: 1px solid #eef1f5;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(26, 35, 58, 0.25) transparent;\n}\n\n.portfolio_action_sidebar__empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: #9aa5b5;\n}\n\n.portfolio_action_sidebar__row {\n  border-bottom: 1px solid #eef1f5;\n}\n\n.portfolio_action_sidebar__row:last-child {\n  border-bottom: none;\n}\n\n.portfolio_action_sidebar__item {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 42px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 14px 14px 12px;\n  border: none;\n  border-left: 3px solid transparent;\n  border-radius: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: background 0.15s ease;\n}\n\n.portfolio_action_sidebar__item:hover {\n  background: #fafbfc;\n}\n\n.portfolio_action_sidebar__item.is_active {\n  background: #fff6f3;\n  border-left-color: #e35834;\n}\n\n.portfolio_action_sidebar__item.is_active.is_watch .portfolio_action_sidebar__name {\n  color: #c45c26;\n}\n\n.portfolio_action_sidebar__avatar {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 0.02em;\n}\n\n.portfolio_action_sidebar__avatar.accumulate.tone_a {\n  background: #e8f8ef;\n  color: #2d8a56;\n}\n\n.portfolio_action_sidebar__avatar.accumulate.tone_b {\n  background: #e3f0ff;\n  color: #2f6eb3;\n}\n\n.portfolio_action_sidebar__avatar.accumulate.tone_c {\n  background: #fff4df;\n  color: #b07a12;\n}\n\n.portfolio_action_sidebar__avatar.accumulate.tone_d {\n  background: #fde8ef;\n  color: #c44d74;\n}\n\n.portfolio_action_sidebar__avatar.accumulate.tone_e {\n  background: #efe9ff;\n  color: #6b4fc7;\n}\n\n.portfolio_action_sidebar__avatar.buy.tone_a,\n.portfolio_action_sidebar__avatar.buy.tone_c {\n  background: #e8eeff;\n  color: #3b5ccc;\n}\n\n.portfolio_action_sidebar__avatar.buy.tone_b,\n.portfolio_action_sidebar__avatar.buy.tone_e {\n  background: #e3f0ff;\n  color: #2f6eb3;\n}\n\n.portfolio_action_sidebar__avatar.buy.tone_d {\n  background: #efe9ff;\n  color: #6b4fc7;\n}\n\n.portfolio_action_sidebar__avatar.watch,\n.portfolio_action_sidebar__avatar.watch.tone_a,\n.portfolio_action_sidebar__avatar.watch.tone_b,\n.portfolio_action_sidebar__avatar.watch.tone_c,\n.portfolio_action_sidebar__avatar.watch.tone_d,\n.portfolio_action_sidebar__avatar.watch.tone_e {\n  background: #fff8e6;\n  color: #c45c26;\n}\n\n.portfolio_action_sidebar__center {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n}\n\n.portfolio_action_sidebar__name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a233a;\n  line-height: 1.25;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.portfolio_action_sidebar__sector_line {\n  font-size: 12px;\n  font-weight: 500;\n  color: #7b8798;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.portfolio_action_sidebar__rail {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n  min-width: 72px;\n}\n\n.portfolio_action_sidebar__chg {\n  font-size: 14px;\n  font-weight: 800;\n  white-space: nowrap;\n  line-height: 1.2;\n}\n\n.portfolio_action_sidebar__chg.pos {\n  color: #2eb872;\n}\n\n.portfolio_action_sidebar__chg.neg {\n  color: #f05454;\n}\n\n.badge_sidebar_accumulate {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 4px 9px;\n  border-radius: 999px;\n  line-height: 1.2;\n  background: #e5f7ed;\n  color: #2d8a56;\n}\n\n.badge_sidebar_buy {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 4px 9px;\n  border-radius: 999px;\n  line-height: 1.2;\n  background: #e8eeff;\n  color: #3b5ccc;\n}\n\n.badge_sidebar_watch {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 4px 9px;\n  border-radius: 999px;\n  line-height: 1.2;\n  background: #fff4df;\n  color: #c45c26;\n}\n\n.portfolio_action_pills {\n  flex-shrink: 0;\n  padding: 14px 20px 12px;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_action_pills__row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_action_pills__pill {\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  background: #ffffff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  padding: 9px 16px;\n  border-radius: 999px;\n  cursor: pointer;\n  max-width: 168px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.12s ease;\n}\n\n.portfolio_action_pills__pill:hover {\n  background: #ffffff;\n  border-color: rgba(227, 88, 52, 0.4);\n  color: #002141;\n  box-shadow: 0 2px 8px rgba(227, 88, 52, 0.12);\n  transform: translateY(-1px);\n}\n\n.portfolio_action_pills__pill.is_active {\n  background: linear-gradient(135deg, #002141 0%, #0a3a6b 100%);\n  border-color: #002141;\n  color: #ffffff;\n  box-shadow: 0 4px 14px rgba(0, 33, 65, 0.22);\n}\n\n.portfolio_action_pills__pill.is_more {\n  background: #ffffff;\n  border-style: dashed;\n  color: #e35834;\n  font-weight: 700;\n  max-width: none;\n}\n\n.portfolio_action_pills__pill.is_more:hover {\n  background: #fff8f4;\n  border-color: #e35834;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_head {\n  border-top: none;\n}\n\n@media (max-width: 960px) {\n  .portfolio_action_section__layout {\n    flex-direction: column;\n    min-height: 0;\n    padding: 8px;\n  }\n\n  .portfolio_action_sidebar {\n    flex: 0 0 auto;\n    width: 100%;\n    max-width: none;\n    max-height: 42vh;\n  }\n\n  .portfolio_action_section__detail_panel {\n    flex: 1 1 auto;\n    min-height: 48vh;\n  }\n}\n\n/* Stock detail header — title row + compact SIHO */\n.portfolio_detail_head__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.portfolio_detail_head__identity {\n  flex: 1;\n  min-width: 0;\n}\n\n.portfolio_execution_step {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.portfolio_execution_step__section {\n  min-width: 0;\n}\n\n.portfolio_execution_step__section--steps {\n  padding: 16px 18px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_execution_step__heading {\n  margin: 0 0 12px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.portfolio_execution_step__empty {\n  margin: 0;\n  padding: 20px 16px;\n  font-size: 14px;\n  color: #64748b;\n  text-align: center;\n}\n\n.portfolio_execution_step .portfolio_action_item_card {\n  margin-top: 0;\n}\n\n.portfolio_execution_step .portfolio_action_plan {\n  margin-top: 0;\n}\n\n.portfolio_action_item_card {\n  margin-top: 14px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  background: linear-gradient(160deg, #f8fafc 0%, #ffffff 72%);\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_action_item_card__title {\n  margin: 0 0 12px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.portfolio_action_item_card__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));\n  gap: 12px 18px;\n  margin: 0;\n}\n\n.portfolio_action_item_card__row {\n  margin: 0;\n  min-width: 0;\n}\n\n.portfolio_action_item_card__row dt {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.portfolio_action_item_card__row dd {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.portfolio_action_item_card__row dd.pos {\n  color: #059669;\n}\n\n.portfolio_action_item_card__row dd.neg {\n  color: #dc2626;\n}\n\n.portfolio_detail_head__title_row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  margin-bottom: 2px;\n}\n\n.portfolio_detail_head__name_block {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.portfolio_detail_head__name_icon {\n  font-size: 22px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_title {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n}\n\n.portfolio_detail_head__nse_code {\n  font-size: 13px;\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.portfolio_detail_head__score_icon {\n  margin-right: 4px;\n}\n\n.portfolio_detail_kpi__icon {\n  display: block;\n  font-size: 14px;\n  line-height: 1;\n  margin-bottom: 4px;\n  opacity: 0.85;\n}\n\n.portfolio_detail_head__return {\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n  font-variant-numeric: tabular-nums;\n}\n\n.portfolio_detail_head__return.pos {\n  color: #2eb872;\n}\n\n.portfolio_detail_head__return.neg {\n  color: #f05454;\n}\n\n.portfolio_detail_head__score_simple {\n  flex-shrink: 0;\n  align-self: flex-start;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  padding: 0;\n  background: none;\n  border: none;\n  box-shadow: none;\n  text-align: right;\n}\n\n.portfolio_detail_head__score_simple .portfolio_dashboard__score_lbl {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.portfolio_detail_head__score_simple .portfolio_dashboard__score_val {\n  font-size: 22px;\n  font-weight: 900;\n  color: #e35834;\n  line-height: 1;\n}\n\n.portfolio_detail_head__score_simple .portfolio_dashboard__score_of {\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_detail_head__score_simple .portfolio_dashboard__score_meter {\n  width: 72px;\n  margin-top: 2px;\n}\n\n.portfolio_detail_head__meta {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.portfolio_detail_head__tags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_detail_head__tag {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  background: #f1f5f9;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  padding: 5px 10px;\n  border-radius: 8px;\n  line-height: 1.2;\n}\n\n.portfolio_detail_head__tag--exchange {\n  color: #002141;\n  background: #eef2f7;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.portfolio_detail_head__meta_line {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 14px;\n  font-size: 14px;\n  color: #475569;\n}\n\n.portfolio_detail_head__sector {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.portfolio_detail_head__dot {\n  color: #cbd5e1;\n  font-weight: 400;\n  user-select: none;\n}\n\n.portfolio_detail_head__isin {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  font-family: ui-monospace, \"Cascadia Code\", monospace;\n}\n\n.portfolio_dashboard__score_box--compact {\n  flex-shrink: 0;\n  align-self: flex-start;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: center;\n  gap: 4px;\n  padding: 8px 14px;\n  min-width: 0;\n  height: auto;\n  line-height: 1;\n}\n\n.portfolio_dashboard__score_box--compact .portfolio_dashboard__score_lbl {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  order: 0;\n}\n\n.portfolio_dashboard__score_box--compact .portfolio_dashboard__score_val {\n  font-size: 22px;\n  font-weight: 900;\n  color: #e35834;\n  line-height: 1;\n  order: 1;\n}\n\n.portfolio_dashboard__score_box--compact .portfolio_dashboard__score_of {\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  order: 2;\n}\n\n/* —— Action section: stock header + KPI tiles —— */\n.portfolio_action_section .portfolio_dashboard__detail_head {\n  padding: 16px 18px 14px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);\n  display: block;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_title {\n  font-size: 24px;\n  letter-spacing: -0.02em;\n  color: #002141;\n  margin: 0;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_kpis {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  margin-top: 16px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_kpis > span {\n  flex: 1 1 0;\n  min-width: 110px;\n  background: transparent;\n  border: none;\n  border-right: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 0;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: none;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_kpis > span:last-child {\n  border-right: none;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_kpis > span strong {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.portfolio_dashboard__score_box--detail {\n  flex-shrink: 0;\n  align-self: flex-start;\n  min-width: 120px;\n  padding: 12px 14px;\n  text-align: left;\n  background: linear-gradient(145deg, #fff8f4 0%, #ffffff 100%);\n  border: 1px solid rgba(227, 88, 52, 0.22);\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(227, 88, 52, 0.1);\n}\n\n.portfolio_dashboard__score_box--detail .portfolio_dashboard__score_lbl {\n  display: block;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 4px;\n}\n\n.portfolio_dashboard__score_detail_val {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  line-height: 1;\n}\n\n.portfolio_dashboard__score_box--detail .portfolio_dashboard__score_val {\n  font-size: 24px;\n  font-weight: 900;\n  color: #e35834;\n}\n\n.portfolio_dashboard__score_box--detail .portfolio_dashboard__score_of {\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_dashboard__score_meter {\n  margin-top: 8px;\n  height: 4px;\n  border-radius: 999px;\n  background: rgba(0, 33, 65, 0.08);\n  overflow: hidden;\n}\n\n.portfolio_dashboard__score_meter > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #e35834, #f59e0b);\n}\n\n.portfolio_action_section .portfolio_dashboard__tabs {\n  padding: 0 18px;\n  background: #fafbfc;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n  gap: 8px;\n}\n\n/* Prominent segmented tabs on Cut Loss / action stock detail */\n.portfolio_detail_tabs_bar.is_action_section {\n  padding: 16px 18px 18px;\n  background: linear-gradient(180deg, #f1f5f9 0%, #ffffff 55%);\n  border-top: 1px solid rgba(0, 33, 65, 0.06);\n  border-bottom: 2px solid rgba(0, 33, 65, 0.08);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.portfolio_detail_tabs_bar__label {\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #002141;\n}\n\n.portfolio_detail_tabs_bar.is_action_section .portfolio_detail_tabs_bar__tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 0;\n  margin: 0;\n  border-bottom: none;\n  background: transparent;\n}\n\n.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  width: 100%;\n  min-height: 52px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  line-height: 1.15;\n  border-radius: 12px;\n  border: 1.5px solid rgba(0, 33, 65, 0.14);\n  background: #ffffff;\n  color: #475569;\n  margin-bottom: 0;\n  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.06);\n  box-sizing: border-box;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    box-shadow 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab .portfolio_dashboard__tab_icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab:not(.active):hover {\n  border-color: rgba(0, 33, 65, 0.22);\n  background: #f8fafc;\n  color: #002141;\n  box-shadow:\n    0 0 0 1px rgba(0, 33, 65, 0.04),\n    0 8px 18px rgba(0, 33, 65, 0.08);\n  transform: translateY(-1px);\n}\n\n.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab:focus-visible {\n  outline: none;\n  border-color: rgba(227, 88, 52, 0.45);\n  box-shadow:\n    0 0 0 4px rgba(227, 88, 52, 0.16),\n    0 8px 18px rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_detail_tabs_bar.is_action_section .portfolio_dashboard__tab.active {\n  color: #c2410c;\n  background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);\n  border-color: #e35834;\n  border-bottom-color: #e35834;\n  box-shadow:\n    0 0 0 1px rgba(227, 88, 52, 0.12),\n    0 6px 16px rgba(227, 88, 52, 0.2);\n}\n\n@media (max-width: 520px) {\n  .portfolio_detail_tabs_bar.is_action_section .portfolio_detail_tabs_bar__tabs {\n    grid-template-columns: 1fr;\n  }\n}\n\n.portfolio_action_section .portfolio_dashboard__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.portfolio_dashboard__tab_icon {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.portfolio_action_section .portfolio_dashboard__tab.active {\n  color: #e35834;\n  border-bottom-color: #e35834;\n  background: rgba(227, 88, 52, 0.06);\n  border-radius: 8px 8px 0 0;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_body {\n  padding: 16px 18px 18px;\n  background: #ffffff;\n}\n\n/* Section tint: left accent on action step cards */\n.portfolio_action_detail--accumulate .portfolio_action_steps__card {\n  border-left-color: #10b981;\n}\n\n.portfolio_action_detail--average_down .portfolio_action_steps__card {\n  border-left-color: #3b82f6;\n}\n\n.portfolio_action_detail--cut_loss .portfolio_action_steps__card,\n.portfolio_action_detail--exit .portfolio_action_steps__card {\n  border-left-color: #f97316;\n}\n\n.portfolio_action_detail--profit_booking .portfolio_action_steps__card {\n  border-left-color: #f59e0b;\n}\n\n.portfolio_action_detail--hold .portfolio_action_steps__card {\n  border-left-color: #64748b;\n}\n\n@media (max-width: 900px) {\n  .portfolio_action_section .portfolio_dashboard__detail_kpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* Three-phase execution plan */\n.portfolio_execution_page {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n}\n\n.portfolio_execution_page .portfolio_overview__head {\n  margin-bottom: 0;\n}\n\n.portfolio_execution_page .portfolio_overview__action_grid {\n  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));\n  gap: 14px;\n}\n\n.portfolio_execution_page .portfolio_overview__action_card {\n  min-height: 0;\n  padding: 14px;\n}\n\n.portfolio_execution_page .portfolio_overview__action_card_count_num {\n  font-size: 24px;\n}\n\n.portfolio_execution_page .portfolio_overview__net_impact_panel {\n  padding: 18px 20px;\n}\n\n.portfolio_tph {\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  background: #fff9f6;\n  overflow: hidden;\n  box-shadow: 0 2px 14px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_tph--page {\n  margin-bottom: 0;\n  background: #ffffff;\n}\n\n.portfolio_tph--execution_tab {\n  margin-bottom: 16px;\n}\n\n.portfolio_execution_tab {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.portfolio_action_execution_layout {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.portfolio_action_submetrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  background: #f1f5f9;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.portfolio_action_submetrics__item {\n  flex: 1 1 0;\n  min-width: 140px;\n  padding: 14px 18px;\n  border-right: 1px solid rgba(0, 33, 65, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.portfolio_action_submetrics__item:last-child {\n  border-right: none;\n}\n\n.portfolio_action_submetrics__lbl {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.portfolio_action_submetrics__item strong {\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1.25;\n}\n\n.portfolio_action_submetrics__item strong.pos {\n  color: #15803d;\n}\n\n.portfolio_action_submetrics__item strong.neg {\n  color: #dc2626;\n}\n\n.portfolio_action_steps__title {\n  margin: 0 0 12px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.portfolio_action_steps__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portfolio_action_steps__card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 18px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-left: 3px solid #002141;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_action_steps__num {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  background: linear-gradient(145deg, #002141 0%, #0a3a6b 100%);\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.portfolio_action_steps__headline {\n  display: block;\n  font-size: 15px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1.35;\n  margin-bottom: 6px;\n}\n\n.portfolio_action_steps__desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: #64748b;\n}\n\n.portfolio_tph__head {\n  padding: 18px 22px;\n  background: #f8fafc;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px 20px;\n}\n\n.portfolio_tph__head_text {\n  min-width: 0;\n  flex: 1;\n}\n\n.portfolio_tph__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  letter-spacing: 0.02em;\n  line-height: 1.35;\n}\n\n.portfolio_tph__head_sub {\n  margin: 6px 0 0;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.portfolio_tph__head_stats {\n  margin: 4px 0 0;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.portfolio_tph__inner {\n  padding: 20px 22px 22px;\n}\n\n.portfolio_tph__intro_details {\n  margin-bottom: 18px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  overflow: hidden;\n}\n\n.portfolio_tph__intro_details > summary {\n  padding: 10px 14px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  cursor: pointer;\n  list-style: none;\n}\n\n.portfolio_tph__intro_details > summary::-webkit-details-marker {\n  display: none;\n}\n\n.portfolio_tph__intro_details .portfolio_tph__note {\n  margin: 0;\n  padding: 0 14px 12px;\n  font-size: 12px;\n  line-height: 1.55;\n}\n\n.portfolio_tph__note {\n  margin: 0 0 16px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #475569;\n}\n\n.portfolio_tph__note strong {\n  color: #002141;\n  font-weight: 700;\n}\n\n.portfolio_tph__phase_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 18px;\n  align-items: start;\n}\n\n.portfolio_tph--page .portfolio_tph__phase_grid {\n  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr) minmax(0, 1fr);\n  gap: 18px;\n}\n\n.portfolio_tph__phase_card {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 16px 18px;\n  min-width: 0;\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_tph--page .portfolio_tph__phase_card--now {\n  padding: 18px 20px;\n}\n\n.portfolio_tph__phase_title {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #002141;\n  margin-bottom: 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_tph__phase_note {\n  margin: -6px 0 14px;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.portfolio_tph__phase_group {\n  margin-bottom: 16px;\n}\n\n.portfolio_tph__phase_group:last-of-type {\n  margin-bottom: 0;\n}\n\n.portfolio_tph__phase_group_title {\n  margin-bottom: 8px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.portfolio_tph__metric {\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_tph__metric:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.portfolio_tph__metric_main {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px 16px;\n}\n\n.portfolio_tph__metric_lbl {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  line-height: 1.4;\n}\n\n.portfolio_tph__metric_val {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n  text-align: right;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.portfolio_tph__metric_val .pos,\n.portfolio_tph__metric_val.pos {\n  color: #16a34a;\n}\n\n.portfolio_tph__metric_val .neg,\n.portfolio_tph__metric_val.neg {\n  color: #dc2626;\n}\n\n.portfolio_tph__metric_badge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #64748b;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n}\n\n.portfolio_tph__metric_ctx {\n  margin: 6px 0 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: #94a3b8;\n}\n\n.portfolio_tph__metric_ctx strong {\n  color: #64748b;\n  font-weight: 700;\n}\n\n.portfolio_tph__baseline_details {\n  margin-top: 14px;\n  border: 1px dashed #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  overflow: hidden;\n}\n\n.portfolio_tph__baseline_details > summary {\n  padding: 10px 14px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  cursor: pointer;\n  list-style: none;\n}\n\n.portfolio_tph__baseline_details > summary::-webkit-details-marker {\n  display: none;\n}\n\n.portfolio_tph__baseline_list {\n  margin: 0;\n  padding: 0 14px 12px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.portfolio_tph__baseline_list li {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.portfolio_tph__baseline_list li span:first-child {\n  font-weight: 700;\n  color: #334155;\n}\n\n.portfolio_tph__baseline_list li strong {\n  color: #0f172a;\n}\n\n/* Legacy row classes (stock detail tab) */\n.portfolio_tph__row {\n  font-size: 14px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 4px 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_tph__row:last-child {\n  border-bottom: none;\n}\n\n.portfolio_tph__row_lbl {\n  color: #475569;\n  font-weight: 600;\n  flex: 1 1 auto;\n  min-width: 120px;\n}\n\n.portfolio_tph__row_val {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n  text-align: right;\n}\n\n.portfolio_tph__row_val .pos,\n.portfolio_tph__row_val.pos {\n  color: #16a34a;\n}\n\n.portfolio_tph__row_val .neg,\n.portfolio_tph__row_val.neg {\n  color: #dc2626;\n}\n\n.portfolio_tph__row_sub {\n  flex: 1 1 100%;\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 4px;\n  line-height: 1.45;\n}\n\n.portfolio_tph__row_sub strong {\n  color: #64748b;\n  font-weight: 700;\n}\n\n.portfolio_tph__pct {\n  color: #94a3b8;\n}\n\n.portfolio_tph__collapsible {\n  margin-top: 6px;\n  border-top: 1px solid rgba(0, 33, 65, 0.06);\n  padding-top: 8px;\n}\n\n.portfolio_tph__collapsible > summary {\n  list-style: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #475569;\n}\n\n.portfolio_tph__collapsible > summary::-webkit-details-marker {\n  display: none;\n}\n\n.portfolio_tph__collapsible_peek {\n  font-weight: 800;\n  color: #002141;\n}\n\n.portfolio_tph__collapsible_panel {\n  padding: 10px 0 2px;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.55;\n}\n\n.portfolio_tph__collapsible_panel p {\n  margin: 8px 0 0;\n}\n\n.portfolio_tph__footer {\n  padding: 16px 18px;\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n}\n\n.portfolio_tph__footer_heading {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #002141;\n  margin-bottom: 10px;\n}\n\n.portfolio_tph__footer_row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 12px 16px;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  font-size: 13px;\n}\n\n.portfolio_tph__footer_row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.portfolio_tph__footer_lbl {\n  color: #475569;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.portfolio_tph__footer_val {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.portfolio_tph__footer_val.neg {\n  color: #dc2626;\n}\n\n@media (max-width: 960px) {\n  .portfolio_tph__phase_grid,\n  .portfolio_tph--page .portfolio_tph__phase_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_tph__metric_main,\n  .portfolio_tph__footer_row {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_tph__metric_val,\n  .portfolio_tph__footer_val {\n    text-align: left;\n    justify-content: flex-start;\n  }\n}\n\n/* Action section bucket totals */\n.portfolio_action_totals {\n  margin: 0;\n  border-radius: 14px;\n  padding: 12px 14px 14px;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  box-shadow: 0 2px 14px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_action_totals--accumulate {\n  background: linear-gradient(135deg, #ecfdf5 0%, #ffffff 55%);\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.portfolio_action_totals--average_down {\n  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 55%);\n  border-color: rgba(59, 130, 246, 0.2);\n}\n\n.portfolio_action_totals--cut_loss,\n.portfolio_action_totals--exit {\n  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 55%);\n  border-color: rgba(249, 115, 22, 0.22);\n}\n\n.portfolio_action_totals--profit_booking {\n  background: linear-gradient(135deg, #fffbeb 0%, #ffffff 55%);\n  border-color: rgba(245, 158, 11, 0.22);\n}\n\n.portfolio_action_totals__title {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  color: #002141;\n}\n\n.portfolio_action_totals__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.portfolio_action_totals__chip {\n  flex: 1 1 140px;\n  min-width: 120px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow:\n    0 1px 4px rgba(0, 33, 65, 0.04),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.portfolio_action_totals--accumulate .portfolio_action_totals__chip {\n  background: #ffffff;\n  border-color: rgba(16, 185, 129, 0.12);\n}\n\n.portfolio_action_totals--average_down .portfolio_action_totals__chip {\n  background: #ffffff;\n  border-color: rgba(59, 130, 246, 0.12);\n}\n\n.portfolio_action_totals--cut_loss .portfolio_action_totals__chip,\n.portfolio_action_totals--exit .portfolio_action_totals__chip {\n  background: #ffffff;\n  border-color: rgba(249, 115, 22, 0.12);\n}\n\n.portfolio_action_totals--profit_booking .portfolio_action_totals__chip {\n  background: #ffffff;\n  border-color: rgba(245, 158, 11, 0.14);\n}\n\n.portfolio_action_totals__chip span {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  color: #475569;\n}\n\n.portfolio_action_totals__chip strong {\n  font-size: 17px;\n  font-weight: 800;\n  color: #002141;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_action_totals__hint {\n  margin: 10px 0 0;\n  font-size: 11px;\n  line-height: 1.55;\n  color: #64748b;\n}\n\n/* Per-stock action plan cards */\n.portfolio_action_plan {\n  border-radius: 14px;\n  padding: 16px 18px;\n  margin-bottom: 14px;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_action_plan--cut {\n  background: linear-gradient(160deg, #fff7ed 0%, #ffffff 65%);\n  border-color: rgba(249, 115, 22, 0.22);\n}\n\n/* Staggered cut loss — execution step card */\n.portfolio_cut_loss_plan {\n  margin-top: 4px;\n  margin-bottom: 14px;\n  padding: 18px 20px;\n  border-radius: 14px;\n  border: 1px dashed rgba(220, 38, 38, 0.28);\n  background: linear-gradient(165deg, rgba(254, 242, 242, 0.55) 0%, rgba(255, 255, 255, 0.92) 48%);\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;\n}\n\n.portfolio_cut_loss_plan__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.portfolio_cut_loss_plan__title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #002141;\n}\n\n.portfolio_cut_loss_plan__lead {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n  max-width: 42ch;\n}\n\n.portfolio_cut_loss_plan__badge {\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #b91c1c;\n  background: rgba(254, 226, 226, 0.85);\n  border: 1px solid rgba(220, 38, 38, 0.18);\n}\n\n.portfolio_cut_loss_plan__subhead {\n  margin: 14px 0 10px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #ea580c;\n}\n\n.portfolio_cut_loss_plan__empty {\n  margin: 8px 0 0;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n  background: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_cut_loss_step {\n  display: grid;\n  grid-template-columns: 88px minmax(0, 1fr) auto;\n  gap: 10px 14px;\n  align-items: center;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  box-shadow: 0 1px 2px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_cut_loss_step + .portfolio_cut_loss_step,\n.portfolio_cut_loss_plan__subhead + .portfolio_cut_loss_step {\n  margin-top: 8px;\n}\n\n.portfolio_cut_loss_step--now {\n  border-color: rgba(220, 38, 38, 0.16);\n  background: linear-gradient(90deg, rgba(254, 242, 242, 0.45) 0%, rgba(255, 255, 255, 0.95) 36%);\n}\n\n.portfolio_cut_loss_step__left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.portfolio_cut_loss_step__num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  color: #fff;\n  background: #002141;\n}\n\n.portfolio_cut_loss_step--now .portfolio_cut_loss_step__num {\n  background: #dc2626;\n}\n\n.portfolio_cut_loss_step__lbl {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.portfolio_cut_loss_step__body {\n  min-width: 0;\n}\n\n.portfolio_cut_loss_step__trade {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #334155;\n}\n\n.portfolio_cut_loss_step__trade strong {\n  font-weight: 800;\n  color: #002141;\n}\n\n.portfolio_cut_loss_step__price {\n  color: #002141;\n}\n\n.portfolio_cut_loss_step__upside {\n  margin: 4px 0 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_cut_loss_step__metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-top: 8px;\n}\n\n.portfolio_cut_loss_metric {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.portfolio_cut_loss_metric__lbl {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.portfolio_cut_loss_metric__val {\n  font-size: 12px;\n  font-weight: 800;\n  color: #334155;\n}\n\n.portfolio_cut_loss_step__tag {\n  justify-self: end;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.portfolio_cut_prob--spot {\n  color: #64748b;\n  background: rgba(100, 116, 139, 0.1);\n}\n\n.portfolio_cut_prob--hi {\n  color: #15803d;\n  background: rgba(34, 197, 94, 0.12);\n}\n\n.portfolio_cut_prob--md {\n  color: #b45309;\n  background: rgba(245, 158, 11, 0.14);\n}\n\n.portfolio_cut_prob--lo {\n  color: #64748b;\n  background: rgba(100, 116, 139, 0.1);\n}\n\n.portfolio_cut_prob--muted {\n  color: #94a3b8;\n  background: rgba(148, 163, 184, 0.12);\n}\n\n.portfolio_cut_loss_plan__stop {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 14px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: rgba(254, 226, 226, 0.45);\n  border: 1px solid rgba(220, 38, 38, 0.18);\n}\n\n.portfolio_cut_loss_plan__stop_icon {\n  flex-shrink: 0;\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.portfolio_cut_loss_plan__stop_text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #7f1d1d;\n}\n\n.portfolio_cut_loss_plan__stop_text strong {\n  font-weight: 800;\n  color: #b91c1c;\n}\n\n.portfolio_cut_loss_plan__stop_text span {\n  color: #991b1b;\n}\n\n@media (max-width: 640px) {\n  .portfolio_cut_loss_plan {\n    padding: 14px 14px;\n  }\n\n  .portfolio_cut_loss_plan__head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .portfolio_cut_loss_step {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .portfolio_cut_loss_step__tag {\n    justify-self: start;\n  }\n}\n\n.portfolio_action_plan--avg {\n  background: linear-gradient(160deg, #eff6ff 0%, #ffffff 65%);\n  border-color: rgba(59, 130, 246, 0.22);\n}\n\n.portfolio_action_plan__title {\n  margin: 0 0 14px;\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  letter-spacing: 0.01em;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_action_plan__intro,\n.portfolio_action_plan__muted {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.55;\n  color: #64748b;\n}\n\n.portfolio_action_plan__subhead {\n  margin: 12px 0 8px;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #002141;\n}\n\n.portfolio_action_plan__metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(148px, 1fr));\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.portfolio_action_plan__metrics > div {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 12px 14px;\n  box-shadow:\n    0 1px 4px rgba(0, 33, 65, 0.04),\n    inset 0 1px 0 rgba(255, 255, 255, 0.95);\n}\n\n.portfolio_action_plan--buy .portfolio_action_plan__metrics > div {\n  background: #f0fdf4;\n  border-color: rgba(16, 185, 129, 0.14);\n}\n\n.portfolio_action_plan--avg .portfolio_action_plan__metrics > div {\n  background: #f0f9ff;\n  border-color: rgba(59, 130, 246, 0.14);\n}\n\n.portfolio_action_plan--cut .portfolio_action_plan__metrics > div {\n  background: #fff7ed;\n  border-color: rgba(249, 115, 22, 0.14);\n}\n\n.portfolio_action_plan--profit .portfolio_action_plan__metrics > div {\n  background: #fffbeb;\n  border-color: rgba(245, 158, 11, 0.16);\n}\n\n.portfolio_action_plan--hold .portfolio_action_plan__metrics > div {\n  background: #f8fafc;\n  border-color: rgba(100, 116, 139, 0.1);\n}\n\n.portfolio_action_plan--trade .portfolio_action_plan__metrics > div {\n  background: #f8fafc;\n  border-color: rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_action_plan__metrics span {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  margin-bottom: 6px;\n}\n\n.portfolio_action_plan__metrics strong {\n  font-size: 16px;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.25;\n}\n\n.portfolio_action_plan__foot {\n  margin: 12px 0 0;\n  padding-top: 10px;\n  border-top: 1px solid rgba(0, 33, 65, 0.08);\n  font-size: 12px;\n  color: #64748b;\n}\n\n.portfolio_lh_phase_list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.portfolio_lh_phase_row {\n  display: grid;\n  grid-template-columns: 72px 1fr auto;\n  gap: 8px 12px;\n  align-items: start;\n  font-size: 12px;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.65);\n  border-radius: 8px;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_lh_phase_lbl {\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.portfolio_lh_phase_body {\n  color: #334155;\n  line-height: 1.5;\n}\n\n.portfolio_lh_price {\n  font-weight: 700;\n  color: #002141;\n}\n\n.portfolio_lh_muted {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.portfolio_lh_prob {\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n@media (max-width: 640px) {\n  .portfolio_lh_phase_row {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_lh_prob {\n    padding-left: 0;\n  }\n}\n\n/* AI expert view */\n.portfolio_expert_view {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.portfolio_action_section .portfolio_dashboard__detail_body {\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.portfolio_expert_section {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  padding: 16px 18px;\n  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_expert_section__title {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  color: #002141;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_expert_section__icon {\n  font-size: 17px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.portfolio_expert_section__text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.75;\n  color: #1e293b;\n}\n\n/* SIHO score cards (replaces progress bars) */\n.portfolio_siho_scores_panel {\n  background: linear-gradient(160deg, #f8fafc 0%, #ffffff 100%);\n}\n\n.portfolio_siho_scores_grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.portfolio_siho_score_card {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 14px 12px;\n  text-align: center;\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_siho_score_card.is_combined {\n  background: linear-gradient(145deg, #fff8f4 0%, #ffffff 100%);\n  border-color: rgba(227, 88, 52, 0.2);\n  box-shadow: 0 2px 10px rgba(227, 88, 52, 0.08);\n}\n\n.portfolio_siho_score_card__lbl {\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: none;\n  letter-spacing: 0;\n  color: #334155;\n  margin-bottom: 8px;\n}\n\n.portfolio_siho_score_card__val {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 3px;\n  line-height: 1;\n}\n\n.portfolio_siho_score_card__val strong {\n  font-size: 26px;\n  font-weight: 900;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_siho_score_card__val small {\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_siho_score_card.is_high .portfolio_siho_score_card__val strong {\n  color: #16a34a;\n}\n\n.portfolio_siho_score_card.is_mid .portfolio_siho_score_card__val strong {\n  color: #d97706;\n}\n\n.portfolio_siho_score_card.is_low .portfolio_siho_score_card__val strong {\n  color: #dc2626;\n}\n\n.portfolio_siho_score_card.is_combined .portfolio_siho_score_card__val strong {\n  color: #e35834;\n}\n\n.portfolio_siho_score_card.is_muted .portfolio_siho_score_card__val strong {\n  color: #94a3b8;\n}\n\n@media (max-width: 768px) {\n  .portfolio_siho_scores_grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* Stock deep dive — collapsible dropdown sections */\n.portfolio_analysis_stack {\n  margin-top: 4px;\n  padding-top: 0;\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.portfolio_analysis_stack__title {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  color: #002141;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_analysis_stack__icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.portfolio_analysis_dropdown {\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_analysis_dropdown__summary {\n  list-style: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  font-family: inherit;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  user-select: none;\n}\n\n.portfolio_analysis_dropdown__summary::-webkit-details-marker {\n  display: none;\n}\n\n.portfolio_analysis_dropdown[open] .portfolio_analysis_dropdown__summary {\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_analysis_dropdown__icon {\n  font-size: 16px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.portfolio_analysis_dropdown__title {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 700;\n  color: #002141;\n  text-align: left;\n}\n\n.portfolio_analysis_dropdown__chev {\n  font-size: 12px;\n  color: #94a3b8;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.portfolio_analysis_dropdown[open] .portfolio_analysis_dropdown__chev {\n  transform: rotate(180deg);\n}\n\n.portfolio_analysis_dropdown__body {\n  padding: 12px 14px 14px;\n  background: #ffffff;\n}\n\n.portfolio_analysis_section {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_analysis_section__title {\n  margin: 0;\n  padding: 14px 18px;\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  color: #002141;\n  background: linear-gradient(180deg, #eef2f7 0%, #f8fafc 100%);\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.portfolio_analysis_section__icon {\n  font-size: 17px;\n  line-height: 1;\n}\n\n.portfolio_analysis_section__body {\n  padding: 14px 16px 16px;\n  background: #ffffff;\n}\n\n.portfolio_analysis_acc {\n  margin-bottom: 8px;\n  border: 1px solid rgba(0, 33, 65, 0.1);\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_analysis_acc__toggle {\n  width: 100%;\n  border: none;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\n.portfolio_analysis_acc__toggle.is_open {\n  border-bottom: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_analysis_acc__icon {\n  font-size: 16px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.portfolio_analysis_acc__title {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 700;\n  color: #002141;\n}\n\n.portfolio_analysis_acc__arrow {\n  font-size: 10px;\n  color: #94a3b8;\n  transition: transform 0.2s ease;\n}\n\n.portfolio_analysis_acc__toggle.is_open .portfolio_analysis_acc__arrow {\n  transform: rotate(180deg);\n}\n\n.portfolio_analysis_acc__body {\n  padding: 12px 14px 14px;\n  background: #ffffff;\n}\n\n.portfolio_analysis_row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 4px 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n  font-size: 15px;\n}\n\n.portfolio_analysis_row:last-child {\n  border-bottom: none;\n}\n\n.portfolio_analysis_row__lbl {\n  color: #475569;\n  font-weight: 600;\n  flex: 1 1 140px;\n}\n\n.portfolio_analysis_row__val {\n  font-weight: 700;\n  color: #0f172a;\n  text-align: right;\n}\n\n.portfolio_analysis_row__val.is_strong {\n  color: #e35834;\n}\n\n.portfolio_analysis_note {\n  margin: 10px 0 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: #475569;\n}\n\n.portfolio_analysis_insight_grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.portfolio_analysis_insight_card {\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.portfolio_analysis_insight_card--wide h5 {\n  margin: 0 0 6px;\n  font-size: 14px;\n  font-weight: 800;\n  text-transform: none;\n  letter-spacing: 0.01em;\n  color: #002141;\n}\n\n.portfolio_analysis_insight_card--wide p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: #1e293b;\n}\n\n/* Future outlook — narrative blocks (matches dashboard cards) */\n.portfolio_future_outlook {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portfolio_future_outlook__scores {\n  padding: 12px 14px;\n  background: #fff9f6;\n  border-color: rgba(0, 33, 65, 0.07);\n}\n\n.portfolio_narrative_grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portfolio_narrative_card {\n  background: #fff9f6;\n  border: 1px solid rgba(0, 33, 65, 0.07);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_narrative_card__title {\n  margin: 0;\n  padding: 12px 16px;\n  font-size: 15px;\n  font-weight: 800;\n  color: #002141;\n  background: #f3eeea;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_narrative_card__body {\n  padding: 14px 16px 16px;\n  background: #fff9f6;\n}\n\n.portfolio_narrative_card__topic {\n  margin: 0 0 10px;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #002141;\n}\n\n.portfolio_narrative_card__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.portfolio_narrative_card__item {\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_narrative_card__item:first-child {\n  padding-top: 0;\n}\n\n.portfolio_narrative_card__item:last-child {\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.portfolio_narrative_card__line {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.75;\n  color: #1e293b;\n  font-weight: 400;\n}\n\n.portfolio_narrative_card__note {\n  margin: 6px 0 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: #64748b;\n}\n\n.portfolio_narrative__metric {\n  font-weight: 700;\n  color: #002141;\n}\n\n.portfolio_analysis_sr_table_wrap {\n  margin-top: 12px;\n}\n\n.portfolio_analysis_sr_table_wrap h5 {\n  margin: 0 0 8px;\n  font-size: 14px;\n  font-weight: 800;\n  text-transform: none;\n  color: #002141;\n}\n\n.portfolio_analysis_sr_table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.portfolio_analysis_sr_table th,\n.portfolio_analysis_sr_table td {\n  padding: 6px 8px;\n  text-align: center;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_analysis_sr_table th {\n  background: #f8fafc;\n  font-weight: 700;\n  color: #475569;\n}\n\n.portfolio_analysis_sr_table td {\n  color: #0f172a;\n}\n\n.portfolio_analysis_muted {\n  color: #94a3b8 !important;\n}\n\n/* Industry peers */\n.portfolio_peers_panel__industry {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n  line-height: 1.45;\n}\n\n.portfolio_peers_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.portfolio_peer_card {\n  background: #fff9f6;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 14px 14px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 100%;\n  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_peer_card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.portfolio_peer_card__identity {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.portfolio_peer_card__code {\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n}\n\n.portfolio_peer_card__name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.portfolio_peer_card__score {\n  flex-shrink: 0;\n  text-align: right;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: #f1f5f9;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_peer_card__score.is_high {\n  background: #ecfdf5;\n  border-color: rgba(22, 163, 74, 0.2);\n}\n\n.portfolio_peer_card__score.is_mid {\n  background: #fffbeb;\n  border-color: rgba(217, 119, 6, 0.2);\n}\n\n.portfolio_peer_card__score.is_low {\n  background: #fef2f2;\n  border-color: rgba(220, 38, 38, 0.18);\n}\n\n.portfolio_peer_card__score_lbl {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-bottom: 2px;\n}\n\n.portfolio_peer_card__score_val {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  gap: 2px;\n  line-height: 1;\n}\n\n.portfolio_peer_card__score_val strong {\n  font-size: 18px;\n  font-weight: 900;\n  color: #002141;\n}\n\n.portfolio_peer_card__score.is_high .portfolio_peer_card__score_val strong {\n  color: #16a34a;\n}\n\n.portfolio_peer_card__score.is_mid .portfolio_peer_card__score_val strong {\n  color: #d97706;\n}\n\n.portfolio_peer_card__score.is_low .portfolio_peer_card__score_val strong {\n  color: #dc2626;\n}\n\n.portfolio_peer_card__score_val small {\n  font-size: 12px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_peer_card__mcap {\n  font-size: 14px;\n  font-weight: 700;\n  color: #002141;\n  padding-top: 2px;\n  border-top: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_peer_card__breakdown {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n  margin-top: auto;\n}\n\n.portfolio_peer_chip {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.07);\n  border-radius: 8px;\n  padding: 8px 6px;\n  text-align: center;\n}\n\n.portfolio_peer_chip__lbl {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1.2;\n  margin-bottom: 4px;\n}\n\n.portfolio_peer_chip strong {\n  font-size: 14px;\n  font-weight: 800;\n  color: #002141;\n}\n\n.portfolio_peer_chip.is_high strong {\n  color: #16a34a;\n}\n\n.portfolio_peer_chip.is_mid strong {\n  color: #d97706;\n}\n\n.portfolio_peer_chip.is_low strong {\n  color: #dc2626;\n}\n\n.portfolio_peer_chip.is_muted strong {\n  color: #94a3b8;\n}\n\n@media (max-width: 960px) {\n  .portfolio_peers_grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (min-width: 961px) and (max-width: 1100px) {\n  .portfolio_peers_grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.portfolio_action_plan--buy {\n  background: linear-gradient(160deg, #ecfdf5 0%, #ffffff 60%);\n  border-color: rgba(16, 185, 129, 0.22);\n}\n\n.portfolio_action_plan--hold {\n  background: linear-gradient(160deg, #f1f5f9 0%, #ffffff 60%);\n  border-color: rgba(100, 116, 139, 0.15);\n}\n\n.portfolio_action_plan--profit {\n  background: linear-gradient(160deg, #fffbeb 0%, #ffffff 60%);\n  border-color: rgba(245, 158, 11, 0.22);\n}\n\n.portfolio_action_plan--trade {\n  background: linear-gradient(160deg, #f8fafc 0%, #ffffff 60%);\n}\n\n.portfolio_action_rationale {\n  margin-top: 0;\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 14px 16px !important;\n  box-shadow: 0 1px 6px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_action_rationale h4 {\n  font-size: 15px;\n  font-weight: 800;\n  text-transform: none;\n  letter-spacing: 0.01em;\n  color: #002141;\n  margin: 0 0 8px;\n}\n\n.portfolio_action_rationale p {\n  font-size: 15px;\n  line-height: 1.65;\n  color: #1e293b;\n}\n\n.portfolio_dashboard__panel h4 {\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  margin: 0 0 10px;\n}\n\n.portfolio_dashboard__panel p {\n  font-size: 15px;\n  line-height: 1.65;\n  color: #1e293b;\n}\n\n.portfolio_lh_phase_row {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(0, 33, 65, 0.08);\n  box-shadow: 0 1px 3px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_action_section .portfolio_expert_view {\n  gap: 14px;\n}\n\n.portfolio_action_section .portfolio_analysis_dropdown__body .portfolio_analysis_insight_card {\n  background: #f8fafc;\n}\n\n/* —— Portfolio stock detail (holdings view) —— */\n.portfolio_stock_detail {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portfolio_stock_detail__summary {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 12px 16px 0;\n  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_stock_detail__summary_top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n}\n\n.portfolio_stock_detail__tags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.portfolio_stock_detail__tag {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.portfolio_stock_detail__score_inline {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border-radius: 8px;\n  background: rgba(227, 88, 52, 0.08);\n}\n\n.portfolio_stock_detail__score_cap {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-right: 2px;\n}\n\n.portfolio_stock_detail__score_inline strong {\n  font-size: 16px;\n  font-weight: 800;\n  color: #e35834;\n  line-height: 1;\n}\n\n.portfolio_stock_detail__score_of {\n  font-size: 12px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.portfolio_stock_detail__metrics {\n  display: flex;\n  flex-wrap: wrap;\n  border-top: 1px solid rgba(0, 33, 65, 0.08);\n}\n\n.portfolio_stock_detail__metric {\n  flex: 1 1 0;\n  min-width: 100px;\n  padding: 10px 14px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_stock_detail__metric:last-child {\n  border-right: none;\n}\n\n.portfolio_stock_detail__metric span {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.portfolio_stock_detail__metric strong {\n  font-size: 14px;\n  font-weight: 800;\n  color: #002141;\n}\n\n.portfolio_stock_detail__body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.portfolio_stock_detail__insights {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  align-items: start;\n}\n\n.portfolio_stock_detail__insights > .portfolio_detail_card {\n  align-self: start;\n  height: auto;\n  min-height: 0;\n}\n\n.portfolio_detail_card {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 10px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_siho_scores.portfolio_detail_card {\n  padding-bottom: 14px;\n  display: flex;\n  flex-direction: column;\n  align-self: start;\n}\n\n.portfolio_detail_card__title {\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  color: #002141;\n  margin: 0 0 10px;\n}\n\n.portfolio_detail_card__text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.7;\n  color: #1e293b;\n}\n\n.portfolio_chart_panel--tight {\n  padding: 12px 14px 8px;\n}\n\n.portfolio_chart_panel--tight .portfolio_chart_panel__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px 12px;\n  margin-bottom: 6px;\n}\n\n.portfolio_chart_panel--tight .portfolio_detail_card__title {\n  margin: 0;\n}\n\n.portfolio_chart_panel--tight .portfolio_chart_panel__sub {\n  margin: 0;\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.portfolio_chart.is_compact {\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n}\n\n.portfolio_chart.is_compact .portfolio_chart__legend {\n  margin-bottom: 2px;\n  padding-left: 0;\n}\n\n.portfolio_chart.is_compact .portfolio_chart__svg {\n  width: 100%;\n  height: auto;\n  max-height: 168px;\n  display: block;\n}\n\n.portfolio_panel_title {\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #002141;\n  margin: 0 0 12px;\n}\n\n.portfolio_detail_stack {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.portfolio_siho_scores__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.portfolio_siho_scores__item {\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 10px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.portfolio_siho_scores__score_line {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.portfolio_siho_scores__grid.is_row {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  flex: 0 0 auto;\n}\n\n.portfolio_siho_scores__grid.is_row .portfolio_siho_scores__item.is_highlight {\n  grid-column: auto;\n  background: linear-gradient(145deg, #fff8f4 0%, #ffffff 100%);\n  border-color: rgba(227, 88, 52, 0.22);\n  box-shadow: 0 2px 10px rgba(227, 88, 52, 0.08);\n}\n\n.portfolio_impact_card.portfolio_detail_card {\n  align-self: start;\n  height: auto;\n}\n\n.portfolio_siho_scores__item.is_highlight {\n  grid-column: 1 / -1;\n  background: #fff8f4;\n  border-color: rgba(227, 88, 52, 0.2);\n}\n\n.portfolio_siho_scores__label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n}\n\n.portfolio_siho_scores__grid.is_row .portfolio_siho_scores__val {\n  font-size: 18px;\n}\n\n.portfolio_siho_scores__val {\n  font-size: 22px;\n  color: #002141;\n  line-height: 1;\n}\n\n.portfolio_siho_scores__of {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.portfolio_impact_card__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.portfolio_impact_card__chip {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(0, 33, 65, 0.08);\n  color: #002141;\n}\n\n.portfolio_impact_card__chip.is_muted {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.portfolio_impact_card__metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 14px;\n  margin-bottom: 12px;\n}\n\n.portfolio_impact_card.portfolio_detail_card .portfolio_impact_card__metrics > div {\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.06);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.portfolio_impact_card__metrics > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.portfolio_impact_card__metrics span {\n  font-size: 13px;\n  color: #475569;\n  font-weight: 600;\n}\n\n.portfolio_impact_card__metrics strong {\n  font-size: 16px;\n  color: #0f172a;\n}\n\n.portfolio_impact_summary {\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-left: 3px solid #e35834;\n  border-radius: 10px;\n  padding: 14px 18px;\n}\n\n.portfolio_impact_summary__text {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.85;\n  color: #1e293b;\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n}\n\n.portfolio_impact_summary__highlight {\n  font-weight: 800;\n  color: #002141;\n}\n\n.portfolio_chart_panel__sub {\n  margin: -6px 0 14px;\n  font-size: 14px;\n  color: #475569;\n}\n\n.portfolio_chart {\n  background: #f8fafc;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 12px 12px 8px;\n}\n\n.portfolio_chart__plot {\n  width: 100%;\n}\n\n.portfolio_chart__legend {\n  display: flex;\n  gap: 18px;\n  margin-bottom: 8px;\n  padding-left: 4px;\n}\n\n.portfolio_chart__legend_item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.portfolio_chart__legend_dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.portfolio_chart__legend_item.is_stock .portfolio_chart__legend_dot {\n  background: #3b82f6;\n}\n\n.portfolio_chart__legend_item.is_nifty .portfolio_chart__legend_dot {\n  background: transparent;\n  border: 2px dashed #22c55e;\n  border-radius: 2px;\n  width: 14px;\n  height: 0;\n}\n\n.portfolio_chart__svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.portfolio_chart__grid {\n  stroke: rgba(148, 163, 184, 0.22);\n  stroke-width: 1;\n}\n\n.portfolio_chart__zero {\n  stroke: rgba(100, 116, 139, 0.45);\n  stroke-width: 1.25;\n  stroke-dasharray: 6 5;\n}\n\n.portfolio_chart__area {\n  pointer-events: none;\n}\n\n.portfolio_chart__line.is_stock {\n  stroke: #2563eb;\n  stroke-width: 3.25;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.portfolio_chart.is_premium .portfolio_chart__line.is_stock {\n  stroke-width: 3.5;\n}\n\n.portfolio_chart__line.is_nifty {\n  stroke: #059669;\n  stroke-width: 2.75;\n  stroke-dasharray: 10 7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  opacity: 0.92;\n}\n\n.portfolio_chart__point.is_stock {\n  fill: #2563eb;\n  stroke: #ffffff;\n  stroke-width: 2.5;\n  pointer-events: none;\n}\n\n.portfolio_chart__point.is_nifty {\n  fill: #059669;\n  stroke: #ffffff;\n  stroke-width: 2;\n  pointer-events: none;\n}\n\n.portfolio_chart__point_halo.is_stock {\n  fill: rgba(37, 99, 235, 0.14);\n  stroke: none;\n  pointer-events: none;\n}\n\n.portfolio_chart__hit {\n  cursor: pointer;\n}\n\n.portfolio_chart__hit_dot {\n  cursor: pointer;\n  pointer-events: all;\n}\n\n.portfolio_chart__period_hit {\n  pointer-events: all;\n}\n\n.portfolio_chart__hover_layer {\n  pointer-events: none;\n}\n\n.portfolio_chart__axis_label {\n  fill: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.portfolio_chart__axis_label.is_period {\n  fill: #334155;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.portfolio_chart__marker {\n  stroke: rgba(37, 99, 235, 0.35);\n  stroke-width: 1.5;\n  stroke-dasharray: 5 5;\n}\n\n.portfolio_chart__tooltip {\n  fill: rgba(15, 23, 42, 0.94);\n  stroke: rgba(255, 255, 255, 0.08);\n  stroke-width: 1;\n  filter: drop-shadow(0 8px 20px rgba(15, 23, 42, 0.22));\n}\n\n/* Reports page */\n.portfolio_reports_page {\n  padding: 20px 22px 28px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.portfolio_reports_hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px 24px;\n  width: 100%;\n  padding: 22px 24px;\n  background: linear-gradient(135deg, #fff9f6 0%, #ffffff 55%);\n  border: 1px solid rgba(241, 86, 35, 0.18);\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 33, 65, 0.06);\n  margin-bottom: 20px;\n}\n\n.portfolio_reports_hero__copy {\n  flex: 1;\n  min-width: 200px;\n}\n\n.portfolio_reports_hero__title {\n  margin: 0 0 8px;\n  font-size: 24px;\n  font-weight: 800;\n  color: #002141;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_reports_hero__sub {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.55;\n  color: #475569;\n}\n\n.portfolio_reports_hero__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 22px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.portfolio_reports_stats {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.portfolio_reports_stat {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 12px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 8px rgba(0, 33, 65, 0.04);\n}\n\n.portfolio_reports_stat__lbl {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.portfolio_reports_stat__val {\n  display: block;\n  font-size: 18px;\n  font-weight: 800;\n  color: #002141;\n  line-height: 1.2;\n}\n\n.portfolio_reports_stat__val.pos {\n  color: #16a34a;\n}\n\n.portfolio_reports_stat__val.neg {\n  color: #dc2626;\n}\n\n.portfolio_reports_grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.portfolio_reports_card {\n  background: #ffffff;\n  border: 1px solid rgba(0, 33, 65, 0.08);\n  border-radius: 14px;\n  padding: 20px 22px;\n  box-shadow: 0 2px 12px rgba(0, 33, 65, 0.05);\n}\n\n.portfolio_reports_card--tip {\n  background: #f8fafc;\n}\n\n.portfolio_reports_card__title {\n  margin: 0 0 14px;\n  font-size: 15px;\n  font-weight: 800;\n  color: #002141;\n}\n\n.portfolio_reports_list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.portfolio_reports_list li {\n  position: relative;\n  padding: 10px 0 10px 22px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #334155;\n  border-bottom: 1px solid rgba(0, 33, 65, 0.06);\n}\n\n.portfolio_reports_list li:last-child {\n  border-bottom: none;\n}\n\n.portfolio_reports_list li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 16px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #f15623;\n}\n\n.portfolio_reports_steps {\n  margin: 0 0 16px;\n  padding-left: 20px;\n  font-size: 14px;\n  line-height: 1.65;\n  color: #475569;\n}\n\n.portfolio_reports_steps li + li {\n  margin-top: 8px;\n}\n\n.portfolio_reports_card__btn {\n  width: 100%;\n  justify-content: center;\n}\n\n@media (max-width: 900px) {\n  .portfolio_reports_stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .portfolio_reports_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .portfolio_reports_hero__btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* ── Print report (Download Report) ───────────────────────────── */\n.portfolio_print_report {\n  display: none;\n}\n\n.portfolio_print__header {\n  text-align: center;\n  padding: 0 0 20px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid #002141;\n}\n\n.portfolio_print__logo {\n  display: block;\n  margin: 0 auto 16px;\n  max-height: 72px;\n  width: auto;\n}\n\n.portfolio_print__title {\n  margin: 0 0 6px;\n  font-size: 26px;\n  font-weight: 800;\n  color: #002141;\n  letter-spacing: -0.02em;\n}\n\n.portfolio_print__meta {\n  margin: 0 0 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #f15623;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.portfolio_print__date {\n  margin: 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.portfolio_print__section {\n  margin-bottom: 28px;\n  page-break-inside: avoid;\n}\n\n.portfolio_print__section_title {\n  margin: 0 0 14px;\n  font-size: 16px;\n  font-weight: 800;\n  color: #002141;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.portfolio_print__subsection_title {\n  margin: 18px 0 10px;\n  font-size: 13px;\n  font-weight: 800;\n  color: #334155;\n}\n\n.portfolio_print__metric_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px 16px;\n}\n\n.portfolio_print__metric {\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.portfolio_print__metric_lbl {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.portfolio_print__metric_val {\n  display: block;\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.portfolio_print__metric_val.is_pos {\n  color: #16a34a;\n}\n\n.portfolio_print__metric_val.is_neg {\n  color: #dc2626;\n}\n\n.portfolio_print__metric_val.is_theme {\n  color: #f15623;\n}\n\n.portfolio_print__summary,\n.portfolio_print__note {\n  margin: 14px 0 0;\n  font-size: 13px;\n  line-height: 1.65;\n  color: #334155;\n}\n\n.portfolio_print__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.portfolio_print__table th {\n  text-align: left;\n  padding: 10px 12px;\n  background: #002141;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.portfolio_print__table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #1e293b;\n  vertical-align: top;\n}\n\n.portfolio_print__table tbody tr:nth-child(even) td {\n  background: #f8fafc;\n}\n\n.portfolio_print__num {\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n/* Holdings table — minimal report style */\n.portfolio_print__section--holdings {\n  margin-bottom: 32px;\n}\n\n.portfolio_print__holdings_title {\n  margin: 0 0 18px;\n  padding: 0;\n  border: none;\n  font-size: 15px;\n  font-weight: 800;\n  color: #002141;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.portfolio_print__holdings_table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.portfolio_print__holdings_table thead tr {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.portfolio_print__holdings_table th {\n  padding: 10px 0 12px;\n  background: transparent;\n  color: #94a3b8;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  text-align: left;\n  vertical-align: bottom;\n}\n\n.portfolio_print__holdings_th_score,\n.portfolio_print__holdings_score_cell {\n  text-align: right;\n}\n\n.portfolio_print__holdings_table td {\n  padding: 14px 0;\n  border: none;\n  border-bottom: 1px solid #f1f5f9;\n  background: transparent;\n  vertical-align: middle;\n}\n\n.portfolio_print__holdings_table tbody tr:nth-child(even) td {\n  background: transparent;\n}\n\n.portfolio_print__holdings_table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.portfolio_print__holdings_name {\n  color: #002141;\n  font-weight: 500;\n  font-size: 14px;\n  padding-right: 16px;\n}\n\n.portfolio_print__holdings_action {\n  color: #64748b;\n  font-weight: 500;\n  font-size: 13px;\n  padding-right: 16px;\n}\n\n.portfolio_print__holdings_score {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.portfolio_print__holdings_score strong {\n  font-weight: 700;\n  color: #002141;\n  font-size: 14px;\n}\n\n.portfolio_print__holdings_score_suffix {\n  color: #94a3b8;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.portfolio_print__holdings_score_muted {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.portfolio_print__phase_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.portfolio_print__phase_card {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px 14px;\n  background: #ffffff;\n}\n\n.portfolio_print__phase_name {\n  margin: 0 0 10px;\n  font-size: 12px;\n  font-weight: 800;\n  color: #002141;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.portfolio_print__list {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  line-height: 1.55;\n  color: #334155;\n}\n\n.portfolio_print__list li + li {\n  margin-top: 6px;\n}\n\n.portfolio_print__footer_box {\n  padding: 14px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff9f6;\n}\n\n.portfolio_print__foot {\n  margin-top: 32px;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n  font-size: 10px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n@media print {\n  @page {\n    margin: 14mm 12mm;\n    size: A4;\n  }\n\n  body {\n    background: #ffffff !important;\n  }\n\n  .no_print,\n  .portfolio_dashboard__sidebar,\n  .portfolio_dashboard__header_fixed,\n  .portfolio_dashboard__scroll,\n  .portfolio_dashboard__main {\n    display: none !important;\n  }\n\n  .portfolio_print_report {\n    display: block !important;\n    width: 100%;\n    max-width: none;\n    padding: 0;\n    background: #ffffff;\n    color: #0f172a;\n  }\n\n  .portfolio_print__phase_grid,\n  .portfolio_print__metric_grid {\n    break-inside: avoid;\n  }\n\n  .portfolio_print__section {\n    page-break-inside: avoid;\n  }\n\n  .portfolio_print__holdings_table thead tr,\n  .portfolio_print__holdings_table td {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .portfolio_print__holdings_table th {\n    background: transparent !important;\n    color: #94a3b8 !important;\n  }\n\n  .portfolio_print__holdings_table tbody tr:nth-child(even) td {\n    background: transparent !important;\n  }\n}\n\n.portfolio_chart__tooltip_title {\n  fill: #94a3b8;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n\n.portfolio_chart__tooltip_stock {\n  fill: #93c5fd;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.portfolio_chart__tooltip_nifty {\n  fill: #6ee7b7;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.portfolio_chart__empty {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
